const messages = {
  es: {
    translations: {
      courses: {
        close: "Cerrar",
        commentsFeed: "Comentarios de los usuarios",
        feedEmpty: "Aún no hay comentarios.",
        coverLabel: "Imagen de portada (opcional — sin ella usamos la miniatura del video)",
        firstVideo: "Enlace del video de YouTube (opcional)",
        firstVideoHelp: "Crea la primera lección con este video. Puedes agregar más lecciones después.",
        newPrefix: "Nuevo",
        editPrefix: "Editar",
        pageTitleLabel: "Nombre de la página",
        itemLabelLabel: "Nombre del elemento (singular)",
        buttonPreview: "El botón dirá",
        uploadCover: "Subir imagen",
        coverUploaded: "Imagen subida.",
        emptyAdmin: "Nada aún. Haz clic en",
        emptyAdmin2: "para crear el primero.",
        noLessonsAdmin: "Este curso aún no tiene lecciones. Haz clic en \"Nueva lección\" para agregar un video de YouTube, un PDF o texto.",
        noLessonsUser: "Este curso aún no tiene lecciones publicadas.",
        commentsHint: "Deja tu pregunta aquí — el equipo responde aquí mismo.",
        editPage: "Editar nombre y descripción de la página",
        backTo: "Volver a",
        title: "Cursos",
        newCourse: "Nuevo curso",
        editCourse: "Editar curso",
        courseTitle: "Título",
        description: "Descripción",
        coverUrl: "URL de la imagen de portada",
        companies: "Empresas con acceso",
        companiesSelected: "empresa(s)",
        status: "Estado",
        active: "Activo",
        inactive: "Inactivo",
        save: "Guardar",
        cancel: "Cancelar",
        remove: "Eliminar",
        removed: "Curso eliminado.",
        saved: "Curso guardado.",
        removeConfirm: "¿Eliminar este curso y sus lecciones?",
        titleRequired: "Ingrese un título.",
        empty: "Aún no hay cursos disponibles.",
        back: "Volver a los cursos",
        lessons: "Lecciones",
        lessonsShort: "lecciones",
        noLessons: "Aún no hay lecciones.",
        newLesson: "Nueva lección",
        editLesson: "Editar lección",
        lessonTitle: "Título de la lección",
        lessonKind: "Tipo",
        kindVideo: "Video (YouTube)",
        kindPdf: "PDF",
        kindText: "Texto",
        videoUrl: "Enlace de YouTube",
        pdfUrl: "URL del PDF",
        lessonBody: "Texto de apoyo / contenido",
        lessonSaved: "Lección guardada.",
        lessonRemoved: "Lección eliminada.",
        lessonTitleRequired: "Ingrese el título de la lección.",
        removeLessonConfirm: "¿Eliminar esta lección?",
        openPdf: "Abrir PDF",
        badVideo: "Enlace de video inválido.",
        comments: "Comentarios",
        noComments: "Sé el primero en comentar.",
        writeComment: "Escribe un comentario...",
        writeReply: "Escribe una respuesta...",
        reply: "Responder",
        send: "Enviar",
        removeCommentConfirm: "¿Eliminar este comentario?",
        editDesc: "Editar descripción",
        descSaved: "Descripción guardada.",
        descPlaceholder: "Escribe la descripción del área de cursos...",
        noDesc: "Área de cursos y capacitación."
      },
      salesAgents: {
        fieldLabel: "Nombre del campo",
        fieldKey: "Clave",
        fieldType: "Tipo",
        fieldRequired: "Obligatorio",
        addField: "Agregar campo",
        schedulingOn: "Permitir programación",
        meet: "Crear enlace de Meet",
        title: "Agentes Comerciales",
        new: "Nuevo agente",
        name: "Nombre del agente",
        nameRequired: "Ingrese el nombre del agente.",
        prompt: "Prompt de conversación",
        template: "Plantilla inicial",
        identification: "Identificación",
        fields: "Lo que el agente debe descubrir",
        extraction: "Cómo la IA lee la conversación",
        knowledge: "Conocimiento y medios",
        knowledgeUpload: "Subir medios",
        knowledgeEmpty: "Aún no hay medios.",
        knowledgeUploaded: "Medios subidos.",
        knowledgeRemoved: "Elemento eliminado.",
        knowledgeRemoveConfirm: "¿Eliminar este elemento?",
        onQualify: "Al calificar",
        onDisqualify: "Al descalificar",
        scheduling: "Programación",
        tag: "Etiqueta",
        kanban: "Etapa del Kanban",
        queue: "Cola",
        user: "Agente",
        transfer: "Transferir a humano",
        duplicate: "Duplicar",
        duplicated: "Agente duplicado.",
        remove: "Eliminar",
        removed: "Agente eliminado.",
        save: "Guardar",
        saved: "¡Agente guardado!",
        cancel: "Cancelar",
        activeOn: "Activo",
        activeOff: "Pausado",
        none: "Ninguno",
        empty: "Aún no hay agentes comerciales configurados.",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo",
        duration: "Duración (min)"
      },
      agentTemplates: {
        title: "Plantillas de Agente",
        new: "Nueva plantilla",
        label: "Nombre de la plantilla",
        labelRequired: "Ingrese el nombre de la plantilla.",
        description: "Descripción corta",
        scope: "Se aplica a",
        scopeBoth: "Ambos",
        scopeConversation: "Conversación",
        scopeCommercial: "Comercial",
        niche: "Nicho (opcional)",
        promptTitle: "Prompt de conversación",
        extractionTitle: "Instrucciones de extracción (agente comercial)",
        duplicate: "Duplicar",
        duplicated: "Plantilla duplicada.",
        remove: "Eliminar",
        removed: "Plantilla eliminada.",
        removeConfirm: "¿Eliminar esta plantilla?",
        save: "Guardar",
        saved: "¡Plantilla guardada!",
        cancel: "Volver",
        empty: "Aún no hay plantillas.",
        systemLocked: "Plantilla del sistema (solo lectura)"
      },
      whatsappQuality: {
        title: "Calidad del número",
        connection: "Conexión",
        official: "Calidad Meta (API Oficial)",
        notes: "Observaciones",
        checkedAt: "Última consulta",
        refresh: "Actualizar ahora",
        close: "Cerrar",
        empty: "Sin datos."
      },
      geoReport: {
        contactsTitle: "Contactos",
        contactsHelp: "Cada contacto con la ubicación inferida por el número. Usa el filtro para verificar quién cayó en cada región.",
        searchPlaceholder: "Buscar por nombre o número...",
        filterLocation: "Ubicación",
        allLocations: "Todas las ubicaciones",
        noContacts: "Ningún contacto para este filtro.",
        contactName: "Nombre",
        contactNumber: "Número",
        contactState: "Estado",
        contactRegion: "Región",
        contactCountry: "País",
        exportPdf: "Exportar PDF",
        exporting: "Generando...",
        regions: { north: "Norte", northeast: "Nordeste", midwest: "Centro-Oeste", southeast: "Sudeste", south: "Sur" },
        title: "Contactos por Región",
        start: "Inicio",
        end: "Fin",
        filter: "Filtrar",
        totalContacts: "Contactos en el período",
        mapped: "Localizados",
        unmapped: "No identificados",
        byRegion: "Contactos por región",
        inferred: "Distribución inferida por el DDD/DDI del número. Número portado, línea corporativa o fijo antiguo pueden caer en la región equivocada.",
        topStates: "Top estados",
        topStatesHelp: "Los 12 estados con más contactos en el período.",
        noStates: "Ningún contacto brasileño identificado en el período.",
        otherCountries: "Otros países",
        countriesHelp: "Contactos con DDI fuera de Brasil.",
        noInternational: "Ningún contacto internacional detectado."
      },
      utmLinks: {
        newLink: "Nuevo enlace de campaña",
        preview: "Vista previa del enlace",
        previewEmpty: "Elige la conexión o informa el número para ver el enlace.",
        useConnection: "Usar número de una conexión",
        useManual: "Informar número manualmente",
        noConnections: "Ninguna conexión con número disponible.",
        reportMoved: "El informe de anuncios está en Informes → Informe de Anuncios.",
        title: "Enlaces UTM",
        tabs: { links: "Mis enlaces", report: "Informe de anuncios" },
        help: "Crea un enlace por anuncio. El código al final del mensaje es lo que identifica de dónde vino el lead — no lo borres ni lo edites al usar el enlace en el anuncio.",
        reportHelp: "Leads y conversaciones generadas por cada anuncio. El lead se cuenta cuando envía el primer mensaje por el enlace.",
        fields: {
          connection: "Conexión",
          name: "Nombre del enlace", source: "Origen", medium: "Medio",
          campaign: "Campaña", content: "Anuncio / creativo",
          number: "Número de WhatsApp (con código de país)", message: "Mensaje predefinido"
        },
        report: { converted: "Leads convertidos", leads: "Leads", tickets: "Conversaciones", closed: "Cerradas" },
        code: "Código", url: "Enlace del anuncio", actions: "Acciones",
        create: "Crear enlace", copy: "Copiar enlace", copied: "¡Enlace copiado!",
        remove: "Eliminar enlace", removed: "Enlace eliminado.", created: "¡Enlace creado!",
        nameRequired: "Informa el nombre del enlace.",
        numberRequired: "Informa el número de WhatsApp con código de país.",
        emptyLinks: "Aún no hay enlaces creados.",
        emptyReport: "Sin datos en el período."
      },
      leadSource: {
        chipEmpty: "Origen",
        menuTitle: "Selecciona el origen del lead",
        empty: "Ningún origen registrado",
        clear: "Limpiar origen",
        saved: "¡Origen actualizado!",
        label: "Origen del lead",
        none: "Sin origen"
      },
      leadSourceSettings: {
        title: "Origen de los leads",
        description: "Define de dónde vienen tus contactos. El agente elige el origen en el encabezado de la conversación, y aparece en el contacto y en el informe de campañas.",
        name: "Nombre",
        icon: "Icono",
        color: "Color",
        add: "Agregar",
        added: "¡Origen agregado!",
        removed: "Origen eliminado.",
        remove: "Eliminar origen",
        nameRequired: "Informa el nombre del origen.",
        newPlaceholder: "Nuevo origen",
        activeOn: "Activo — visible para el agente",
        activeOff: "Inactivo — oculto para el agente",
        icons: {
          facebook: "Facebook", instagram: "Instagram", messenger: "Messenger",
          google: "Google", tiktok: "TikTok", youtube: "YouTube",
          organic: "Orgánico", referral: "Recomendación", other: "Otro"
        }
      },
      authTabs: {
        login: "Entrar",
        signup: "Registrarse"
      },
      welcome: {
        dontShowAgain: "No volver a mostrar este saludo",
        messages: {
          m1: "Qué bueno tenerte aquí. ¡Buena jornada!",
          m2: "Tu equipo ya te espera. ¿Vamos?",
          m3: "Cada conversación es una oportunidad de encantar a alguien.",
          m4: "Día nuevo, nuevas oportunidades de atender bien.",
          m5: "Café en mano y todo listo para empezar.",
          m6: "Nada como empezar el día con la bandeja ordenada.",
          m7: "Que hoy sea un día ligero y productivo.",
          m8: "Un cliente bien atendido lo recuerda por mucho tiempo.",
          m9: "Qué bueno verte de vuelta. Vamos a lograrlo.",
          m10: "Respira hondo. Una conversación a la vez."
        },
        morning: "¡Buenos días!",
        afternoon: "¡Buenas tardes!",
        evening: "¡Buenas noches!",
        morningWithName: "¡Buenos días, {{name}}!",
        afternoonWithName: "¡Buenas tardes, {{name}}!",
        eveningWithName: "¡Buenas noches, {{name}}!",
        subtitle: "Qué bueno tenerte aquí. ¡Buena jornada!",
        close: "Cerrar"
      },
    voiceIvr: {
      criarDestinos: "Crear transferencia para cada opción",
      destinosCriados: "Transferencias creadas. Elija la fila de cada una.",
      transferindoPara: "Aguarde, le voy a transferir.",
      voz: {
        semVozEscolhida: "Ninguna voz elegida",
        buscarVozes: "Buscar voces",
        escolhaVoz: "Voz",
        modeloPadrao: "Predeterminado del proveedor",
        previa: "Vista previa de la voz",
        informeChave: "Informe primero la clave de la API.",
        nenhumaVoz: "No se encontraron voces en esta cuenta.",
        falhaBusca: "No se pudo consultar al proveedor.",
        comecar: "Pegue la clave de la API y haga clic en Buscar voces para cargar las voces de su cuenta.",
        titulo: "Voz del IVR",
        provedor: "Proveedor de voz",
        padraoServidor: "Voz predeterminada del servidor",
        idDaVoz: "ID de la voz",
        idDaVozAjuda: "Copie el identificador de la voz en el panel del proveedor.",
        chaveApi: "Clave de la API",
        verChave: "Mostrar u ocultar la clave",
        modelo: "Modelo (opcional)",
        ajuda: "Sin elegir proveedor, el IVR usa la voz configurada en el servidor. Piper funciona en su propia máquina, sin costo por uso.",
        avisoChave: "La clave se guarda junto con este IVR, en el servidor de voz. Use una clave exclusiva, con límite de uso, para poder revocarla sin afectar lo demás.",
        provedores: {
          piper: "Piper (en su servidor)",
          elevenlabs: "ElevenLabs",
          openai: "OpenAI",
        },
      },
      titulo: "Constructor de IVR",
      nova: "Nuevo IVR",
      novaModelo: "Empezar con una plantilla lista",
      novaVazia: "Empezar desde cero",
      editando: "Editando IVR",
      editar: "Editar",
      excluir: "Eliminar",
      voltar: "Volver",
      salvar: "Guardar",
      salva: "IVR guardado.",
      excluida: "IVR eliminado.",
      ativa: "Activo",
      inativa: "Inactivo",
      passo: "Paso",
      semUras: "Aún no hay ningún IVR creado.",
      semUrasDica: "Cree uno para que las llamadas entrantes se atiendan automáticamente.",
      explicacao: "Arme la atención automática de las llamadas. Después de guardar, vaya a Conexiones y elija este IVR en el campo de atención por voz.",
      comoFunciona: "Los pasos se ejecutan de arriba hacia abajo. Solo el menú se desvía: cada opción lleva al paso que usted elija.",
      confirmarExclusao: "¿Eliminar este IVR?",
      confirmarExclusaoTexto: "Las conexiones que usan este IVR volverán a sonar directamente al agente.",
      naoEditavel: "Esta IVR fue creada en un formato antiguo y no puede abrirse en este editor. Cree una nueva IVR con los pasos deseados.",
      adicionarPasso: "Agregar paso",
      removerPasso: "Quitar paso",
      subir: "Mover arriba",
      descer: "Mover abajo",
      adicionarOpcao: "Agregar opción",
      removerOpcao: "Quitar opción",
      seguirOrdem: "Seguir al siguiente paso",
      primeiroPasso: "Comienza en",
      corrijaAntes: "Corrija antes de guardar:",
      nenhuma: "Ninguna",
      qualquer: "Cualquiera de la fila",
      colunas: {
        nome: "Nombre",
        situacao: "Estado",
        acoes: "Acciones",
      },
      tipos: {
        message: "Reproducir mensaje",
        voice_menu: "Menú de opciones",
        dtmf_capture: "Pedir dígitos",
        record_audio: "Grabar un mensaje",
        transfer: "Transferir a un agente",
        end: "Finalizar llamada",
      },
      campos: {
        nome: "Nombre del IVR",
        ativa: "IVR activo",
        tipo: "Tipo de paso",
        falar: "Lo que dirá el IVR",
        falarAjuda: "Este texto se lee en voz alta a quien llamó.",
        menuFala: "Texto del menú",
        menuFalaAjuda: "Diga las opciones en voz alta. Ej.: para Ventas, marque 1.",
        opcoes: "Opciones",
        tecla: "Tecla",
        rotulo: "Nombre de la opción",
        irPara: "Ir a",
        teclaDica: "Use teclas de un dígito (1 a 9). Así el IVR reconoce el tono al instante, sin esperar. Quien llama también puede decir el nombre de la opción.",
        tempo: "Tiempo de espera (s)",
        seNaoResponder: "Si no responde",
        seNaoEntender: "Si no entiende",
        pedirDigitos: "Qué pedir",
        pedirDigitosAjuda: "Ej.: marque su número de documento y finalice con la tecla numeral.",
        maxDigitos: "Máximo de dígitos",
        guardarEm: "Guardar como",
        guardarEmAjuda: "Use {{nombre}} en los textos siguientes",
        segundos: "Duración máxima (s)",
        gravarAjuda: "Agregue un paso de mensaje antes de este para que la persona sepa que puede empezar.",
        avisoTransferencia: "Aviso antes de transferir",
        avisoTransferenciaAjuda: "Opcional. Ej.: aguarde, le voy a transferir.",
        fila: "Fila",
        atendente: "Agente",
        transferirAjuda: "El IVR termina aquí: la llamada pasa a la atención humana.",
        despedida: "Mensaje de despedida",
        despedidaAjuda: "La llamada se finaliza después de este mensaje.",
      },
      erros: {
        nomeObrigatorio: "Dele un nombre al IVR.",
        semPassos: "Agregue al menos un paso.",
        falaVazia: "Escriba lo que dirá el IVR.",
        semOpcoes: "El menú necesita al menos una opción.",
        teclaRepetida: "Hay dos opciones con la misma tecla.",
        semDestino: "Elija una fila o un agente para la transferencia.",
      },
      title: "IVR de voz (WhatsApp Plus)",
      desc: "Flujo que atiende la llamada antes del agente. El cliente escucha el menú y elige con el teclado.",
      none: "Sin IVR — suena directo al agente",
      inactive: "(desactivado)",
      empty: "Ningún flujo de voz registrado. Cree uno en Automatizaciones y vuelva aquí para vincularlo."
    },
    ramais: {
      title: "Extensiones internas",
      dial: "Marcar extensión",
      call: "Llamar",
      callVoice: "Llamar (voz)",
      callVideo: "Llamar (video)",
      empty: "Ninguna extensión registrada. Defina la extensión en el registro de cada usuario.",
      extension: "ext.",
      available: "Disponible",
      onCall: "En llamada",
      offline: "Desconectado",
      incoming: "Llamada entrante",
      calling: "Llamando...",
      inCall: "En llamada",
      answer: "Contestar",
      reject: "Rechazar",
      hangup: "Colgar",
      mute: "Silenciar",
      unmute: "Reactivar sonido",
      transfer: "Transferir",
      transferTooltip: "Transferir esta llamada",
      close: "Cerrar",
      transferredCall: "Llamada transferida",
      transferTitle: "Transferencia de llamada",
      transferFrom: "{{name}} quiere transferirle una llamada.",
      accept: "Aceptar",
      noCameraLocal: "Sin cámara aquí — verá y escuchará, pero solo enviará voz.",
      noCameraAnswer: "Sin cámara aquí — verá a la otra persona y solo enviará voz.",
      noCameraRemote: "La otra persona no tiene cámara — solo escuchará su voz.",
      toasts: {
        busy: "Extensión ocupada en este momento.",
        notFound: "Extensión no encontrada.",
        self: "No puede llamar a su propia extensión.",
        failed: "No se pudo completar la llamada.",
        connectFailed: "Error al conectar la llamada.",
        alreadyInCall: "Ya está en una llamada.",
        startFailed: "No se pudo iniciar la llamada.",
        answerFailed: "No se pudo contestar.",
        lost: "Llamada finalizada (conexión perdida).",
        transferOffered: "Transferencia ofrecida a {{name}}."
      }
    },
    officialCall: {
      title: "Llamada por WhatsApp Oficial",
      connection: "Conexión",
      number: "Número con código de área",
      numberPlaceholder: "5511999999999",
      permissionHint: "Para llamar, el cliente debe haber autorizado recibir llamadas. Sin eso, Meta rechaza la llamada.",
      noConnection: "Ninguna conexión oficial conectada. Las llamadas solo funcionan en conexiones WhatsApp Oficial.",
      incoming: "Llamada entrante",
      calling: "Llamando...",
      connecting: "Conectando...",
      inCall: "En llamada",
      answer: "Contestar",
      reject: "Rechazar",
      hangup: "Colgar",
      mute: "Silenciar",
      unmute: "Reactivar sonido",
      call: "Llamar",
      close: "Cerrar",
      tooltip: "Llamar por WhatsApp Oficial",
      toasts: {
        noSdp: "La llamada llegó sin datos de audio. Pida que llamen de nuevo.",
        typeNumber: "Escriba el número con código de área.",
        chooseConnection: "Elija la conexión oficial.",
        alreadyInCall: "Ya está en una llamada.",
        answerFailed: "No se pudo contestar.",
        startFailed: "No se pudo iniciar la llamada.",
        failed: "No se pudo completar la llamada.",
        lost: "Llamada finalizada (conexión perdida).",
        rejected: "Llamada rechazada.",
        missed: "Llamada no contestada.",
        callFailed: "La llamada falló."
      }
    },
    groupGreeting: {
      cardTitle: "Saludo de bienvenida",
      cardDesc: "Mensaje automático para quien entre al grupo",
      dialogTitle: "Saludo de bienvenida",
      intro: "Enviado automáticamente cuando alguien entra en",
      introScope: "La configuración vale solo para este grupo en esta conexión.",
      enable: "Activar saludo en este grupo",
      whereToSend: "Dónde enviar",
      inGroup: "En el grupo, mencionando a quien entró",
      inPrivate: "En privado al nuevo miembro",
      privateWarning: "Quien nunca habló con este número puede no recibir el mensaje privado — WhatsApp bloquea envíos a desconocidos.",
      message: "Mensaje",
      messagePlaceholder: "Ej.: {{saudacao}}, {{primeiro_nome}}! Bienvenido(a) a {{grupo}}.",
      variablesHint: "Haga clic para insertar una variable:",
      preview: "Ver vista previa",
      previewTitle: "Vista previa (con datos de ejemplo)",
      save: "Guardar",
      toasts: {
        loadError: "No se pudo cargar el saludo de este grupo.",
        saved: "Saludo guardado.",
        saveError: "No se pudo guardar el saludo.",
        previewError: "No se pudo generar la vista previa."
      }
    },
      googleSettings: {
        navTitle: 'Google',
        navSubtitle: 'Inicio de sesión y credenciales',
        title: 'Google (Inicio de sesión y Calendario)',
        subtitle: 'Credenciales OAuth de Google para inicio de sesión social e integración con Google Calendar.',
        whereToGet: 'Google Cloud Console → APIs & Services → Credentials',
        loginSection: 'Inicio de sesión con Google (OAuth)',
        clientId: 'Google Client ID',
        clientSecret: 'Google Client Secret',
        calendarSection: 'Google Calendar',
        calendarClientId: 'Client ID de Google Calendar',
        calendarClientSecret: 'Client Secret de Google Calendar',
        hint: 'Consejo: puede usar el mismo OAuth Client para el inicio de sesión y el Calendario, siempre que el alcance de Calendar esté habilitado.',
        save: 'Guardar',
        saved: 'Credenciales de Google guardadas correctamente.',
        saveError: 'Error al guardar las credenciales de Google.'
      },
      voiceCampaign: {
        enable: 'Campaña de voz (llama al contacto y reproduce un audio)',
        audioTitle: 'Audio de la llamada',
        record: 'Grabar',
        stop: 'Detener',
        upload: 'Subir archivo',
        remove: 'Quitar audio',
        savedAudio: 'Audio guardado',
        hint: 'Grabe con el micrófono o suba un archivo de audio.',
        ringSeconds: 'Tiempo de timbre (s)',
        ringSecondsHelp: 'Tiempo hasta considerarla no atendida',
        attempts: 'Intentos',
        attemptsHelp: 'Llamadas por contacto',
        sendText: 'Enviar un mensaje de texto justo después de la llamada',
        sendTextHelp: 'El mensaje es el configurado en la etapa "Mensaje", con variables y adjunto. Desactive arriba para hacer solo la llamada, sin texto.',
        retryMinutes: 'Intervalo entre intentos (min)',
        retryMinutesHelp: 'Espera antes de volver a llamar',
        errors: {
          noRecorder: 'Este navegador no permite grabar audio. Suba un archivo.',
          noMic: 'No se pudo acceder al micrófono. Verifique el permiso del navegador.',
          recordFailed: 'Error al iniciar la grabación.'
        }
      },
      sipSettings: {
        title: 'Troncal SIP',
        navSubtitle: 'Llamada vía SIP',
        subtitle: 'Llamar/recibir por una línea SIP (Asterisk, FreePBX, operador VoIP) independiente de WhatsApp. Después de guardar, usa la pestaña "Vía SIP" en el marcador de WhatsApp Plus.',
        warning: 'Requiere el servicio de troncal SIP instalado en el servidor — ya se instala automáticamente en la instalación/actualización del sistema. Si el chip de abajo muestra "SIP desconectado", ejecuta instalador → Herramientas → Instalar troncal SIP manualmente. Después de cambiar host/usuario/contraseña, puede ser necesario reiniciar el servicio manualmente para que la nueva cuenta sea leída.',
        connected: 'SIP conectado',
        disconnected: 'SIP desconectado',
        trunkEnabled: 'troncal habilitada',
        trunkDisabled: 'troncal deshabilitada',
        enableTrunk: 'Habilitar troncal SIP',
        host: 'Servidor (host)',
        port: 'Puerto',
        username: 'Usuario',
        usernamePlaceholder: 'ramal o usuario de la troncal',
        passwordFilled: 'Contraseña (guardada — deja en blanco para mantener)',
        password: 'Contraseña',
        domain: 'Dominio SIP',
        domainPlaceholder: 'deja en blanco para usar el host',
        domainHelp: 'Completa solo si el dominio SIP es diferente del host/IP de la troncal.',
        transport: 'Transporte',
        callerId: 'Caller ID',
        optional: 'opcional',
        save: 'Guardar',
        testCallHelp: 'Llamada de prueba: después de guardar y con el servicio SIP corriendo, abre el marcador de WhatsApp Plus, selecciona "Vía SIP" y marca un número/anexo conocido de tu PBX.',
        saved: 'Configuración de la troncal SIP guardada.',
        saveError: 'No fue posible guardar la troncal SIP.',
      },
      callModal: {
        contact: 'Contacto',
        incoming: 'Llamada entrante',
        calling: 'Llamando...',
        inProgress: 'Llamada en curso',
        finished: 'Llamada finalizada',
        ended: 'Finalizada',
      },
      dialer: {
        canais: {
          ramal: "Extensión",
          whatsapp: "WhatsApp Plus",
          oficial: "API Oficial",
          sip: "SIP",
        },
        semCanais: "Ningún canal de llamadas configurado. Hable con el administrador.",
        ramalPlaceholder: "Número de extensión",
        title: 'Marcador',
        recent: 'Recientes',
        viaWhatsapp: 'Vía WhatsApp',
        viaSip: 'Vía SIP',
        noWhatsappConnected: 'Ningún WhatsApp conectado.',
        sipWarning: 'Llamada vía troncal SIP (independiente de WhatsApp). Configura la troncal en Configuración → Troncal SIP.',
        sipNumberPlaceholder: 'Número/anexo SIP',
        numberPlaceholder: 'Número',
        audioOnly: 'Solo audio',
        videoCall: 'Videollamada',
        call: 'Llamar',
        noRecentCalls: 'Sin llamadas recientes',
        dialFailed: 'Error al marcar',
      },
    schedulesHeader: {
      title: "Programación de mensajes",
      subtitle: "Programa y visualiza envíos automáticos y recordatorios en un calendario interactivo",
      programmed: "Envíos programados",
      schedulesWord: "agendamientos",
      cardTotal: "Total programados",
      cardTotalHint: "Envíos registrados en el sistema",
      cardToday: "Programados para hoy",
      cardTodayHint: "Envíos previstos para el día",
      cardWeek: "Próximos 7 días",
      cardWeekHint: "Previsión de la semana",
      cardPending: "Pendientes de envío",
      cardPendingHint: "Esperando el horario de envío",
      googleCalendar: "Google Calendar",
      newSchedule: "Nuevo agendamiento",
    },
    scheduleGoogle: {
      connectAccount: "Conectar cuenta",
      notConnectedHint: "Ninguna cuenta de Google conectada. Conecta una para sincronizar este agendamiento y generar el enlace de Meet.",
      title: "Integración Google Calendar & Meet",
      connectedAs: "Conectado:",
      syncCalendar: "Sincronizar en Google Calendar",
      generateMeet: "Generar enlace de Google Meet",
      eventTitle: "Título de la reunión / Asunto",
      eventTitlePlaceholder: "Ej.: Reunión con el cliente",
      duration: "Duración",
      minutes: "minutos",
      hour: "hora",
      hours: "horas",
      copyLink: "Copiar enlace",
      copied: "¡Copiado!",
      openMeet: "Abrir Meet",
    },
      googleCalendar: {
        errors: {
          credentialsMissing: "Google Calendar aún no está habilitado en esta plataforma. Pide al administrador que registre el Client ID y el Client Secret de Google.",
          redirectMissing: "No se pudo identificar la dirección del servidor para el retorno de Google. Avisa al administrador.",
        },
        step1: "1. Credenciales de la API de Google (OAuth 2.0)",
        step1Sub: "Configura tu Client ID y Client Secret generados en Google Cloud Console",
        clientId: "Google Client ID",
        clientSecret: "Google Client Secret",
        redirectUri: "URI de redirección autorizada (pégala en Google Cloud)",
        jsOrigin: "Origen JavaScript autorizado (pégalo en Google Cloud)",
        saveCredentials: "Guardar credenciales de la API",
        credentialsSaved: "Credenciales guardadas.",
        credentialsFail: "No se pudieron guardar las credenciales.",
        copied: "¡Copiado!",
        howToTitle: "Paso a paso: cómo generar el Client ID y el Client Secret en Google Cloud (2 minutos)",
        how1: "Entra en console.cloud.google.com y crea (o elige) un proyecto.",
        how2: "En APIs y servicios → Biblioteca, activa la Google Calendar API.",
        how3: "En Pantalla de consentimiento OAuth, configúrala como Externa y publícala.",
        how4: "En Credenciales → Crear credenciales → ID de cliente de OAuth, elige Aplicación web.",
        how5: "Pega los dos valores de arriba en los campos de orígenes y URIs de redirección autorizados.",
        how6: "Copia el Client ID y el Client Secret generados y pégalos arriba.",
        step2: "2. Conexión de la cuenta de Google",
        step2Sub: "Conecta la cuenta que gestionará las reuniones y Meet",
        connectionStatus: "ESTADO DE LA CONEXIÓN",
        connectedAccount: "CUENTA CONECTADA",
        disconnectAccount: "Desconectar cuenta",
        openCalendar: "Abrir Google Calendar",
        prefsTitle: "Preferencias de Google Meet y agendamientos",
        prefsSubtitle: "Define cómo se crearán los eventos y reuniones",
        autoMeet: "Generar Google Meet automáticamente",
        autoMeetHelp: "Crea un enlace de videollamada exclusivo en cada agendamiento",
        syncEvents: "Sincronizar eventos en Google Calendar",
        syncEventsHelp: "Inserta los agendamientos en tu calendario de Google",
        sendInvite: "Enviar invitación por correo al cliente",
        sendInviteHelp: "Google enviará una invitación automática si el contacto tiene correo registrado",
        menu: "Google Calendar",
        title: "Integración con Google Calendar",
        subtitle: "Conecta una cuenta de Google para permitir que FlowBuilder cree eventos automáticos en el calendario durante las atenciones.",
        notConnected: "Ninguna cuenta de Google conectada para esta empresa.",
        connect: "Conectar Google Calendar",
        connectedAs: "Conectado",
        disconnect: "Desconectar",
        defaultCalendar: "Calendario predeterminado",
        primary: "primary (predeterminado)",
        main: "principal",
        defaultDuration: "Duración predeterminada (minutos)",
        timezone: "Zona horaria",
        timezoneHelp: "Ej.: America/Sao_Paulo",
        save: "Guardar configuración",
        saving: "Guardando...",
        confirmDisconnect: "¿Desconectar Google Calendar?",
        toast: {
          connected: "¡Google Calendar conectado!",
          connectFail: "Error al conectar: ",
          unknownError: "error desconocido",
          authUrlError: "Error al generar la URL de autorización.",
          disconnected: "Desconectado.",
          disconnectError: "Error al desconectar.",
          saved: "Configuración guardada.",
          saveError: "Error al guardar.",
        },
      },
      flowPage: {
        noDescription: "Sin descripción",
        trigger: "Disparador",
        noKeywords: "Ninguna palabra clave configurada",
        executions: "ejecuciones",
        node: "nodo",
        nodes: "nodos",
        successRate: "Tasa de éxito",
        updated: "Actualizado",
        tooltipEdit: "Editar flujo",
        tooltipActivate: "Activar flujo",
        tooltipDeactivate: "Desactivar flujo",
        triggerTypes: {
          keyword: "Palabra clave",
          anyMessage: "Cualquier mensaje",
          firstContact: "Primer contacto",
          outOfHours: "Fuera de horario",
          regex: "Expresión regular (Regex)",
          integration: "Integración / Webhook",
          manual: "Manual (disparo vía API)",
        },
        menu: {
          edit: "Editar",
          report: "Informe",
          duplicate: "Duplicar",
          export: "Exportar",
          delete: "Eliminar",
        },
      },
      flowFormModal: {
        description: "Descripción",
        triggerType: "Tipo de Disparador",
        keywords: "Palabras clave",
        keywordsPlaceholder: "Escriba y presione Enter o coma",
        keywordsHelper: "Agregue varias palabras. Presione Enter, Tab o coma para confirmar cada una.",
        regexPattern: "Patrón Regex",
        regexPatternPlaceholder: "Ej: ^pedido\\\\s+\\\\d+$",
        regexHelper: "Expresión regular JavaScript. El flujo dispara si el mensaje coincide.",
        regexFlags: "Flags",
        regexFlagsPlaceholder: "Ej: i",
        webhookUrl: "URL del Webhook",
        webhookUrlPlaceholder: "https://...",
        webhookHelper: "URL externa que disparará el flujo vía POST.",
        integrationId: "ID de integración (opcional)",
        manualToken: "Token de la API",
        manualTokenHelper: "Use este token al llamar POST /api/flowbuilder/trigger para disparar el flujo.",
        manualEndpoint: "Endpoint",
        copy: "Copiar",
        generateToken: "Generar token",
        anyMessageHelper: "El flujo dispara con cualquier mensaje recibido. No requiere configuración.",
        firstContactHelper: "El flujo dispara solo en la primera interacción del contacto. No requiere configuración.",
        outOfHoursHelper: "El flujo dispara cuando el mensaje llega fuera del horario de atención configurado en la empresa.",
      },
      flowReport: {
        title: "Informe del Flujo",
        executions: "Ejecuciones",
        completion: "Finalización",
        clickRate: "Tasa de clic",
        avgNodes: "Promedio de nodos",
        interactionRate: "Tasa de interacción",
        started: "Iniciaron",
        interacted: "Interactuaron",
        completed: "Completaron",
        completionRate: "Tasa de finalización",
        close: "CERRAR",
      },
      common: {
        loading: "Cargando...",
      },
      integrationNode: {
        loading: "Cargando...",
        loadingIntegrations: "Cargando integraciones...",
        available: "{{count}} integración(es) disponible(s)",
        select: "Seleccionar...",
        empty: "Ninguna integración encontrada",
        emptyTypebot: "Ninguna integración Typebot registrada.",
        emptyN8n: "Ninguna integración n8n registrada.",
        emptyGeneric: "Ninguna integración registrada. Créala en Integraciones > Colas.",
        advanced: "Configuración avanzada",
        drawerTitle: "Configuración avanzada",
        tabGeneral: "General",
        tabExecution: "Ejecución",
        tabVariables: "Variables",
        tabFallback: "Respaldo",
        nodeName: "Nombre del nodo",
        beforeMsg: "Mensaje antes de disparar",
        afterMsg: "Mensaje después de ejecutar",
        continueFlow: "Continuar el flujo después de la integración",
        timeout: "Tiempo de espera (segundos)",
        retries: "Reintentos en caso de fallo",
        retryDelay: "Intervalo entre reintentos (ms)",
        async: "Modo asíncrono (no esperar respuesta)",
        varsSend: "Variables enviadas",
        responseVar: "Guardar respuesta en variable",
        urlOverride: "URL del webhook (override)",
        method: "Método HTTP",
        headers: "Cabeceras personalizadas",
        bodyExtra: "Body extra (JSON)",
        fallbackMsg: "Mensaje en caso de fallo",
        transferOnFail: "Transferir ticket en caso de fallo",
        transferQueueId: "ID de la cola de transferencia",
        transferUserId: "ID del usuario de transferencia",
        add: "Agregar",
        emptyKV: "Sin elementos.",
        save: "Guardar",
        cancel: "Cancelar",
      },
      adsReport: {
        sourceTitle: "Origen de los leads",
        charts: { funnel: "Embudo de leads", byStatus: "Distribución por estado", topAds: "Top anuncios por leads" , bySource: "Por origen del lead" },
        utmTitle: "Enlaces UTM",
        title: "Informe de Anuncios",
        startDate: "Inicio",
        endDate: "Fin",
        status: "Estado",
        search: "Buscar (teléfono, anuncio, ctwa_clid)",
        filter: "Filtrar",
        export: "Exportar",
        statusOptions: {
          all: "Todos",
          new: "Nuevo",
          contact: "En atención",
          qualified: "Calificado",
          purchase: "Venta",
          lost: "Perdido",
        },
        kpis: {
          total: "Total",
          new: "Nuevos",
          contact: "En atención",
          qualified: "Calificados",
          purchase: "Ventas",
          lost: "Perdidos",
        },
        performanceTitle: "Rendimiento por anuncio",
        leadsTitle: "Leads",
        columns: {
          ad: "Anuncio",
          id: "ID",
          leads: "Leads",
          sales: "Ventas",
          conv: "Conv. %",
          date: "Fecha",
          contact: "Contacto",
          phone: "Teléfono",
          origin: "Origen",
          channel: "Canal",
          status: "Estado",
          capi: "CAPI",
        },
        empty: {
          ads: "Ningún anuncio capturado en el período.",
          leads: "Ningún lead encontrado.",
        },
        capiTooltip: "Enviado {{when}}",
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas rápidas",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        noPhone: "No hay teléfono disponible para copiar",
        copyError: "Error al copiar el teléfono",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          disabled:
            "El registro de usuarios está deshabilitado en este momento. Por favor, inténtalo más tarde.",
          fail: "Error creando el usuario. Verifica los datos informados.",
          codeSent: "¡Código de verificación enviado a tu correo!",
          codeResent: "¡Nuevo código enviado!"
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "WhatsApp (CÓDIGO + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        plan: {
          title: "Elige tu plan",
          subtitle: "Selecciona el plan ideal para tu empresa",
          badge: "Ideal para tu empresa",
          period: "mes",
          meta: "Hasta {{users}} usuarios · Hasta {{connections}} conexiones"
        },
        formStep: {
          title: "Crea tu cuenta",
          subtitle: "Completa los datos de tu empresa"
        },
        verify: {
          title: "Verificación de correo",
          subtitle: "Ingresa el código de 6 dígitos enviado a",
          confirm: "Verificar y Crear Cuenta",
          sending: "Enviando...",
          resend: "Reenviar código",
          resendIn: "Reenviar en"
        },
        actions: {
          continue: "Continuar",
          back: "Volver",
          hasAccount: "¿Ya tienes una cuenta?",
          enter: "Entrar"
        },
        document: {
          label: "CPF / CNPJ / Documento (opcional)",
          cpfValid: "¡CPF válido!",
          cnpjValid: "¡CNPJ válido! Nombre de la empresa completado automáticamente.",
          invalid: "Documento inválido.",
          error: "Error al validar el documento."
        },
        validation: {
          required: "Campo obligatorio",
          nameMin: "El nombre debe tener al menos 2 caracteres",
          nameMax: "El nombre debe tener como máximo 50 caracteres",
          companyMin: "La empresa debe tener al menos 2 caracteres",
          companyMax: "La empresa debe tener como máximo 50 caracteres",
          passwordMin: "La contraseña debe tener al menos 5 caracteres",
          passwordMax: "La contraseña debe tener como máximo 50 caracteres",
          invalidEmail: "Correo inválido",
          codeLength: "Ingresa el código completo de 6 dígitos."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "Campañas",
          schedules: "Agendamientos",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          integrations: "Integraciones",
          openAi: "OpenAI",
          kanban: "Kanban"
        }
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        forgotPassword: "¿Olvidaste tu contraseña?",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
        footer: "Todos los derechos reservados.",
      },
      forgotPassword: {
        title: "Recuperar acceso",
        subtitleLine1: "Informa el correo vinculado a tu cuenta.",
        subtitleLine2: "Te enviaremos un código de verificación.",
        email: "Correo Electrónico",
        placeholder: "tu.correo@ejemplo.com",
        sending: "Enviando...",
        send: "Enviar Código",
        back: "Volver al login",
        toasts: {
          requiredEmail: "Ingresa tu correo",
          success: "Si el correo está registrado, se enviará un código.",
          error: "Error al enviar el código. Verifica si SMTP está configurado en ajustes."
        }
      },
      validateCode: {
        title: "Verifica tu correo",
        subtitle: "Enviamos un código de 6 dígitos a",
        label: "Código de Verificación",
        submitting: "Validando...",
        submit: "Verificar Código",
        resendPrompt: "¿No lo recibiste? Reenviar código",
        back: "Volver",
        toasts: {
          incomplete: "Ingresa el código completo de 6 dígitos",
          success: "¡Código validado con éxito!",
          error: "Código inválido o expirado. Inténtalo nuevamente.",
          resent: "¡Nuevo código enviado!",
          resentError: "Error al reenviar el código."
        }
      },
      resetPassword: {
        title: "Crear nueva contraseña",
        subtitleLine1: "Elige una contraseña segura para",
        subtitleLine2: "proteger tu cuenta.",
        newPassword: "Nueva Contraseña",
        confirmPassword: "Confirmar Contraseña",
        passwordPlaceholder: "Ingresa tu nueva contraseña",
        confirmPlaceholder: "Repite la nueva contraseña",
        minHint: "Mínimo 6 caracteres",
        submitting: "Guardando...",
        submit: "Restablecer Contraseña",
        successTitle: "¡Contraseña restablecida con éxito!",
        successSubtitle: "Redirigiendo al login...",
        toasts: {
          minLength: "La contraseña debe tener al menos 6 caracteres",
          mismatch: "Las contraseñas no coinciden",
          success: "¡Contraseña restablecida con éxito!",
          error: "Error al restablecer la contraseña. Token inválido o expirado."
        }
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Empresa",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta empresa? Todos los datos relacionados se perderán. Esta acción no se puede deshacer.",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
          warning: "Su suscripción vence en {{days}} {{unit}}",
          expired: "¡Su suscripción venció el {{date}}! Contacte al Soporte para más información.",
        },
        token: "Token",
      },
      dashboard: {
        subtitle: "Visión general de los indicadores de atención",
        fetchError: "Error al cargar los datos del dashboard",
        hideFilters: "Ocultar Filtros",
        filters: "Filtros",
        filter: "FILTRAR ",
        npsTitle: "Encuesta de Satisfacción (NPS)",
        calls: "Atenciones",
        analytics: {
          title: "Análisis",
          ticketVolume: "Volumen de Tickets",
          lastDays: "Últimos {{days}} días",
          noData: "Sin datos",
          ticketStatus: "Estado de los Tickets",
          distributionByStatus: "Distribución por estado",
          noTickets: "Sin tickets",
          conversationMetrics: "Métricas de Conversaciones",
          activeContacts: "Contactos Activos",
          ticketsPerContact: "Tickets/Contacto",
          days: "días",
          ratingRate: "Tasa de Evaluación",
          hourlyActivity: "Actividad por Hora",
          less: "Menos",
          more: "Más",
          topContacts: "Top Contactos",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        subtitle: "Visualice y exporte datos de atención",
        protocol: "Protocolo",
        protocolPlaceholder: "Ej.: 20260526000123",
        serviceProtocol: "Protocolo de atención",
        copyProtocol: "Copiar protocolo",
        saleValue: "Valor de Venta",
        noSaleReason: "Motivo de No Venta",
        closedWithSale: "Finalizado con Venta",
        yes: "Sí",
        no: "No",
        ticketLogs: "Logs del Ticket",
        accessTicket: "Acceder al Ticket",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
            valorVenda: "Valor de Venta",
            motivoNaoVenda: "Motivo de No Venta",
            finalizadoComVenda: "Finalizado con Venta",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
        startDate: "Fecha Inicial",
        endDate: "Fecha Final",
        searchPlaceholder: "Buscar...",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha Apertura",
          dateClose: "Fecha Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        openContact: "Abrir ficha del contacto",
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        default: "Predeterminado",
        shareLink: "Enlace para compartir",
        copy: "Copiar",
        linkCopied: "¡Enlace copiado!",
        stats: { last7days: "Últimos 7 días", sent: "Enviadas", received: "Recibidas", noData: "Sin mensajes en el período" },
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        searchPlaceholder: "Buscar por nombre, ID o número...",
        status: "Estado",
        statusAll: "Todos",
        statusConnected: "Conectado",
        statusDisconnected: "Desconectado",
        statusOpening: "Conectando",
        statusQrcode: "Código QR",
        statusPairing: "Emparejando",
        clearFilters: "Limpiar filtros",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        integrity: "Integridad",
        stable: "Estable",
        unstable: "Inestable",
        statusConnected: "Conectado",
        statusDisconnected: "Desconectado",
        statusOpening: "Conectando",
        statusQrcode: "QR Code",
        statusPairing: "Emparejando",
        active: "Activo",
        inactive: "Inactivo",
        updatedAt: "Actualizado",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        toasts: {
          reconnecting: "Reconectando... espera unos segundos.",
          activate: "Activar agente",
          deactivate: "Desactivar agente",
          activated: "Agente activado",
          deactivated: "Agente desactivado",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
          importHistory: "Importar mensajes anteriores",
          importingHistory: "Importando mensajes...",
          importHistorySuccess: "Importación iniciada — las conversaciones antiguas irán apareciendo poco a poco.",
          importHistoryPeriodTitle: "Período de importación",
          importHistoryPeriodHint: "Elija el período de mensajes a importar (opcional — déjelo en blanco para importar todo el lote reciente).",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Color",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          label: "Recibir Comentarios",
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se están recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se están recibiendo. Haga clic para habilitar.",
          },
        },
        transfer: {
          title: "Transferencia de Tickets",
          description: "Seleccione la conexión de origen y la de destino. Todos los atendimientos activos serán movidos.",
          source: "Origen",
          target: "Destino",
          cancel: "Cancelar",
          transfer: "Transferir",
          transferTickets: "Transferir Tickets",
          transferring: "Transfiriendo Tickets",
          of: "de",
          waitMessage: "Espere mientras los tickets se transfieren...",
          selectConnections: "Seleccione las conexiones de origen y destino",
          differentConnections: "Las conexiones de origen y destino deben ser diferentes",
          success: "¡Tickets transferidos con éxito! {{count}} tickets transferidos.",
        },
        preDelete: {
          title: "Antes de eliminar",
          message: "¿Ya transfirió los tickets de esta conexión a otra? Si no, recomendamos transferir antes de eliminar.",
          notYet: "Aún no",
          yesTransferred: "Sí, ya transferí",
        },
        importMessages: {
          title: "Importar Mensajes",
          button: "Importar Mensajes",
          connection: "Conexión",
          selectConnection: "Seleccione una conexión Z-API",
          startDate: "Fecha de Inicio",
          endDate: "Fecha de Fin",
          messageType: "Tipo de Mensaje",
          all: "Todos",
          individual: "Individual",
          group: "Grupo",
          ticketStatus: "Estado del Ticket",
          open: "Abierto",
          pending: "Pendiente",
          closed: "Cerrado",
          queue: "Cola",
          noQueue: "Sin cola",
          import: "Importar",
          cancel: "Cancelar",
          importing: "Importando mensajes...",
          importingDescription: "Espere mientras se importan los mensajes. Esto puede tardar unos minutos.",
          success: "¡Importación completada! {{messages}} mensajes, {{tickets}} tickets, {{contacts}} contactos importados.",
          noZApiConnections: "No se encontraron conexiones Z-API.",
          noConnections: "No se encontraron conexiones WhatsApp conectadas.",
          errorMissingFields: "Complete todos los campos obligatorios.",
        },
        nativeImport: {
          importing: "Importando mensajes de WhatsApp...",
          finishing: "Finalizando importación...",
          processed: "Procesados",
          messages: "mensajes",
          currentDate: "Fecha actual",
          errors: "errores",
          cancelled: "Importación cancelada",
          cancel: "Cancelar",
        },
        importProgress: {
          done: "¡Importación completada!",
          cancelled: "Importación cancelada",
          importing: "Importando mensajes...",
          starting: "Conectando...",
          scanning: "Buscando chats...",
          processingChat: "Procesando chat {{current}} de {{total}}",
          allProcessed: "Todos los chats fueron procesados",
          cancelledAt: "Detenido en {{current}} de {{total}} chats",
          initializing: "Iniciando...",
          progress: "Progreso",
          chats: "chats",
          messagesLabel: "Mensajes",
          tickets: "Tickets",
          contacts: "Contactos",
          errorsLabel: "Errores",
          cancelImport: "Cancelar Importación",
          close: "Cerrar",
        },
        officialLabel: "Oficial",
        badges: {
          pairingCode: "Conectado vía Código de Emparejamiento",
          qrCode: "Conectado vía QR Code",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
        close: "Cerrar",
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        close: "Cerrar",
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "inició la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
          chatbot: "Chatbot",
          defaultFlow: "Flujo Predeterminado",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          allowSignature: "Permitir firma del agente",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationEnd: "Fecha final",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        webchat: {
          publicUrl: "URL pública (página)",
          embedIframe: "Embed iframe",
          floatingWidget: "Widget flotante (botón en la esquina)",
          tokenInfo: "El token público se generará al guardar.",
          titleField: "Título",
          subtitle: "Subtítulo",
          welcomeMessage: "Mensaje de bienvenida",
          primaryColor: "Color primario (hex)",
          logoUrl: "URL del logo (opcional)",
          uploadLogo: "Enviar logo",
          remove: "Quitar",
          logoSizeError: "El logo debe tener como máximo 1MB",
          allowedOrigins: "Orígenes permitidos (CORS, separados por coma)",
          requireForm: "Exigir formulario antes de iniciar la conversación",
          formFields: "Campos del formulario",
          fieldName: "Nombre",
          fieldEmail: "Correo electrónico",
          fieldPhone: "Teléfono",
          defaults: {
            title: "Atención",
            subtitle: "¡Hola! ¿Cómo podemos ayudarte?",
            welcomeMessage: "¡Hola! ¿En qué podemos ayudarte?",
          },
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      qrcodeModal: {
        title: "Conectar a WhatsApp",
        subtitle: "Escanea el código QR con tu celular para iniciar la sesión",
        connected: "¡Conectado con éxito!",
        generating: "Generando nuevo código QR...",
        step1: "Abre <strong>WhatsApp</strong> en tu celular",
        step2Options: "Toca <strong>Más opciones ⋮</strong> o <strong>Configuración ⚙</strong> y selecciona <strong>Dispositivos vinculados</strong>",
        step3: "Toca <strong>Vincular un dispositivo</strong> y apunta la cámara a este código QR",
        refreshCountdown: "El código QR se actualiza en {{seconds}}s",
        refreshing: "Actualizando código QR...",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "Flujos",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        loading: "Cargando...",
        loadMore: "Cargar Más",
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "¡Agente guardado exitosamente!",
        title: {
          add: "Crear Agente",
          edit: "Editar Agente",
        },
        subtitle: "Configure los parámetros del agente de IA",
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        tabs: {
          basic: "Básico",
          behavior: "Comportamiento",
          advanced: "Avanzado",
          knowledge: "📚 Conocimiento",
          test: "🧪 Probar",
        },
        basic: {
          agentName: "Nombre del Agente *",
          agentNamePlaceholder: "Ej: Asistente de Ventas",
          function: "Función",
          voiceTone: "Tono de Voz",
          aiModel: "Modelo de IA",
          apiKey: "API Key *",
          responseLanguages: "🌐 Idiomas de respuesta",
          responseLanguagesHelp: "Seleccione los idiomas en los que la IA puede responder. Use \"Auto\" para responder en el idioma del cliente automáticamente.",
          personality: "Personalidad",
          personalityPlaceholder: "Describa la personalidad, conocimientos y habilidades del agente",
          personalityHelp: "Describa la personalidad, conocimientos y habilidades del agente",
          activeAgent: "Agente Activo",
        },
        behavior: {
          greetingMessage: "Mensaje Inicial (opcional)",
          greetingPlaceholder: "¡Hola! ¿Cómo puedo ayudarte?",
          greetingHelp: "Mensaje enviado automáticamente cuando el agente inicia una conversación",
          responseRules: "Reglas de Respuesta",
          responseRulesPlaceholder: "Liste reglas específicas que el agente debe seguir",
          responseRulesHelp: "Liste reglas específicas que el agente debe seguir",
          allowTransfer: "Permitir transferencia a agente",
          transferKeywords: "Palabras clave para transferencia",
          transferKeywordsPlaceholder: "agente, salir, hablar con humano, humano",
          transferKeywordsHelp: "Separe por coma. Cuando se detectan, la IA transfiere a un agente",
          transferKeywordsDefault: "agente, salir, hablar con humano, humano",
          transferMessage: "Mensaje al transferir",
          transferMessagePlaceholder: "Disculpe, no tengo información sobre este tema. Lo transferiré a un agente.",
          transferMessageDefault: "Disculpe, no tengo información sobre este tema. Lo transferiré a un agente.",
          insertVariable: "Insertar variable:",
          vars: {
            name: "Nombre",
            firstName: "Primer nombre",
            attendant: "Agente",
            queue: "Cola",
            connection: "Conexión",
            protocol: "Protocolo",
            hour: "Hora",
            datetime: "Fecha y hora",
            company: "Empresa",
          },
          transferTargetTitle: "Destino de la transferencia",
          transferQueueLabel: "Cola",
          transferUserLabel: "Agente (opcional)",
          useAgentDefaultQueue: "— Usar cola por defecto del agente —",
          anyUserOfQueue: "— Cualquier agente de la cola —",
          whereTicket: "Dónde debe aparecer el ticket",
          statusPending: "En espera",
          statusOpen: "En atención (del agente)",
          statusOpenHelp: "\"En atención\" solo está disponible cuando se selecciona un agente — el ticket entra directamente en su lista.",
        },
        advanced: {
          responseDelay: "Retraso de Respuesta",
          responseDelayHelp: "Tiempo de espera antes de enviar la respuesta (simula escritura)",
          charLimit: "Límite de caracteres",
          charLimitHelp: "Tamaño máximo de la respuesta del agente",
          humanize: "✨ Humanizar conversación",
          humanizeHelp: "Alterna entre primer nombre, nombre completo y sin nombre para parecer natural",
          audioFeatures: "🔊 Recursos de Audio",
          transcribeAudio: "Transcribir audios recibidos",
          transcribeAudioHelp: "Convierte mensajes de audio en texto para que el agente entienda",
          responseMode: "Modo de Respuesta",
          agentVoice: "Voz del Agente",
          sendAsPTT: "Enviar como audio grabado (PTT)",
          sendAsPTTHelp: "El audio aparece como si fuera grabado al momento, igual a un audio de WhatsApp",
          temperatureHelp: "0 = preciso, 2 = creativo",
          maxTokens: "Max Tokens",
          maxMessages: "Historial de Mensajes",
          maxMessagesHelp: "Cantidad máxima de mensajes anteriores enviados al agente como contexto/historial de la conversación. Cuanto mayor sea, más recuerda el agente, pero consume más tokens.",
        },
        knowledge: {
          title: "Base de Conocimiento",
          subtitle: "Agregue textos, URLs, PDFs, audios y videos para que el agente use como referencia",
          upload: "Subir",
          add: "Agregar",
          saveFirst: "Guarde el agente primero para agregar elementos a la base de conocimiento",
          newItem: "Nuevo Elemento",
          nameLabel: "Nombre",
          textType: "📋 Texto",
          urlType: "🔗 URL",
          urlLabel: "URL del sitio",
          textLabel: "Contenido de texto",
          urlPlaceholder: "https://ejemplo.com/pagina",
          textPlaceholder: "Pegue aquí el texto de referencia...",
          cancelBtn: "Cancelar",
          saveBtn: "Guardar",
          empty: "No hay elementos en la base de conocimiento",
          emptyHelp: "Agregue textos, URLs o suba archivos",
          noContent: "Sin contenido",
          fillNameContent: "Complete el nombre y el contenido",
          addedSuccess: "¡Elemento agregado a la base de conocimiento!",
          uploadSuccess: "¡Archivo subido exitosamente!",
          removeConfirm: "¿Está seguro de que desea eliminar este elemento?",
          removeSuccess: "¡Elemento eliminado!",
        },
        test: {
          model: "Modelo",
          usingApiKey: "Usando API Key y prompt de la pestaña \"Básico\"",
          clear: "Limpiar",
          emptyChat: "💬 Envíe un mensaje para probar su Agente de IA",
          placeholder: "Escriba su mensaje de prueba...",
          fillApiKey: "Complete la API Key antes de probar",
          fillPrompt: "Complete la personalidad/prompt antes de probar",
          fillApiKeyVoice: "Complete la API Key en la pestaña Básico para escuchar la vista previa de voz",
          voiceError: "Error al generar vista previa de voz. Verifique la API Key.",
        },
        tools: {
          title: "Capacidades del Agente",
          subtitle: "Habilite herramientas para que el agente pueda ejecutar acciones reales además de solo conversar.",
          openTicket: {
            title: "Abrir Atención",
            desc: "Cambia el estado de la conversación a Abierto y pausa el Agente de IA.",
            config: {
              title: "🎧 Configuración — Abrir Atención",
              beforeLabel: "Mensaje al cliente antes de transferir (opcional)",
              beforePlaceholder: "Ej: Voy a transferirte con un agente humano. Un momento, por favor.",
              queueLabel: "Cola predeterminada para transferencia",
              queueNone: "— Ninguna (decidir por la conversación) —",
              userLabel: "Agente predeterminado (opcional)",
              userAny: "— Cualquier agente de la cola —",
              hint: "Si la cola está definida, el agente abrirá la atención directamente en ella (y en el agente, si se informa) al activar la herramienta.",
              pauseAi: "Pausar Agente de IA después de abrir la atención",
            },
          },
          notifyHuman: {
            title: "Notificar Humano",
            desc: "Envía una alerta por WhatsApp a los responsables configurados.",
            config: {
              numbersTitle: "📱 Números de WhatsApp de los responsables",
              phonePlaceholder: "+34 600 000 000",
              removePhone: "Eliminar este número",
              addNumber: "+ Agregar otro número",
              hint: "El agente enviará la alerta a <b>todos</b> los números configurados. Ingrese con código de país + área; la máscara es solo visual — guardamos solo dígitos.",
            },
          },
          httpRequest: {
            title: "Petición HTTP",
            desc: "Permite que el agente llame a APIs externas (GET, POST, etc.) para integrarse con otros sistemas.",
            config: {
              title: "🛰️ Configuración — Petición HTTP",
              domainsLabel: "Dominios permitidos (uno por línea) — deje vacío para permitir todos",
              headersLabel: "Headers predeterminados (JSON) — ej.: autenticación",
              invalidHeaders: "Headers predeterminados inválidos. Use JSON, ej: { \"Authorization\": \"Bearer xxx\" }",
            },
          },
          tags: {
            title: "Etiquetas",
            desc: "Permite que el agente aplique etiquetas a la atención según la conversación.",
            config: {
              title: "🏷️ Etiquetas que el agente puede aplicar",
              hint: "Seleccione las etiquetas permitidas. Si no se selecciona ninguna, el agente podrá usar cualquier etiqueta.",
              empty: "Ninguna etiqueta registrada.",
            },
          },
          kanban: {
            title: "Kanban",
            desc: "Permite que el agente mueva la atención entre columnas del Kanban.",
            config: {
              title: "🗂️ Columnas del Kanban que el agente puede usar",
              hint: "El agente podrá mover la atención a una de las columnas seleccionadas. Si no se selecciona ninguna, se permitirá cualquier columna del Kanban.",
              empty: "Ninguna columna de Kanban registrada. Cree etiquetas con Kanban activo en <b>Etiquetas</b>.",
            },
          },
          workingHours: {
            title: "⏰ Turno del Agente — Horario de Atención",
            subtitle: "Herramienta que controla cuándo responde el agente. Fuera del turno configurado, la IA se pausa y el cliente solo recibe el mensaje definido.",
            tooltipTitle: "Cómo funciona",
            tooltipInside: "Cuando está activo, el agente solo responde mensajes <b>dentro</b> de los intervalos configurados para cada día (usando la zona horaria seleccionada).",
            tooltipOutside: "<b>Fuera del turno:</b> la IA <b>no</b> procesa el mensaje ni consume tokens. El sistema envía automáticamente el <b>\"Mensaje fuera del turno\"</b> e ignora el resto de la conversación hasta volver al horario.",
            tooltipLanguage: "Si el cliente habla otro idioma, el mensaje se traduce automáticamente.",
            tooltipMultiple: "Puedes definir <b>varios intervalos por día</b> (ej.: 08:00–12:00 y 14:00–18:00) y dejar días <b>sin intervalos</b> para mantenerlos cerrados.",
            timezone: "Zona horaria",
            outOfMessage: "Mensaje fuera del turno",
            closed: "Cerrado",
            to: "hasta",
            addInterval: "+ Agregar intervalo",
            days: { mon: "Lunes", tue: "Martes", wed: "Miércoles", thu: "Jueves", fri: "Viernes", sat: "Sábado", sun: "Domingo" },
          },
        },
        functions: {
          geral: "General",
          geralDesc: "Asistente multiusos",
          vendas: "Ventas",
          vendasDesc: "Enfocado en conversión",
          suporte: "Soporte",
          suporteDesc: "Atención técnica",
          agendamento: "Agendamiento",
          agendamentoDesc: "Reserva de horarios",
          financeiro: "Financiero",
          financeiroDesc: "Cobros y pagos",
        },
        voiceTones: {
          amigavel: "😊 Amigable",
          profissional: "💼 Profesional",
          formal: "🎩 Formal",
          casual: "😎 Casual",
          empatico: "🤗 Empático",
          tecnico: "🔧 Técnico",
        },
        responseModes: {
          text: "Solo Texto",
          textDesc: "Responde solo con texto",
          audio: "Solo Audio",
          audioDesc: "Responde solo con audio",
          both: "Texto y Audio",
          bothDesc: "Responde con ambos",
        },
        agentVoices: {
          alloyDesc: "Neutra y equilibrada",
          ashDesc: "Masculina, suave",
          balladDesc: "Femenina, expresiva",
          coralDesc: "Femenina, clara",
          echoDesc: "Masculina, profunda",
          fableDesc: "Masculina, británica",
          onyxDesc: "Masculina, grave",
          novaDesc: "Femenina, energética",
          sageDesc: "Masculina, calma",
          shimmerDesc: "Femenina, delicada",
        },
        aiModels: {
          gpt4oMiniDesc: "Recomendado - Equilibrio entre velocidad y calidad",
          gpt4oDesc: "Más inteligente y detallado",
          gpt41MiniDesc: "Rápido y eficiente",
          gpt41Desc: "Alto rendimiento",
          gpt41NanoDesc: "Ultra rápido y económico",
          o4MiniDesc: "Modelo de razonamiento avanzado",
        },
        sectorRequired: "Seleccione un sector de transferencia",
      },
      prompts: {
        title: "Agente de IA",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          tokens_used: "Tokens Usados",
          status: "Estado",
          actions: "Acciones",
        },
        metrics: {
          title: "Métricas de Uso de Tokens",
          totalTokens: "Total de Tokens",
          inputTokens: "Tokens de Entrada",
          outputTokens: "Tokens de Salida",
          estimatedCost: "Costo Estimado (USD)",
          costTooltip: "Estimación basada en precios promedio de GPT-4o-mini. El costo real puede variar.",
          perAgent: "Consumo por Agente",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede revertir!",
        },
        toasts: {
          activate: "Activar agente",
          deactivate: "Desactivar agente",
          activated: "Agente activado",
          deactivated: "Agente desactivado",
        },
        buttons: {
          add: "Agregar Agente",
        },
        inactivity: {
          title: "Mensaje de Inactividad",
          description: "Despierta al cliente automáticamente si tarda en responder.",
          timeoutLabel: "Tiempo de inactividad (minutos)",
          maxRemindersLabel: "Máx. de recordatorios",
          messageLabel: "Mensaje para despertar al cliente",
          messagePlaceholder: "Ej.: ¡Hola! ¿Sigues ahí? 😊",
          helper: "Se envía si el cliente no responde tras el último mensaje del agente.",
          defaultMessage: "¡Hola! ¿Sigues ahí? ¿Puedo ayudarte con algo más? 😊",
          banner: {
            howItWorks: "Cómo va a funcionar:",
            intro: "si el cliente queda",
            withoutReply: "sin responder, se enviará",
            oneReminder: "1 recordatorio",
            nReminders: "{{n}} recordatorios",
            withInterval: "con intervalo de",
            betweenEach: "entre cada uno",
            maxWait: "como máximo",
            totalWait: "de espera total",
            singleTail: "con el mensaje de abajo. Después de eso el sistema deja de insistir.",
            example: "Ejemplo: el cliente dejó de responder a las 10:00",
            firstReminderAt: "1er recordatorio a las",
            lastAt: "último a las",
          },
        },
        noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Lo estamos redirigiendo.",
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          whatsapp: "Conexión Origen: ",
          assignWallet: "Cartera de Cliente",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
        wallet: "Cartera",
        totalContacts: "Total de Contactos",
        activeUsers: "Usuarios Activos",
        activeQueues: "Colas Activas",
        withEmail: "Con Email",
        emptyTitle: "Ningún contacto en la billetera",
        emptySubtitle: "Los contactos vinculados aparecerán aquí.",
        chartByUser: "Distribución por Usuario",
        chartByQueue: "Contactos por Cola",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de rotación",
          randomizeImmediate: "Aleatorizar automáticamente (inmediato)",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integración",
          file: "Archivo",
          aiAgent: "Agente de IA",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione una Integración",
           selectAiAgent: "Seleccione un Agente de IA",
           selectModel: "Modelo de IA",
           addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          acceptanceMessage: "Saludo al aceptar ticket",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          internalExtension: "Extensión interna",
          internalExtensionPlaceholder: "Ej.: 101",
          internalExtensionHelper: "Deje en blanco si este usuario no usa extensión",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
          notifyPendingTicketWhatsapp: "Tickets pendientes",
          whatsappNumber: "WhatsApp para notificaciones",
          whatsappNumberHelper: "Ingrese código de país + código de área + número, solo dígitos (cualquier país). Ej.: 34662531131 (ES), 5511999999999 (BR), 351912345678 (PT).",
          pendingTicketNotificationMessage: "Mensaje personalizado de notificación",
          pendingTicketNotificationMessagePlaceholder: "Ej.: Hola {usuario}, nuevo ticket #{ticket} en la cola {fila} del contacto {contato}.",
          pendingTicketNotificationMessageHelper: "Déjelo en blanco para usar el mensaje predeterminado. Variables: {fila}, {contato}, {ticket}, {usuario}.",
          notifyOpenTicketWhatsapp: "Tickets en atención",
          notifyKanbanTicketWhatsapp: "Cambios en Kanban",
          notificationMaxCount: "Cantidad máxima de notificaciones",
          notificationMaxCountHelper: "Cuántas veces notificar el mismo ticket (por tipo).",
          notificationIntervalMinutes: "Intervalo (min)",
          notificationIntervalMinutesHelper: "Tiempo mínimo entre notificaciones repetidas. 0 = sin intervalo.",
          notificationsSectionTitle: "Notificaciones por WhatsApp",
          enableNotifications: "Activar notificaciones vía WhatsApp",
          enableNotificationsHelper: "Activa o desactiva todas las notificaciones. Puede ajustarlas individualmente abajo.",
          notificationWhatsappId: "Conexión para enviar notificaciones",
          notificationWhatsappIdHelper: "Elija la conexión utilizada para enviar las notificaciones de este usuario.",
          notificationWhatsappAuto: "Automática (usar conexión activa)",
          showReturnQueueButton: "Mostrar botón de devolver a la fila",
          showTransferTicketButton: "Mostrar botón de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel en Tiempo Real",
          allowConnections: "Permitir acciones en conexiones",
          showContacts: "Ver contactos",
          showCampaign: "Ver campañas",
          showFlow: "Ver automatizaciones",
          showSchedules: "Ver Agendamientos",
          showKanban: "Ver Kanban",
          showInternalChat: "Ver Chat Interno",
          showOpenAi: "Ver Agente de IA",
          showIntegrations: "Ver Integraciones",
          finalizacaoComValorVenda: "Finalización con Valor de Venta",
          birthDate: "Fecha de Nacimiento",
          birthDateHelper: "Fecha de nacimiento para notificaciones de cumpleaños",
          connections: "Conexiones",
          language: "Idioma",
          timezone: "Zona horaria (campañas)",
        },
        tabs: {
          general: "General",
          notifications: "Notificaciones",
          permissions: "Permisos",
          sectionNotificationTypes: "Tipos de notificación",
          sectionSendChannel: "Canal de envío",
          sectionLimitsAndMessage: "Límites y mensaje",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      
        notifyTest: {
          button: "Enviar notificación de prueba",
          helper: "Las notificaciones automáticas solo se disparan para tickets en colas donde el usuario está vinculado (pestaña Colas).",
          saveFirst: "Guarde el usuario antes de enviar la prueba.",
          invalidNumber: "Indique un número de WhatsApp válido (código de país + área + número, 8 a 15 dígitos).",
          success: "¡Notificación de prueba enviada con éxito!",
          fail: "Error al enviar la notificación de prueba.",
          reasons: {
            userNotFound: "Usuario no encontrado.",
            invalidNumber: "Número de WhatsApp inválido o vacío (use código de país + área + número, solo dígitos).",
            noDefaultWhatsapp: "No se encontró ninguna conexión de WhatsApp predeterminada. Defina una en Conexiones.",
            wppNotInitialized: "La conexión predeterminada \"{{name}}\" no está inicializada. Vaya a Conexiones y conéctela antes de enviar la prueba.",
            wppOffline: "La conexión predeterminada \"{{name}}\" no está en línea en este momento.",
            sendFailed: "Error al enviar: {{error}}"
          }
        },
},
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programa",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para redirigir al carril",
          nextLaneId: "Carril",
          greetingMessageLane: "Mensaje de bienvenida del carril",
          mediaFiles: "Medios",
          rollbackLaneId: "Volver al carril después de reanudar la atención",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        header: {
          title: "Conversaciones",
        },
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
          messageHidden: "Mensaje oculto",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        elapsedPrefix: "hace {{distance}}",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar sector",
        },
        lastMessage: {
          deleted: "Mensaje eliminado",
          location: "Ubicación",
          contact: "Contacto compartido",
          contactCount: "Contacto compartido ({{count}})",
          missedCall: "Llamada de voz/vídeo perdida",
          audio: "Audio",
          photo: "Foto",
          video: "Vídeo",
          document: "Documento",
          sticker: "Sticker",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        createAndSendTemplate: "Crear y Enviar Plantilla",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          courses: "Cursos",
          agentTemplates: "Plantillas de Agente",
          salesAgents: "Agentes Comerciales",
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          birthdaySettings: "Config. Cumpleaños",
          files: "Lista de archivos",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          myPlan: "Mi Plan",
          adminFinanceiro: "Gestión Financiera",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Agente de IA",
          allConnections: "Admin conexiones",
          whatsappHealth: "Salud de Números",
          reports: "Informes",
          management: "Gerencia",
          callHistorical: "Historial de Llamadas",
          automations: "Automatizaciones",
          groupManager: "Gestor de Grupos",
          tasks: "Tareas",
          followUp: "Follow UP (Templates)",
          salesPipeline: "Pipeline de Ventas",
          salesPipelineDesc: "Visualizar oportunidades",
          taskList: "Lista de Tareas",
          taskListDesc: "Programar y gestionar",
          preferences: "Preferencias",
          preferencesDesc: "Configuraciones del sistema",
          switchAccount: "Cambiar de Cuenta",
          switchAccountDesc: "Gestionar cuentas guardadas",
        },
        planExpiresToday: "⚠️ ¡Tu plan vence hoy! Renueva ahora para no perder el acceso.",
        planExpiresTomorrow: "⚠️ ¡Tu plan vence mañana! Renueva para no perder el acceso.",
        planExpiresIn: "⏳ Tu plan vence en {{count}} días. Renueva para seguir usando el sistema.",
        renewNow: "Renovar ahora",
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            switchAccount: "Cambiar de Cuenta",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
        "pt-BR": "Portugués",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        title: "Notificaciones", clearAll: "Limpiar todo",
        noTickets: "Sin notificaciones.",
        messageHidden: "Mensaje oculto",
        newMessage: "Nuevo mensaje de",
        hideAll: "Ocultar notificaciones",
        hideAllTooltip: "Desactivar notificaciones (puedes reactivarlas en Configuración)",
      },
      triggerFlowModal: {
        title: "Disparar Flujo",
        description:
          "Selecciona un flujo para ejecutar en este ticket. El ticket cambiará a estado 'chatbot' durante la ejecución.",
        selectFlow: "Elige un flujo",
        selectedFlow: "Flujo seleccionado",
        flowId: "ID del flujo",
        noFlows: "No se encontraron flujos activos",
        cancel: "Cancelar",
        trigger: "Disparar Flujo",
        triggering: "Disparando...",
        success: "¡Flujo disparado con éxito!",
        error: "Error al disparar el flujo",
        processingMessage:
          "Disparando flujo... Campo de mensaje temporalmente deshabilitado.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        selectMessage: "Seleccionar Respuesta Rápida",
        hasMedia: "Con multimedia",
        global: "Global",
        noResultsFound: "No se encontraron respuestas rápidas para tu búsqueda",
        noQuickMessages: "No hay respuestas rápidas disponibles",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          media: "Medios",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        sortBy: "Ordenar por",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        search: "Buscar",
        addColumns: "Agregar columnas",
        allTickets: "Todos los tickets",
        myTickets: "Mis tickets",
        slaOverdue: "SLA Atrasado",
        filterSla: "Filtrar SLA",
        filterUser: "Agente",
        filterQueue: "Cola",
        filterChannel: "Canal",
        filterTag: "Etiqueta",
        filterAll: "Todos",
        compact: "Compacto",
        expanded: "Expandido",
        clearFilters: "Limpiar filtros",
        shortcutsHelp: "Atajos: ←/→ navegar columnas · ↑/↓ navegar tarjetas · Enter abrir · C alterna compacto · / enfocar búsqueda",
        boardLabel: "Board",
        boardAll: "Todas las etiquetas",
        manageBoards: "Administrar boards",
        sortOptions: {
          ticketNumber: "Número de Ticket",
          lastMessage: "Último Mensaje",
          valueDesc: "Valor (mayor a menor)",
        },
        toasts: {
          tagUpdated: "¡Tag del Ticket actualizado con éxito!",
          tagRemoved: "¡Tag del Ticket removido!",
          adminOnly: "Solo los administradores pueden reordenar las lanes del Kanban",
          laneOrderUpdated: "Orden de las lanes actualizado con éxito",
          laneOrderError: "Error al guardar el orden de las lanes",
        },
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      kanbanBoards: {
        title: "Boards del Kanban",
        buttons: {
          backToKanban: "Volver al Kanban",
          newBoard: "+ Nuevo Board",
        },
        filters: {
          allBoards: "Todos los boards",
          myBoards: "Mis boards",
        },
        emptyState: "Ningún board creado todavía. Haz clic en <b>+ Nuevo Board</b> para empezar.",
        table: {
          name: "Nombre",
          description: "Descripción",
          columns: "Columnas",
          visibility: "Visibilidad",
          owner: "Propietario",
          default: "Predeterminado",
          actions: "Acciones",
          user: "Usuario",
        },
        visibility: {
          shared: "Compartido",
          private: "Privado",
        },
        actions: {
          removeDefault: "Quitar como predeterminado",
          setDefault: "Definir como predeterminado",
          openInKanban: "Abrir en el Kanban",
          edit: "Editar",
          delete: "Eliminar",
        },
        dialog: {
          newTitle: "Nuevo Board",
          editTitle: "Editar Board",
          nameLabel: "Nombre del board",
          descriptionLabel: "Descripción",
          color: "Color:",
          shareWithCompany: "Compartir con toda la empresa",
          sharedHelp: "<b>Compartido:</b> todos los usuarios de la empresa verán este board en el selector del Kanban y podrán visualizarlo y editarlo. Solo el creador puede eliminarlo.",
          privateHelp: "<b>Privado:</b> solo tú verás este board. Otros usuarios de la misma empresa no tendrán acceso a él en el selector del Kanban.",
          templateOptional: "Plantilla (opcional)",
          blankTemplate: "En blanco",
          blankTemplateDesc: "Crear board sin columnas predefinidas",
          cancel: "Cancelar",
          save: "Guardar",
          saving: "Guardando...",
        },
        templates: {
          sales: {
            name: "Ventas",
            description: "Pipeline comercial: del lead al cierre.",
            columns: { Lead: "Lead", Qualificado: "Calificado", Proposta: "Propuesta", Fechado: "Cerrado", Perdido: "Perdido" },
          },
          support: {
            name: "Soporte",
            description: "Helpdesk y atención al cliente.",
            columns: { Novo: "Nuevo", "Em análise": "En análisis", "Aguardando cliente": "Esperando cliente", Resolvido: "Resuelto" },
          },
          billing: {
            name: "Cobranza",
            description: "Recuperación financiera y negociación.",
            columns: { "Em aberto": "Pendiente", Negociação: "Negociación", Acordo: "Acuerdo", Pago: "Pagado", Inadimplente: "Moroso" },
          },
          onboarding: {
            name: "Onboarding",
            description: "Éxito del cliente y activación.",
            columns: { "Boas-vindas": "Bienvenida", Treinamento: "Capacitación", Ativação: "Activación", "Cliente ativo": "Cliente activo" },
          },
        },
        confirmDelete: {
          title: "Eliminar board",
          message: "¿Seguro que deseas eliminar el board <b>{{name}}</b>? Las tags/columnas no serán eliminadas.",
        },
        toasts: {
          loadError: "Error al cargar boards",
          nameRequired: "Informe un nombre",
          updated: "Board actualizado",
          created: "Board creado",
          saveError: "Error al guardar",
          defaultRemoved: "Board predeterminado removido",
          defaultSet: "Board predeterminado definido",
          defaultError: "Error al cambiar el predeterminado",
          deleted: "Board eliminado",
          deleteError: "Error al eliminar",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
          recurrence: "Recurrencia",
          nextExecution: "Próxima Ejecución",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        statuses: {
          inactive: "Inactiva",
          scheduled: "Programada",
          inProgress: "En Proceso",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrence: {
          minutely: "Por Minuto",
          hourly: "Por Hora",
          daily: "Diario",
          weekly: "Semanal",
          biweekly: "Quincenal",
          monthly: "Mensual",
          yearly: "Anual",
        },
        stopRecurrence: {
          title: "Detener Recurrencia",
          message: "¿Está seguro de que desea detener la recurrencia de esta campaña? La campaña actual seguirá ejecutándose, pero no habrá ejecuciones futuras.",
        },
        filters: {
          status: "Estado",
          all: "Todos",
          allFem: "Todas",
          recurrence: "Recurrencia",
          recurring: "Recurrentes",
          single: "Única",
        },
        tooltips: {
          recurring: "Campaña Recurrente",
          stop: "Detener Campaña",
          restart: "Reiniciar Campaña",
          stopRecurrence: "Detener Recurrencia",
          duplicate: "Duplicar Campaña",
          export: "Exportar CSV",
          preview: "Vista previa del mensaje",
        },
        summary: {
          total: "Total",
          scheduled: "Programadas",
          inProgress: "En Proceso",
          finished: "Finalizadas",
          cancelled: "Canceladas",
        },
        bulk: {
          selected: "seleccionada(s)",
          cancelAll: "Cancelar",
          restartAll: "Reiniciar",
          deleteAll: "Eliminar",
          confirmTitle: "Acción Masiva",
          confirmMessage: "¿Está seguro de ejecutar esta acción en {{count}} campaña(s)?",
        },
        noMessage: "Sin mensaje",
        listRemoved: "Sin lista vinculada",
        connectionDeleted: "Conexión eliminada",
        connectionPrefix: "Conexión",
        noConnection: "Sin conexión",
        notCompleted: "No completada",
        totalLabel: "campañas",
        pagination: {
          rowsPerPage: "Filas por página:",
          of: "de",
          moreThan: "más de",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
          duplicated: "¡Campaña duplicada con éxito!",
          bulkSuccess: "¡Acción masiva completada con éxito!",
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Lo estamos redirigiendo.",
          recurrenceStopped: "¡Recurrencia detenida con éxito!",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
        fetchError: "Error al obtener datos del reporte",
        backButton: "Volver",
        awaitingTemplateResponseCard: "Esperando respuesta del template",
        templateRespondedCard: "Respondieron (follow-up enviado)",
        followUpStatus: {
          waiting: "Esperando respuesta",
          waitingTooltip: "Template enviado. Esperando que el cliente responda para liberar los mensajes 2-5 (ventana de 24h de Meta).",
          sent: "Follow-ups enviados",
          sentTooltip: "El cliente respondió al template. Los mensajes de follow-up (2-5) ya fueron enviados.",
          expired: "Ventana expirada",
          expiredTooltip: "La ventana de 24h de Meta expiró sin respuesta del cliente. Los mensajes 2-5 ya no pueden enviarse.",
        },
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          avatar: "Avatar",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          internalExtension: "Extensión interna",
          internalExtensionPlaceholder: "Ej.: 101",
          internalExtensionHelper: "Deje en blanco si este usuario no usa extensión",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
          backfillChats: "Generar chats existentes",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          amount: "Valor",
          campaigns: "Campañas",
          schedules: "Programas",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openAi: "Agente de IA",
          integrations: "Integraciones",
          flows: "Flujos",
          contacts: "Contactos",
          dashboard: "Dashboard",
          realTime: "Tiempo Real",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
        },
        toasts: {
          success: "¡Operación realizada con éxito!",
          errorList: "No fue posible cargar la lista de registros",
          errorSave: "No fue posible realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron llenados correctamente",
          errorDelete: "No fue posible realizar la operación",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Registro",
          deleteMessage: "¿Desea realmente eliminar este registro?",
        },
        toasts: {
          success: "¡Operación realizada con éxito!",
          error: "No fue posible realizar la operación",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        more: "más",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        subtitle: "Gestiona tus preferencias e integraciones",
        nav: {
          leadSourcesDesc: "Origen de los contactos",
          optionsDesc: "Configuraciones generales",
        },
        tabs: {
          leadSources: "Origen de los leads",
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
          finalizacao: "Finalización de Atención",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            enableCloseTicketModal:
              "Pantalla de cierre de ticket (asunto y resumen)",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            autoReaction: "Reaccionar automáticamente en el mensaje",
            autoReactionRules: "Reglas de Reacción Automática",
            autoReactionAddRule: "Agregar Regla",
            autoReactionKeywords: "Palabras clave (separadas por comas)",
            autoReactionEmojis: "Emojis de reacción",
            autoReactionHelp: "Crea reglas para que el sistema reaccione automáticamente. Si el mensaje del cliente contiene alguna de las palabras clave, el sistema elegirá un emoji configurado en la regla. Si ninguna regla coincide, no habrá reacción.",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            disableSystemNotifications: "Silenciar todas las notificaciones",
            transferredTicketStatus:
              "Estado del ticket al transferir con usuario",
            copyContactPrefix: "Prefijo para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_",
            open: "Abierto",
            pending: "Pendiente",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - use {{queue}} para el nombre de la cola destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar integración",
            disableIntegration: "Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
            greetingAcceptedMessage:
              "Debes configurar un mensaje de saludo al aceptar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
        tooltips: {
          bold: "Negrita",
          italic: "Cursiva",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista con Viñetas",
          quote: "Cita",
          clearFormat: "Limpiar Formato",
          ghostMention: "Mención Fantasma (notifica a todos sin mostrar @)",
          triggerFlow: "Disparar Flujo",
          aiSuggest: "IA: Sugerir Respuesta",
          enableSignature: "Habilitar/Deshabilitar Firma",
          enableComments: "Habilitar/Deshabilitar Comentarios",
          quickAnswers: "Respuestas rápidas",
        },
        menuItems: {
          ghostMention: "Mención Fantasma",
          signature: "Firma",
          triggerFlow: "Disparar Flujo",
          catalog: "Catálogo de productos",
          comments: "Comentarios",
        },
        errors: {
          ticketIdNotFound: "Error: ID del ticket no encontrado",
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
          scheduledDate: "Fecha del Programa",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
        aiSummarize: "Resumen IA del Atendimiento",
        aiSummarizeTitle: "Resumen IA del Atendimiento",
        aiSummaryCopied: "¡Resumen copiado al portapapeles!",
        aiSummaryCopy: "Copiar",
        aiSummaryClose: "Cerrar",
        aiSummarySaveNote: "Guardar como Nota",
        aiSummarySaved: "¡Resumen guardado como nota del contacto!",
        autoAiSummary: "Auto-resumen IA al finalizar",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          attach: "Adjuntar archivo",
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
          triggerFlow: "Disparar Flujo",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
          template: "Plantilla Meta",
          interactive: "Mensaje Interactivo",
          pix: "PIX",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        react: "Reaccionar",
        reactionSent: "Reacción enviada",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_FLOW_AI_NO_KEY: "Ninguna clave de IA configurada. Registra la clave en Configuraciones > IA antes de generar flujos.",
        ERR_FLOW_AI_SHORT_DESCRIPTION: "Describe el flujo con un poco más de detalle.",
        ERR_FLOW_AI_REQUEST_FAILED: "No fue posible hablar con la IA. Verifica la clave e inténtalo de nuevo.",
        ERR_FLOW_AI_INVALID_JSON: "La IA devolvió una respuesta inválida. Intenta reescribir la descripción.",
        ERR_FLOW_AI_EMPTY: "La IA no pudo armar un flujo con esa descripción. Intenta detallar mejor.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
        ERR_TICKET_NO_LINKED_CONNECTION:
          "Este ticket no tiene una conexión vinculada; probablemente la conexión fue eliminada.",
        ERR_PLAN_FEATURE_DISABLED: "Esta función no está disponible en su plan actual. Contacte al administrador para actualizar.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puede elegir enviar el mensaje de forma recurrente y seleccionar el intervalo. Si es un mensaje único, no cambie nada en esta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: "Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendientes",
        noqueue: "SIN COLA",
        total: "Total",
        inService: "En atención",
        activeAgents: "Agentes activos",
        searchPlaceholder: "Buscar contacto, mensaje o agente...",
        allQueues: "Todas las colas",
        all: "Todos",
        refresh: "Actualizar",
        fullscreen: "Pantalla completa",
        exitFullscreen: "Salir de pantalla completa",
        noTicketsForFilters: "No hay atenciones para los filtros actuales.",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        editMessage: "Editar Mensaje",
        messageLabel: "Mensaje",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Nombre del Grupo",
          create: "Crear",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        logoMobile: "Logo Mobile (PWA)",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
      flowBuilder: {
        conversationFlows: "Flujos",
        pageTitle: "Flujos",
        pageSubtitle: "Automatiza conversaciones y procesos con flujos visuales",
        confirmDelete: {
          title: "¿Eliminar flujo \"{{name}}\"?",
          message: "Esta acción no se puede deshacer. Todas las integraciones relacionadas se perderán.",
        },
        confirmDuplicate: {
          title: "¿Duplicar flujo \"{{name}}\"?",
          message: "Se creará una copia del flujo para que puedas editarla.",
        },
        addImage: {
          title: "Agregar imagen al flujo",
          editTitle: "Editar imagen",
          add: "Agregar",
          save: "Guardar",
          caption: "Leyenda (opcional)",
          uploadImage: "Subir imagen",
          successAdd: "¡Imagen agregada con éxito!",
          fileTooLarge: "¡El archivo es muy grande! Máximo 2MB",
          error: "error",
        },
        addText: {
          title: "Agregar mensaje al flujo",
          editTitle: "Editar mensaje del flujo",
          add: "Agregar",
          save: "Guardar",
          message: "Mensaje",
        },
        addAttendant: {
          title: "Agregar agente al flujo",
          editTitle: "Editar agente",
          add: "Agregar",
          edit: "Editar",
          chooseAttendant: "Elija un agente",
          selectUser: "Seleccione un usuario",
          addAttendant: "Agregue un agente",
        },
        condition: {
          title: "Nueva Condición",
          editTitle: "Editar Condición",
          variableField: "Variable / Campo",
          variablePlaceholder: "Escriba $ para ver variables disponibles",
          variableHelper: "Escriba $ para autocompletar variables del flujo",
          conditionType: "Tipo de condición",
          comparisonValue: "Valor de comparación",
          commaSeparated: "Valores separados por coma",
          regexExample: "Ej: ^[0-9]{11}$ — expresión regular JavaScript",
          anyTokenTrigger: "Cualquier token de la lista activa Verdadero",
          fixedOrVariable: "Valor fijo o variable con $",
          insertVariable: "Insertar variable del selector",
          addCondition: "Agregar condición",
          logicTrue: "Lógica: Verdadero si",
          allConditions: "TODAS las condiciones",
          anyCondition: "CUALQUIER condición",
          satisfied: "se cumplen",
          quickTips: "💡 Consejos rápidos",
          tipContainsAny: "Contiene cualquier (,): separe tokens por coma →",
          tipRegex: "Regex: use expresión JS →",
          tipVariable: "Use ${variable} en cualquier campo para referenciar valores dinámicos",
          containsAnyTip: "Contiene cualquier (,): separe tokens por coma",
          regexTip: "Regex: use expresión JS",
          dynamicVarTip: "Use ${variable} en cualquier campo para referenciar valores dinámicos",
          cancel: "Cancelar",
          saving: "Guardando...",
          saveChanges: "Guardar cambios",
          errorRequired: "el campo \"Variable / Campo\" es obligatorio",
          errorComparisonRequired: "el campo \"Valor de comparación\" es obligatorio",
          errorSave: "Ocurrió un error al guardar. Intente de nuevo.",
          selectVariable: "Seleccionar variable",
          dynamicVarsFound: "variable(s) encontrada(s) en el flujo",
          addVarNodes: "Agregue nodos de Variable Global o Input para variables dinámicas",
          searchVariable: "Buscar variable...",
          noVariableFound: "No se encontró ninguna variable",
          flowVariables: "Variables del flujo",
          quickShortcut: "Atajos rápidos:",
          hasTag: "Contacto con la etiqueta",
          notHasTag: "Contacto sin la etiqueta",
          inQueue: "Ticket en la cola",
          notInQueue: "Ticket fuera de la cola",
          selectQueueIn: "Seleccione la cola en la que DEBE estar el ticket",
          selectQueueNotIn: "Seleccione la cola en la que NO debe estar el ticket",
          searchQueue: "Buscar cola...",
          equals: "Igual a",
          notEquals: "Diferente de",
          contains: "Contiene texto",
          notContains: "No contiene",
          containsAny: "Contiene cualquier (,)",
          startsWith: "Empieza con",
          endsWith: "Termina con",
          greaterThan: "Mayor que",
          lessThan: "Menor que",
          greaterOrEqual: "Mayor o igual a",
          lessOrEqual: "Menor o igual a",
          isEmpty: "Está vacío",
          isNotEmpty: "No está vacío",
          regex: "Expresión regular",
          equality: "Igualdad",
          text: "Texto",
          numeric: "Numérico",
          state: "Estado",
          advanced: "Avanzado",
          contactName: "Nombre del contacto",
          contactEmail: "Email del contacto",
          contactPhone: "Teléfono / número del contacto",
          lastMessage: "Último mensaje recibido",
          ticketIdDesc: "ID del ticket actual",
          ticketStatusDesc: "Estado del ticket (open/pending/closed)",
          ticketQueueDesc: "Cola actual del ticket",
          ticketQueueIdDesc: "ID de la cola actual del ticket",
          ticketConnectionDesc: "Nombre de la conexión (WhatsApp) del ticket",
          ticketConnectionIdDesc: "ID de la conexión (WhatsApp) del ticket",
          ticketTagsDesc: "Etiquetas del ticket (separadas por comas)",
          ticketIsOpenDesc: "Ticket está abierto (true/false)",
          ticketIsClosedDesc: "Ticket está cerrado (true/false)",
          ticketIsPendingDesc: "Ticket está pendiente (true/false)",
          ticketTransferredDesc: "Ticket fue transferido (true/false)",
          ticketUserIdDesc: "ID del agente responsable del ticket",
          apiResponseDesc: "Respuesta de la última solicitud HTTP",
          contact: "Contacto",
          ticket: "Ticket",
          globalVariable: "Variable Global",
          capturedInput: "Input Capturado",
          menu: "Menú",
          httpApi: "HTTP / API",
          api: "API",
          globalVarDesc: "Variable global del flujo",
          userResponseDesc: "Respuesta capturada del usuario",
          responseFrom: "Respuesta de:",
          menuResponse: "Respuesta del menú:",
          menuOption: "Opción del menú:",
          mappedFrom: "Mapeado de:",
          httpVarDesc: "Variable de respuesta HTTP",
          valuePrefix: "Valor:",
        },
      },
      flowBuilderTicketModal: {
        addTitle: "Agregar Ticket",
        editTitle: "Editar Ticket",
        chooseQueue: "Elegir sector",
        selectConnection: "Seleccionar una conexión",
        addQueueError: "Seleccione un sector",
      },
      campaignModal: {
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          recurrenceTypeRequired: "Tipo de recurrencia es obligatorio",
          intervalMin: "El intervalo debe ser mayor que 0",
          intervalRequired: "El intervalo es obligatorio",
          selectDay: "Seleccione al menos un día de la semana",
          dayRange: "El día debe estar entre 1 y 31",
          dayRequired: "El día del mes es obligatorio",
          endDateFuture: "La fecha final debe ser futura",
          maxExecMin: "El número máximo debe ser mayor que 0",
          noneValue: "Ninguna",
        },
        tabCampaign: "Campaña",
        tabContactLists: "📋 Listas de Contactos",
        tabSettings: "⚙️ Configuraciones",
        recurrenceTitle: "Configuración de Recurrencia",
        enableRecurrence: "Habilitar recurrencia",
        recurrenceType: "Tipo de recurrencia",
        minutely: "Cada X minutos",
        hourly: "Cada X horas",
        daily: "Diaria",
        weekly: "Semanal",
        biweekly: "Quincenal",
        monthly: "Mensual",
        yearly: "Anual",
        interval: "Intervalo",
        daysOfWeek: "Días de la semana",
        dayOfMonth: "Día del mes",
        dayOfMonthHelper: "Día específico del mes (1-31)",
        endDate: "Fecha final (opcional)",
        emptyRecurrence: "Déjelo vacío para recurrencia infinita",
        maxExecutions: "Máximo de ejecuciones (opcional)",
        hideExecutions: "Ocultar",
        showExecutions: "Ver",
        nextExecutions: "Próximas ejecuciones",
        next5Executions: "Próximas 5 ejecuciones:",
        nthExecution: "{{n}}ª ejecución",
        campaignMessage: "Mensaje de la campaña",
        apiOfficialNote: "Para API Oficial, utilice la plantilla seleccionada al lado. El campo de mensaje y el adjunto de medios no están disponibles.",
        apiOfficialNoFollowUp: "⚠️ Follow-up disponible solo para canales Baileys. En campañas vía API Oficial, solo se envía la plantilla.",
        attachMedia: "Adjuntar medio",
        messageVariableHelper: "Utilice las variables disponibles del sistema, como {nome}, {numero}, {email}, {greeting}, {protocol}, {primeiroNome} y {atendente}.",
        varName: "Nombre",
        varNumber: "Número",
        varEmail: "Email",
        varGreeting: "Saludo",
        varProtocol: "Protocolo",
        varFirstName: "Primer nombre",
        varAgent: "Agente",
        tabs: {
          campaign: "Campaña",
          contactLists: "📋 Listas de Contactos",
          settings: "⚙️ Configuraciones",
        },
        recurrence: {
          title: "Configuración de Recurrencia",
          enable: "Habilitar recurrencia",
          type: "Tipo de Recurrencia",
          interval: "Intervalo",
          dayOfMonth: "Día del Mes",
          dayOfMonthHelper: "Día específico del mes (1-31)",
          endDate: "Fecha Final (opcional)",
          endDateHelper: "Deje vacío para recurrencia infinita",
          maxExecutions: "Máximo de Ejecuciones (opcional)",
          maxExecutionsHelper: "Deje vacío para recurrencia infinita",
          showExecutions: "Ver",
          hideExecutions: "Ocultar",
          nextExecutions: "Próximas Ejecuciones",
          next5: "Próximas 5 Ejecuciones:",
          nthExecution: "ª Ejecución",
          minutely: "Cada X minutos",
          hourly: "Cada X horas",
          daily: "Diaria",
          weekly: "Semanal",
          biweekly: "Quincenal",
          monthly: "Mensual",
          yearly: "Anual",
        },
        days: {
          sunday: "Domingo",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
        },
        message: {
          title: "Mensaje de Campaña",
          variables: {
            name: "Nombre",
            number: "Número",
            email: "Email",
            greeting: "Saludo",
            protocol: "Protocolo",
            firstName: "Primer Nombre",
            attendant: "Agente",
          },
          helperText: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          oficialNotAvailable: "Para API Oficial, utilice la plantilla seleccionada al lado. El campo de mensaje y adjunto de medios no están disponibles.",
          attachMedia: "Adjuntar Medio",
          preview: "Vista previa",
        },
        template: {
          label: "Plantilla *",
          noTemplates: "No se encontró ninguna plantilla aprobada. Cree una plantilla antes de enviar.",
          helperText: "Obligatorio para API Oficial. Los mensajes sin plantilla fallan fuera de la ventana de 24h.",
          selectTemplate: "Seleccione una plantilla aprobada para campañas de API Oficial.",
        },
        followUp: {
          toggle: "Enviar mensaje después del template",
          delayLabel: "Delay entre mensajes",
          description: "Mensajes enviados en secuencia después del template (dentro de la ventana de 24h).",
          multipleHelp: "Complete solo los mensajes que desea enviar. Se enviarán en secuencia. El medio se envía en el 1er mensaje.",
          windowWarningTitle: "Ventana de 24 horas de Meta",
          windowWarningBody: "Los mensajes 2 al 5 solo se enviarán DESPUÉS de que el cliente responda al template. La API Oficial de WhatsApp exige que el cliente responda para abrir una ventana de 24 horas. Si el cliente no responde, solo se entregará el template.",
          delay3s: "3 segundos",
          delay5s: "5 segundos",
          delay10s: "10 segundos",
          delay30s: "30 segundos",
          delay60s: "1 minuto",
          useApprovedTemplate: "Usar plantilla aprobada",
          noSimpleTemplate: "Ninguna plantilla simple disponible",
          selectApprovedTemplate: "Seleccione una plantilla aprobada",
          simpleTemplateHelper: "Solo aparecen aquí plantillas aprobadas sin variables. El medio del encabezado (si lo hay) forma parte de la plantilla.",
          metaRestrictionTitle: "Restricción de Meta — ventana de 24h",
          metaRestrictionBody: "Completó mensajes adicionales (2-5) en una campaña de API Oficial. Meta solo permite enviar estos mensajes después de que el cliente responda al template inicial, y dentro de una ventana de 24h.",
          metaRestrictionEnableHint: "Active el switch \"Enviar mensaje después del template\" abajo; de lo contrario, los mensajes 2-5 no se enviarán.",
        },
        contactList: {
          title: "📋 Lista de Contactos de Campaña",
          description: "Seleccione una lista creada en la pestaña \"📋 Listas de Contactos\". La lista define quién recibirá los mensajes de esta campaña.",
          label: "Lista de Contactos",
          noList: "Ninguna lista seleccionada",
          contacts: "contactos",
          filterByTag: "Filtrar por Etiqueta (opcional)",
          noTagFilter: "Sin filtro de etiqueta",
          switchList: "Cambiar lista → Ir a Listas de Contactos",
          createOrSelect: "+ Crear o seleccionar lista en la pestaña Listas de Contactos",
        },
        triggerSettings: {
          title: "Intervalos de Disparo",
          description: "Configure los intervalos de tiempo entre los disparos de esta campaña para evitar bloqueos.",
          antiBan: "Anti-Ban",
          antiBanDesc: "Humaniza el disparo para reducir el riesgo de bloqueo",
          jitterLabel: "Variación aleatoria (jitter)",
          jitterFixed: "fijo",
          jitterMax: "máximo",
          jitterBase: "Base",
          jitterBetween: "entre",
          jitterAnd: "y",
          selectBaseInterval: "⚠️ Seleccione un intervalo base arriba",
          extraPause: "Pausa extra cada N msgs",
          extraPauseDuration: "Duración de la pausa extra",
          disabled: "Deshabilitado",
          every10: "Cada 10 mensajes",
          every20: "Cada 20 mensajes",
          every30: "Cada 30 mensajes",
          every50: "Cada 50 mensajes",
          every100: "Cada 100 mensajes",
          seconds: "segundos",
          minute1: "1 minuto",
          minutes2: "2 minutos",
          minutes5: "5 minutos",
          savedSuccess: "¡Configuraciones guardadas con éxito!",
          saveSettings: "Guardar Configuraciones",
        },
      },
      chatMessages: {
        user: "Usuario",
        today: "HOY",
        loadingOldMessages: "Cargando mensajes antiguos...",
        viewDocument: "Ver Documento",
        doubleClickReply: "Haga doble clic para responder",
        messageLabel: "Mensaje",
        messageNotFound: "[mensaje no encontrado]",
      },
      finalizacaoAtendimento: {
        title: "Finalización de Atención",
        generalSettings: "Configuraciones Generales",
        informSaleValue: "Informar valor de venta al finalizar atención",
        informSaleValueHelper: "Cuando está habilitado, el campo de valor de venta aparecerá en el modal de finalización",
        finalizationReasons: "Motivos de Finalización",
        addReason: "Agregar Motivo",
        name: "Nombre",
        description: "Descripción",
        actions: "Acciones",
        noDescription: "Sin descripción",
        noReasons: "Ningún motivo registrado. Haga clic en \"Agregar Motivo\" para comenzar.",
        editReason: "Editar Motivo",
        reasonName: "Nombre del Motivo",
        descriptionOptional: "Descripción (opcional)",
        cancel: "Cancelar",
        saving: "Guardando...",
        update: "Actualizar",
        add: "Agregar",
        nameRequired: "El nombre del motivo es obligatorio",
        reasonUpdated: "¡Motivo actualizado con éxito!",
        reasonCreated: "¡Motivo creado con éxito!",
        reasonSaveError: "Error al guardar motivo",
        confirmDelete: "¿Está seguro de que desea eliminar este motivo?",
        reasonDeleted: "¡Motivo eliminado con éxito!",
        reasonDeleteError: "Error al eliminar motivo",
        settingUpdated: "¡Configuración actualizada con éxito!",
        settingUpdateError: "Error al actualizar configuración",
        currencyUpdated: "¡Moneda actualizada con éxito!",
        currencyUpdateError: "Error al actualizar moneda",
      },
      interactiveMessage: {
        tabs: { buttons: "Botones", list: "Lista", billing: "Cobro", offers: "Ofertas", pix: "PIX", url: "URL", call: "Llamada", location: "Ubicación", carousel: "Carrusel", catalog: "Catálogo", poll: "Encuesta" },
        select: "Seleccionar", options: "Opciones", reviewAndPay: "Revisar y pagar",
        templateLoaded: "Plantilla \"{{name}}\" cargada", templateNameRequired: "Ingrese un nombre para la plantilla",
        templateSaved: "¡Plantilla guardada!", templateSaveError: "Error al guardar plantilla",
        templateRemoved: "Plantilla eliminada", templateRemoveError: "Error al eliminar",
        fillMessageText: "Complete el texto del mensaje", addAtLeastOneButton: "Agregue al menos un botón",
        addAtLeastOneListOption: "Agregue al menos una opción a la lista", fillLatLong: "Complete latitud y longitud",
        fillUrl: "Complete la URL", fillPhone: "Complete el número de teléfono", fillPixKey: "Complete la clave PIX",
        addAtLeast2Options: "Agregue al menos 2 opciones", addAtLeastOneCard: "Agregue al menos un card",
        fillBillingDescription: "Complete la descripción del cobro", pdfUploadError: "Error al enviar PDF",
        messageSent: "¡Mensaje interactivo enviado!", sendError: "Error al enviar",
        buttonsInfo: "Envíe hasta 3 botones clicables.", messageText: "Texto del mensaje *",
        footerOptional: "Pie de página (opcional)", buttonsMax3: "Botones (máx. 3)", addButton: "Agregar",
        optionPlaceholder: "Opción {{number}}", listInfo: "Envíe una lista con hasta 10 opciones.",
        buttonText: "Texto del botón", sectionTitle: "Título de la sección", titleLabel: "Título",
        descriptionLabel: "Descripción", addOption: "Agregar opción",
        offerInfo: "Envíe una oferta con título, precio y descripción.", offerTitle: "Título de la oferta",
        bodyDescription: "Descripción / Cuerpo del mensaje *", price: "Precio", additionalDetails: "Detalles adicionales",
        pixInfo: "Envíe datos PIX formateados.", pixKey: "Clave PIX *",
        pixKeyPlaceholder: "CPF, CNPJ, correo, teléfono o clave aleatoria",
        beneficiaryName: "Nombre del beneficiario", city: "Ciudad", amount: "Monto",
        urlInfo: "Envíe un enlace clicable.", linkText: "Texto del enlace", linkTextPlaceholder: "Haga clic aquí",
        urlLabel: "URL *", urlPlaceholder: "https://...",
        callInfo: "Envíe un mensaje con número para llamada.", callButtonText: "Texto del botón",
        callButtonPlaceholder: "Llamar ahora", phoneNumber: "Número de teléfono *",
        locationInfo: "Envíe una ubicación.", locationName: "Nombre del lugar", address: "Dirección",
        latitude: "Latitud *", longitude: "Longitud *",
        carouselInfo: "Envíe múltiples cards como carrusel.", cardLabel: "Card {{number}}", addCard: "Agregar card",
        catalogInfo: "Envíe productos del catálogo.", productLabel: "Producto {{number}}",
        productName: "Nombre del producto", priceDescription: "Descripción / Precio", addProduct: "Agregar producto",
        pollInfo: "Cree una encuesta.", pollQuestion: "Pregunta de la encuesta *",
        pollOptionsLabel: "Opciones (mín. 2, máx. 12)",
        billingInfo: "Envíe un cobro con detalles de pago.", billingNumber: "Nº del cobro",
        billingDescription: "Descripción del cobro *", quantity: "Cantidad", totalAmount: "Monto total",
        billingMessage: "Mensaje adicional", paymentUrl: "URL de pago (opcional)",
        paymentButtonText: "Texto del botón de pago", attachPdf: "Adjuntar PDF",
        save: "Guardar", cancel: "Cancelar", send: "Enviar", sending: "Enviando...",
        saveTemplate: "Guardar como plantilla", templateNameLabel: "Nombre de la plantilla",
        saveTemplateBtn: "Guardar Plantilla", noTemplates: "Sin plantillas guardadas",
        templates: "Plantillas", deleteTemplate: "Eliminar plantilla",
      },
      flowBuilderInteractive: {
        title: "Mensaje Interactivo (Baileys)", editTitle: "Editar Mensaje Interactivo",
        add: "Agregar", save: "Guardar", cancel: "Cancelar",
        messageType: "Tipo de mensaje interactivo", buttonsMax3: "Botones (máx. 3)",
        infoText: "Botones interactivos via Baileys. Funciona en conexiones no oficiales. Límite de 3 botones.",
        messageContent: "CONTENIDO DEL MENSAJE", buttonsTab: "BOTONES",
        messageBody: "Cuerpo del mensaje", footerOptional: "Pie de página (opcional)",
        headerImageOptional: "Imagen de encabezado (opcional)", changeImage: "Cambiar imagen",
        uploadImage: "Subir imagen", listButtonText: "Texto del botón de lista",
        listButtonHelper: "Texto mostrado en el botón que abre la lista",
        preview: "Vista previa", messageBodyPlaceholder: "Cuerpo del mensaje...",
        buttonsLabel: "Botones", listOptions: "Opciones de lista",
        buttonTextPlaceholder: "Texto del botón {{number}}", optionPlaceholder: "Opción {{number}}",
        addAtLeastOneOption: "Agregue al menos una opción.",
        bodyRequired: "¡El cuerpo del mensaje es obligatorio!",
        addOption: "¡Agregue al menos una opción!",
        fileTooLarge: "¡Archivo muy grande! Máximo 2MB",
        imageUploadError: "Error al subir imagen",
        maxOptionsReached: "¡Límite máximo de {{max}} opciones para botones!",
        officialOnlyBanner: "⚠ Funciones avanzadas (CTA, Flow, Catálogo, Carrusel) requieren WhatsApp API Oficial (Meta Cloud). Botones y Listas funcionan en ambos canales.",
        flowOnlyOfficial: "WhatsApp Flows requiere canal API Oficial (Meta).",
        typeButton: "Botones rápidos (Quick Reply)",
        typeList: "Lista interactiva",
        typeCtaUrl: "CTA - Abrir enlace",
        typeCtaCall: "CTA - Llamar",
        typeFlow: "WhatsApp Flow (solo API Oficial)",
        typeCatalog: "Catálogo de productos",
        typeCarousel: "Carrusel de productos",
        typeDescButton: "Hasta 3 botones de respuesta rápida. Úselo para preguntas con pocas opciones (ej: Sí/No, Hablar con agente). Funciona en Baileys y API Oficial.",
        typeDescList: "Lista con hasta 10 opciones agrupadas en un menú. Úselo cuando haya muchas opciones (ej: sectores, horarios, productos). Funciona en Baileys y API Oficial.",
        typeDescCtaUrl: "Botón único que abre una URL externa (sitio, formulario, pago). Solo API Oficial.",
        typeDescCtaCall: "Botón único que inicia una llamada telefónica al número informado. Solo API Oficial.",
        typeDescFlow: "Formulario interactivo nativo de WhatsApp (Flows) configurado en Meta Business. Solo API Oficial.",
        typeDescCatalog: "Envía un producto o su catálogo registrado en Meta Commerce. Opcionalmente envíe una imagen de portada. Solo API Oficial.",
        typeDescCarousel: "Varios cards desplazables con imagen, título, descripción y botón. Úselo para vitrina de productos u opciones visuales. Solo API Oficial.",
        ctaButtonText: "Texto del botón",
        ctaUrl: "URL",
        ctaPhone: "Teléfono (con código de país, ej: +5491155555555)",
        ctaUrlPlaceholder: "Ej: Abrir sitio",
        ctaCallPlaceholder: "Ej: Llamar ahora",
        flowId: "Flow ID",
        flowToken: "Flow Token (opcional)",
        flowCta: "Texto del botón (CTA)",
        flowScreen: "Pantalla inicial",
        catalogId: "Catalog ID",
        catalogProductId: "Producto destacado (retailer_id, opcional)",
        carouselCards: "Cards del carrusel",
        addCard: "Agregar card",
        cardTitle: "Título",
        cardDescription: "Descripción",
        cardImageUrl: "URL de la imagen (opcional)",
        cardButtonText: "Texto del botón",
        cardButtonId: "ID del botón",
        cardLabel: "Card",
        ctaTextRequired: "Informe el texto del botón y la URL",
        callTextRequired: "Informe el texto del botón y el teléfono",
        flowFieldsRequired: "Informe Flow ID y CTA",
        catalogIdRequired: "Informe el ID del catálogo",
        carouselCardsRequired: "Agregue al menos un card al carrusel",
        maxCards: "Máximo 10 cards",
        pixBoxInfo: "Envía un botón nativo 'Copiar código PIX' con el código copia y pega.",
        pixReuseTitle: "Reutilice en varios cobros:",
        pixReuseSubtitle: "use variables en el cuerpo (arriba) y en los campos de abajo.",
        pixFlowVars: "Variables del flujo (capturadas/Webhook):",
        pixTicketVars: "Variables de la atención:",
        pixCopyPasteLabel: "Código PIX copia y pega",
        pixButtonTextLabel: "Texto del botón",
        pixNameLabel: "Nombre del beneficiario (opcional)",
        pixAmountLabel: "Valor (opcional)",
        pixQrCodeLabel: "Enviar código QR (imagen) junto con el botón",
        pixDocBoxInfo: "📄 Adjuntar un PDF (boleta/factura) como encabezado + botón 'Copiar clave Pix' en el mismo globo.",
        pixTotalLabel: "Total mostrado (opcional)",
        pixDocUrlLabel: "URL del PDF (boleta/factura)",
        pixDocNameLabel: "Nombre del archivo (opcional)",
      },
      flowBuilderVideo: {
        title: "Agregar video al flujo", editTitle: "Editar video",
        add: "Agregar", save: "Guardar", captionOptional: "Leyenda (opcional)",
        uploadVideo: "Subir video", mp4Only: "¡ATENCIÓN! ¡Solo videos en MP4!",
        videoAdded: "¡Video agregado con éxito!", fileTooLarge: "¡Archivo muy grande! 20MB máximo",
        browserNotSupported: "su navegador no soporta HTML5",
      },
      flowBuilderInput: {
        addTitle: "Agregar input al flujo",
        title: "Agregar input al flujo", editTitle: "Editar input del flujo",
        add: "Agregar", saveChanges: "Guardar cambios",
        question: "Pregunta", questionTooltip: "La pregunta que se enviará al usuario.",
        questionLabel: "Escriba la pregunta", typeQuestion: "Escriba la pregunta",
        questionPlaceholder: "Ej: Hola {{firstName}}, ¿cuál es su edad?",
        flowVariables: "Variables de flujo (clic para insertar):",
        variableName: "Nombre de la variable", variableNameTooltip: "Nombre de la variable donde se almacenará la respuesta.",
        variableTooltip: "Nombre de la variable donde se almacenará la respuesta.",
        variableNameLabel: "Nombre de la variable", variableNamePlaceholder: "Ej: edad_cliente",
        variablePlaceholder: "Ej: edad_cliente",
        variableNameHelper: "La respuesta del usuario se almacenará en esta variable",
        variableHelper: "La respuesta del usuario se almacenará en esta variable",
        howItWorks: "Cómo funciona",
        howItWorksDescription: "Este nodo enviará la pregunta al usuario y esperará una respuesta.",
        howItWorksDesc: "Este nodo enviará la pregunta al usuario y esperará una respuesta.",
        examples: { name: "Nombre del cliente", email: "Email del cliente", phone: "Teléfono del cliente", city: "Ciudad del cliente" },
        exampleVars: { nome: "Nombre del cliente", email: "Email del cliente", telefone: "Teléfono del cliente", cidade: "Ciudad del cliente" },
      },
      flowBuilderTag: {
        addTitle: "Agregar una etiqueta al flujo", editTitle: "Editar etiqueta",
        chooseTag: "Elija una etiqueta", selectTag: "Seleccione una etiqueta",
        noTagSelected: "Ninguna etiqueta seleccionada", addTag: "Agregue una etiqueta",
        add: "Agregar", edit: "Editar",
      },
      flowBuilderSingleBlock: {
        addTitle: "Agregar contenido al flujo", editTitle: "Editar contenido",
        addMenu: "Agregar menú al flujo", add: "Agregar", save: "Guardar",
        image: "Imagen", uploadImage: "Subir imagen", captionOptional: "Leyenda (opcional)",
        audio: "Audio", uploadAudio: "Subir audio", sendAsRecorded: "Enviar como audio grabado en vivo",
        video: "Video", uploadVideo: "Subir video", text: "Texto", message: "Mensaje",
        interval: "Intervalo", timeInSeconds: "Tiempo en segundos",
        document: "Documento", uploadDocument: "Subir Documento", viewDocument: "Ver Documento",
        contentAdded: "¡Contenido agregado con éxito!", deleteEmptyCards: "Elimine los cards vacíos",
        emptyMessageFields: "¡Campos de mensaje vacíos!", intervalInvalid: "¡El intervalo no puede ser 0 o mayor que 120!",
        fileTooLargeImg: "¡Archivo muy grande! 2MB máximo", fileTooLargeAudio: "¡Archivo muy grande! 5MB máximo",
        fileTooLargeVideo: "¡Archivo muy grande! 20MB máximo", fileTooLargeDoc: "¡Archivo muy grande! 10MB máximo",
        browserNotSupported: "su navegador no soporta HTML5",
        uploading: "Subiendo los archivos y creando el contenido...",
        variableLabels: { firstName: "Primer Nombre", name: "Nombre", userName: "Agente", ms: "Saludo", protocol: "Protocolo", date: "Fecha", hour: "Hora", ticket_id: "Nº del Ticket", queue: "Cola", connection: "Conexión", phoneNumber: "Teléfono", email: "Correo", kanban: "Kanban" },
        vars: { firstName: "Primer Nombre", name: "Nombre", userName: "Agente", greeting: "Saludo", protocol: "Protocolo", date: "Fecha", hour: "Hora", ticketId: "Nº del Ticket", queue: "Cola", connection: "Conexión", phone: "Teléfono", email: "Correo", kanban: "Kanban" },
      },
      flowBuilderGemini: {
        title: "Agregar Gemini al flujo", editTitle: "Editar Gemini del flujo",
        add: "Agregar", save: "Guardar", cancel: "Cancelar",
        basicSettings: "Configuraciones Básicas - Google Gemini",
        assistantName: "Nombre del Asistente", apiKey: "API Key Google AI", model: "Modelo Gemini",
        systemPrompt: "Prompt del Sistema", systemPromptPlaceholder: "Describa cómo debe comportarse la IA...",
        temperature: "Temperatura", temperatureHelper: "0 = conservador, 2 = creativo",
        maxTokens: "Max Tokens", maxTokensHelper: "Tamaño máximo de respuesta",
        maxMessages: "Max Mensajes", maxMessagesHelper: "Historial de contexto",
        flowBehavior: "Comportamiento del Flujo", flowBehaviorTooltip: "Configure cómo Gemini debe comportarse",
        operationMode: "Modo de Funcionamiento",
        permanent: "Permanente", permanentDesc: "Terminar flujo aquí",
        permanentHelper: "El usuario sigue conversando con la IA hasta pedir transferencia",
        temporary: "Temporal", temporaryDesc: "Vuelve al flujo después",
        temporaryHelper: "La IA ejecuta una tarea específica y regresa al flujo normal",
        temporarySettings: "Configuraciones del Modo Temporal",
        temporarySettingsDesc: "Configure cuándo la IA debe detenerse y regresar al flujo",
        maxInteractions: "Máximo de Interacciones", maxInteractionsHelper: "Número máximo de mensajes antes de volver al flujo",
        timeout: "Timeout (minutos)", timeoutHelper: "Límite de tiempo antes de volver al flujo",
        continueKeywords: "Palabras clave para Continuar Flujo", keywordPlaceholder: "Escriba una palabra clave",
        addKeyword: "Agregar", keywordsHelper: "Cuando el usuario envíe una de estas palabras, el flujo continuará",
        objective: "Objetivo de la IA", objectiveHelper: "Describa lo que la IA debe completar",
        objectivePlaceholder: "Ej: Recopilar datos del cliente...",
        autoComplete: "Auto completar al alcanzar objetivo", autoCompleteHelper: "La IA analizará si completó el objetivo",
        validation: { tooShort: "¡Muy corto!", tooLong: "¡Muy largo!", required: "Obligatorio", describeTraining: "Describa el entrenamiento para IA", invalidModel: "Modelo inválido", informModel: "Informe el modelo", minTokens: "Mínimo 10 tokens", maxTokens: "Máximo 8000 tokens", informMaxTokens: "Informe el número máximo de tokens", minTemp: "Mínimo 0", maxTemp: "Máximo 2", informTemp: "Informe la temperatura", informApiKey: "Informe la API Key", minMessages: "Mínimo 1 mensaje", maxMessages: "Máximo 100 mensajes", informMaxMessages: "Informe el número máximo de mensajes", invalidFlowMode: "Modo de flujo inválido", selectFlowMode: "Seleccione el modo de flujo", minInteraction: "Mínimo 1 interacción", maxInteraction: "Máximo 50 interacciones", minTimeout: "Mínimo 1 minuto", maxTimeout: "Máximo 60 minutos", keywordRequired: "La palabra clave no puede estar vacía", atLeastOneKeyword: "Al menos una palabra clave es obligatoria en modo temporal", objectiveRequired: "El objetivo es obligatorio cuando auto completar está activo" },
      },
      flowBuilderOpenAI: {
        title: "Agregar OpenAI al flujo", editTitle: "Editar OpenAI del flujo",
        add: "Agregar", save: "Guardar", cancel: "Cancelar",
        basicSettings: "Configuraciones Básicas - OpenAI",
        assistantName: "Nombre del Asistente", apiKey: "API Key OpenAI", model: "Modelo OpenAI",
        systemPrompt: "Prompt del Sistema", systemPromptPlaceholder: "Describa cómo debe comportarse la IA...",
        temperature: "Temperatura", temperatureHelper: "0 = conservador, 2 = creativo",
        maxTokens: "Max Tokens", maxTokensHelper: "Tamaño máximo de respuesta",
        maxMessages: "Max Mensajes", maxMessagesHelper: "Historial de contexto",
        voiceSettings: "Configuraciones de Voz (Opcional)", responseType: "Tipo de Respuesta", textOnly: "Solo Texto",
        voiceKeyLabel: "Voice Key (Azure)", voiceKeyPlaceholder: "Clave de Azure Speech Service",
        voiceRegionLabel: "Voice Region (Azure)", voiceRegionPlaceholder: "ej: brazilsouth",
        flowBehavior: "Comportamiento del Flujo", flowBehaviorTooltip: "Configure cómo OpenAI debe comportarse",
        operationMode: "Modo de Funcionamiento",
        permanent: "Permanente", permanentDesc: "Terminar flujo aquí",
        permanentHelper: "El usuario sigue conversando con la IA hasta pedir transferencia",
        temporary: "Temporal", temporaryDesc: "Vuelve al flujo después",
        temporaryHelper: "La IA ejecuta una tarea específica y regresa al flujo normal",
        temporarySettings: "Configuraciones del Modo Temporal",
        temporarySettingsDesc: "Configure cuándo la IA debe detenerse y regresar al flujo",
        maxInteractions: "Máximo de Interacciones", maxInteractionsHelper: "Número máximo de mensajes antes de volver al flujo",
        timeout: "Timeout (minutos)", timeoutHelper: "Límite de tiempo antes de volver al flujo",
        continueKeywords: "Palabras clave para Continuar Flujo", keywordPlaceholder: "Escriba una palabra clave",
        addKeyword: "Agregar", keywordsHelper: "Cuando el usuario envíe una de estas palabras, el flujo continuará",
        objective: "Objetivo de la IA", objectiveHelper: "Describa lo que la IA debe completar",
        objectivePlaceholder: "Ej: Recopilar datos del cliente...",
        autoComplete: "Auto completar al alcanzar objetivo", autoCompleteHelper: "La IA analizará si completó el objetivo",
        validation: { tooShort: "¡Muy corto!", tooLong: "¡Muy largo!", required: "Obligatorio", describeTraining: "Describa el entrenamiento para IA", invalidModel: "Modelo inválido", informModel: "Informe el modelo", minTokens: "Mínimo 10 tokens", maxTokens: "Máximo 4000 tokens", informMaxTokens: "Informe el número máximo de tokens", minTemp: "Mínimo 0", maxTemp: "Máximo 2", informTemp: "Informe la temperatura", informApiKey: "Informe la API Key", minMessages: "Mínimo 1 mensaje", maxMessages: "Máximo 100 mensajes", informMaxMessages: "Informe el número máximo de mensajes", informVoice: "Informe el modo de voz", voiceKeyRequired: "Voice Key es obligatoria para síntesis de voz", voiceRegionRequired: "Voice Region es obligatoria para síntesis de voz", invalidFlowMode: "Modo de flujo inválido", selectFlowMode: "Seleccione el modo de flujo", minInteraction: "Mínimo 1 interacción", maxInteraction: "Máximo 50 interacciones", minTimeout: "Mínimo 1 minuto", maxTimeout: "Máximo 60 minutos", keywordRequired: "La palabra clave no puede estar vacía", atLeastOneKeyword: "Al menos una palabra clave es obligatoria en modo temporal", objectiveRequired: "El objetivo es obligatorio cuando auto completar está activo" },
      },
      queueModalExtra: { none: "Ninguno" },
      validation: { tooShort: "¡Muy corto!", tooLong: "¡Muy largo!", required: "Obligatorio", messageTooShort: "Mensaje muy corto", nameTooShort: "nombre muy corto" },
      
    embeddedSignup: {
      title: "WhatsApp Embedded Signup",
      subtitle: "Registre su número directamente desde el CRM",
      steps: { configure: "Configurar", processing: "Procesando", result: "Resultado" },
      description: "Haga clic en el botón de abajo para iniciar el proceso de registro de su número de WhatsApp Business directamente a través de Meta.",
      connectionName: "Nombre de la conexión",
      connectionNamePlaceholder: "Ej: WhatsApp Principal",
      infoTitle: "Qué sucede:",
      infoItems: { popup: "Se abrirá un popup de Meta", login: "Iniciará sesión con su cuenta de Facebook Business", select: "Seleccionará o creará una cuenta de WhatsApp Business", register: "El número se registrará automáticamente en el CRM" },
      buttons: { loadingSdk: "Cargando SDK...", processing: "Procesando...", start: "Iniciar Registro vía Meta", close: "Cerrar", cancel: "Cancelar" },
      success: { title: "¡Conexión creada con éxito!", name: "Nombre", number: "Número", numberPending: "Se mostrará pronto", wabaId: "WABA ID", status: "Estado" },
      errors: { title: "Error en el registro", noAppId: "¡App ID de Meta no configurado!", noConfigId: "¡Configuration ID de Meta no configurado!", noName: "¡Ingrese un nombre para la conexión!", sdkNotLoaded: "El SDK de Meta no se cargó correctamente. Recargue la página e intente nuevamente.", sdkInitFailed: "Error al inicializar el SDK de Meta.", sdkLoadFailed: "Error al cargar el SDK de Meta. Desactive bloqueadores y permita popups.", sdkNotAvailable: "SDK de Facebook no disponible en el navegador.", appIdNotConfigured: "¡App ID de Meta no configurado! Vaya a Configuración > Integraciones Meta.", configIdNotConfigured: "¡Configuration ID de Meta no configurado! Vaya a Configuración > Integraciones Meta.", timeout: "Tiempo agotado. El popup de Meta puede haber sido bloqueado por el navegador. Permita popups e intente nuevamente.", noAuthCode: "Código de autorización no recibido. Verifique los permisos de la app.", cancelled: "Proceso cancelado por el usuario.", signupError: "Error durante el proceso de registro.", processingError: "Error al procesar el registro. Intente nuevamente.", popupError: "Error al abrir popup de Meta. Verifique si los popups están permitidos.", loginCancelled: "Login cancelado o no autorizado.", metaStatus: "Meta devolvió estado:" },
      processing: { title: "Procesando registro...", description: "Estamos intercambiando credenciales con Meta y configurando su conexión." },
      menuItem: "WhatsApp Embedded Signup",
    },
    },
    flowBuilderConditionModal: { addTitle: "Agregar condición al flujo", editTitle: "Editar condición", add: "Agregar", save: "Guardar", conditionField: "Campo de condición (Ingrese solo 1 clave)", validationRule: "Regla de validación", conditionValue: "Valor de condición a analizar" },
    flowBuilderTypebot: { addTitle: "Agregar Typebot al flujo", editTitle: "Editar Typebot en flujo", add: "Agregar", edit: "Editar", save: "Guardar" },
    flowBuilderSwitchFlow: { addTitle: "Agregar Cambio de Flujo", editTitle: "Editar Cambio de Flujo", add: "Agregar", edit: "Editar", save: "Guardar", chooseFlow: "Elija un flujo" },
    flowBuilderRandomizer: { add: "Agregar", edit: "Editar" },
    flowBuilderRandomizerModal: { addTitle: "Agregar aleatorizador al flujo", editTitle: "Editar aleatorizador", addIntervalError: "El porcentaje debe ser mayor que 0", maxTimeError: "El porcentaje no puede ser mayor que 120" },
    flowBuilderKanbanNode: { title: "Kanban", moveTo: "Mover a: {{lane}}", noLane: "Ninguna etapa seleccionada" },
    flowBuilderKanbanModal: { addTitle: "Agregar etapa del Kanban al flujo", editTitle: "Editar etapa del Kanban", description: "Al pasar por este nodo, la conversación se mueve a la etapa elegida del tablero Kanban. El flujo continúa normalmente después.", laneLabel: "Etapa de destino", lanePlaceholder: "Seleccione la etapa...", noLanesAvailable: "No hay etapas de Kanban registradas. Créelas en Etiquetas (marcando la opción Kanban).", selectLaneError: "Seleccione la etapa a la que debe ir la conversación.", cancel: "Cancelar", add: "Agregar", saveEdit: "Guardar" },
    flowBuilderDistributionNode: { title: "Distribución", roundRobin: "Round Robin", leastBusy: "Menos ocupado", membersCount: "{{count}} miembro(s)", noMembers: "Ningún miembro seleccionado" },
    flowBuilderDistributionModal: { addTitle: "Agregar distribución al flujo", editTitle: "Editar distribución", distributionTypeLabel: "Tipo de distribución", roundRobinTitle: "Round Robin", roundRobinDesc: "Distribuye en secuencia, uno a la vez, entre los miembros seleccionados.", leastBusyTitle: "Menos ocupado", leastBusyDesc: "Distribuye siempre a quien tenga menos conversaciones abiertas en este momento.", memberTypeLabel: "Distribuir entre", memberTypeUser: "Agentes", memberTypeQueue: "Colas", membersLabel: "Miembros ({{count}} seleccionado(s))", membersPlaceholder: "Buscar y seleccionar...", selectMembersError: "Seleccione al menos un miembro para distribuir.", add: "Agregar", saveEdit: "Guardar" },
    flowBuilderMenu: { addTitle: "Agregar menú al flujo", editTitle: "Editar menú del flujo", add: "Agregar", save: "Guardar", menuMessage: "Mensaje del menú", addOption: "Agregar opción", digit: "Dígito", typeOption: "Escriba la opción" },
    flowBuilderInterval: { addTitle: "Agregar intervalo al flujo", editTitle: "Editar intervalo", add: "Agregar", edit: "Editar", timeInSeconds: "Tiempo en segundos", addIntervalError: "El intervalo debe ser mayor que 0", maxTimeError: "El intervalo no puede ser mayor que 120" },
    flowBuilderRemoveTag: { addTitle: "Eliminar una etiqueta del flujo", editTitle: "Editar eliminación de etiqueta", addRemoval: "Agregar Eliminación", edit: "Editar", selectTagToRemove: "Seleccione una etiqueta para eliminar", noTagSelected: "Ninguna etiqueta seleccionada", chooseTag: "Elija una etiqueta para eliminar del contacto", actionDescription: "Esta acción eliminará la etiqueta seleccionada del contacto cuando se ejecute el flujo", selectTagError: "Seleccione una etiqueta para eliminar", title: "Eliminar Etiqueta", tagNotSelected: "Etiqueta no seleccionada", removesTagFromContact: "Elimina la etiqueta del contacto" },
    flowBuilderTicket: { add: "Agregar", edit: "Editar" },
    flowBuilderVideo: { addTitle: "Agregar video al flujo", editTitle: "Editar video", add: "Agregar", save: "Guardar" },
    flowBuilderAudio: { addTitle: "Agregar audio al flujo", editTitle: "Editar audio", add: "Agregar", save: "Guardar" },
    flowBuilderGeminiModal: { addTitle: "Agregar Gemini al flujo", editTitle: "Editar Gemini en flujo", add: "Agregar", save: "Guardar", cancel: "Cancelar", basicSettings: "Configuraciones Básicas - Google Gemini", assistantName: "Nombre del Asistente", geminiModel: "Modelo Gemini", systemPrompt: "Prompt del Sistema", systemPromptPlaceholder: "Describa cómo la IA debe comportarse...", temperature: "Temperatura", temperatureHelper: "0 = conservador, 2 = creativo", maxTokensLabel: "Max Tokens", maxTokensHelper: "Tamaño máximo de respuesta", maxMessagesLabel: "Max Mensajes", maxMessagesHelper: "Historial de contexto", flowBehavior: "Comportamiento del Flujo", flowBehaviorTooltip: "Configure cómo Gemini debe comportarse en el flujo", operationMode: "Modo de Funcionamiento", permanent: "Permanente", permanentDesc: "Terminar flujo aquí", permanentHelper: "El usuario sigue conversando con la IA hasta pedir transferencia", temporary: "Temporal", temporaryDesc: "Vuelve al flujo después", temporaryHelper: "La IA ejecuta una tarea específica y regresa al flujo normal", temporarySettings: "Configuraciones del Modo Temporal", temporarySettingsDesc: "Configure cuándo la IA debe detenerse y regresar al flujo", maxInteractions: "Máximo de Interacciones", maxInteractionsHelper: "Número máximo de mensajes antes de volver al flujo", timeoutLabel: "Timeout (minutos)", timeoutHelper: "Límite de tiempo antes de volver al flujo", continueKeywords: "Palabras clave para Continuar Flujo", keywordPlaceholder: "Escriba una palabra clave", addKeyword: "Agregar", keywordsHelper: "Cuando el usuario envíe una de estas palabras, el flujo continuará", objectiveLabel: "Objetivo de la IA", objectiveHelper: "Describa lo que la IA debe completar", objectivePlaceholder: "Ej: Recopilar datos del cliente...", autoComplete: "Auto completar al alcanzar objetivo", autoCompleteHelper: "La IA analizará si completó el objetivo", queueId: "ID de Cola (para transferencia)", queueIdHelper: "ID de cola para transferir si el usuario pide agente (0 = no transferir)" },
    interactiveMessageModal: { title: "Enviar Mensaje Interactivo", subtitle: "Envíe mensajes con botones, listas, ofertas, PIX o links", templateActive: "📋 Template: {{name}}", cancel: "Cancelar", send: "Enviar", sending: "Enviando...", save: "Guardar", saveTemplate: "Guardar Template", saveAsTemplate: "Guardar como template", loadTemplate: "Cargar template guardado", models: "Modelos", templateNameLabel: "Nombre del template", templateNamePlaceholder: "Ej: Bienvenida con botones", saveCurrentConfig: "Guarde la configuración actual como modelo reutilizable", noTemplates: "No hay templates guardados para este tipo", templateLoaded: "Template \"{{name}}\" cargado", templateSaved: "¡Template guardado!", templateRemoved: "Template eliminado", templateSaveError: "Error al guardar template", templateRemoveError: "Error al eliminar", templateNameRequired: "Ingrese un nombre para el template", messageSent: "¡Mensaje interactivo enviado!", messageError: "Error al enviar", fillMessageText: "Complete el texto del mensaje", addAtLeastOneButton: "Agregue al menos un botón", addAtLeastOneOption: "Agregue al menos una opción en la lista", fillLatLong: "Complete latitud y longitud", fillUrl: "Complete la URL", fillPhone: "Complete el número de teléfono", fillPixKey: "Complete la clave PIX", addAtLeast2Options: "Agregue al menos 2 opciones", addAtLeastOneCard: "Agregue al menos una tarjeta", fillBillingDesc: "Complete la descripción de cobro", pdfUploadError: "Error al enviar PDF", pdfTooBig: "PDF muy grande (máx. 16MB)", previewTitle: "Vista Previa del Mensaje", billingDesc: "Descripción del cobro...", messageBody: "Cuerpo del mensaje...", tabs: { buttons: "Botones", list: "Lista", billing: "Cobro", offers: "Ofertas", pix: "PIX", url: "URL", call: "Llamada", location: "Ubicación", carousel: "Carrusel", catalog: "Catálogo", poll: "Encuesta" }, buttonsTab: { info: "Envíe hasta 3 botones clicables.", messageText: "Texto del mensaje *", footer: "Pie de página (opcional)", buttonsMax: "Botones (máx. 3)", add: "Agregar", option: "Opción" }, listTab: { info: "Envíe una lista con hasta 10 opciones.", messageText: "Texto del mensaje *", footer: "Pie de página (opcional)", buttonText: "Texto del botón", sectionTitle: "Título de sección", title: "Título", description: "Descripción", addOption: "Agregar opción", select: "Seleccionar" }, offerTab: { info: "🏷️ Envíe una oferta con título, precio y descripción.", offerTitle: "Título de la oferta", bodyText: "Descripción / Cuerpo del mensaje *", price: "Precio", additionalDetails: "Detalles adicionales", footer: "Pie de página (opcional)" }, pixTab: { info: "💰 Envíe datos PIX formateados.", messageText: "Texto del mensaje *", pixKey: "Clave PIX *", pixKeyPlaceholder: "CPF, CNPJ, email, teléfono o clave aleatoria", beneficiaryName: "Nombre del beneficiario", city: "Ciudad", amount: "Valor" }, urlTab: { info: "🔗 Envíe un link clicable con texto personalizado.", messageText: "Texto del mensaje *", linkText: "Texto del link", linkPlaceholder: "Haga clic aquí", url: "URL *", footer: "Pie de página (opcional)" }, callTab: { info: "📞 Envíe un mensaje con número para llamada.", messageText: "Texto del mensaje *", buttonText: "Texto del botón", buttonPlaceholder: "Llamar ahora", phone: "Número de teléfono *" }, locationTab: { info: "📍 Envíe una ubicación al cliente.", messageText: "Texto del mensaje", locationName: "Nombre del lugar", address: "Dirección", latitude: "Latitud *", longitude: "Longitud *", searchPlaceholder: "Buscar dirección o lugar...", myLocation: "Mi ubicación", mapHint: "Toque en el mapa o arrastre el marcador para definir la ubicación." }, carouselTab: { info: "🎠 Envíe múltiples tarjetas como carrusel.", messageText: "Texto del mensaje *", card: "Tarjeta", title: "Título", description: "Descripción", addCard: "Agregar tarjeta" }, catalogTab: { info: "🛍️ Envíe productos del catálogo como tarjetas.", messageText: "Texto del mensaje *", product: "Producto", productName: "Nombre del producto", descriptionPrice: "Descripción / Precio", addProduct: "Agregar producto" }, pollTab: { info: "📊 Cree una encuesta para que el cliente vote.", officialNote: "(Se enviará como texto formateado en la API Oficial)", question: "Pregunta de la encuesta *", optionsMinMax: "Opciones (mín. 2, máx. 12)", add: "Agregar", option: "Opción" }, billingTab: { info: "🧾 Envíe un cobro con detalles de pago.", billingNumber: "Nº de cobro", billingDesc: "Descripción del cobro *", billingDescPlaceholder: "Cobro pensión", quantity: "Cantidad", totalAmount: "Valor total *", customMessage: "Mensaje personalizado", footer: "Pie de página (opcional)", attachPdf: "📄 Adjuntar PDF / Boleta (opcional)", selectPdf: "Seleccionar PDF", paymentButton: "Botón de pago", buttonText: "Texto del botón", paymentUrl: "URL de pago (opcional)", paymentUrlHelper: "Si se completa, el botón será un link clicable", reviewAndPay: "Revisar y pagar", total: "Total", billingNumberLabel: "Nº DE COBRO" } },
    pairingCodeModal: { title: "📱 Conectar vía Código de Emparejamiento", instructions: "Ingrese el número de WhatsApp con", countryCode: "código de país + código de área", example: "Ejemplo:", phoneLabel: "Número de WhatsApp", phonePlaceholder: "+1 (555) 999-8888", digitsCount: "{{count}}/13 dígitos", generateCode: "Generar Código", tryAgain: "Intentar de Nuevo", close: "Cerrar", cancel: "Cancelar", connected: "¡Conectado!", connectedDesc: "WhatsApp emparejado con éxito.", alreadyConnected: "✅ WhatsApp ya está conectado!", codeNotReturned: "Código no retornado por el servidor.", codeGenerated: "🔑 ¡Código generado! Ingréselo en su WhatsApp en 60 segundos.", whatsappInstructions: "En su WhatsApp, vaya a:", whatsappSteps: "Configuración → Dispositivos vinculados → Vincular un dispositivo", tapLinkPhone: "Toque en", linkWithPhone: "Vincular con número de teléfono", enterCodeExact: "e ingrese el código exactamente como se muestra:", waitingCode: "Esperando código...", enterCodeInWhatsapp: "Ingrese el código en WhatsApp", codeExpiring: "¡Código expirando!", waitingPairing: "Esperando que ingrese el código en WhatsApp...", syncingSession: "Sincronizando sesión... ¡Casi listo!", steps: { generateCode: "Generar código", enterCode: "Ingresar en WhatsApp", syncing: "Sincronizando", connected: "Conectado" } },
    campaignContactSelector: { newListTitle: "Nueva Lista de Contactos", stepName: "Nombrar lista", stepImport: "Importar contactos", nameDescription: "Dé un nombre para identificar esta lista.", listName: "Nombre de la lista", namePlaceholder: "Ej: Clientes VIP, Prospectos Noviembre...", charsCount: "{{count}}/50 caracteres", listCreated: "¡Lista \"{{name}}\" creada! Ahora importe contactos (opcional).", dragExcel: "Arrastre el Excel aquí o haga clic para seleccionar", acceptedFormats: "Formatos aceptados: .xls, .xlsx", downloadTemplate: "📥 Descargar planilla modelo (.xlsx)", close: "Cerrar", cancel: "Cancelar", skipImport: "Omitir importación", creating: "Creando...", createList: "Crear Lista →", sending: "Enviando...", importContacts: "Importar Contactos", selectedForCampaign: "✓ Lista seleccionada para esta campaña", selectForCampaign: "Seleccionar esta lista para la campaña", backToCampaign: "Volver a la Campaña →", searchSystemContacts: "Buscar Contactos del Sistema", selected: "{{count}} seleccionado(s)", addingToList: "Agregando a la lista: {{name}}", searchPlaceholder: "Buscar por nombre o número...", filterByTag: "Filtrar por etiqueta:", clearFilters: "Limpiar ({{count}})", loadingTags: "Cargando etiquetas...", noTagsAvailable: "Ninguna etiqueta disponible.", selectAll: "Seleccionar todos ({{count}} mostrados)", noContactsFound: "Ningún contacto encontrado.", tryAnotherSearch: "Intente buscar otro nombre o número.", name: "Nombre", number: "Número", loadMore: "Cargar más", cancelSearch: "Cancelar", adding: "Agregando...", addToList: "Agregar {{count}} a la lista", contactLists: "Listas de Contactos", createListsDesc: "Cree listas, importe contactos y seleccione la lista para la campaña.", simpleList: "Lista Simple", newListExcel: "Nueva Lista + Excel", selectedList: "Lista seleccionada: {{name}}", contactsCount: "{{count}} contactos — esta lista será usada en la campaña", remove: "Eliminar", searchList: "Buscar lista...", noListsYet: "Ninguna lista creada aún.", clickNewList: "Haga clic en \"Nueva Lista\" para comenzar.", selectedBadge: "Seleccionada", contacts: "contactos", alreadySelected: "Lista ya seleccionada", selectForCampaignTooltip: "Seleccionar para la campaña", searchSystemContactsTooltip: "Buscar contactos del sistema", editList: "Editar lista", deleteList: "Eliminar lista", deleteListConfirm: "¿Eliminar la lista \"{{name}}\"?", listSelected: "¡Lista \"{{name}}\" seleccionada para la campaña!", listRemoved: "Lista eliminada con éxito", importStarted: "¡Importación iniciada! Los contactos se cargarán pronto.", invalidFormat: "Formato inválido. Use solo archivos .xls o .xlsx", fileUploaded: "¡Archivo enviado! Los contactos se cargarán pronto.", searchContact: "Buscar contacto...", selectThisList: "Seleccionar esta lista para la campaña", listSelectedToast: "¡Lista \"{{name}}\" seleccionada para la campaña!", nameList: "Nombrar lista", giveNameToList: "Dé un nombre para identificar esta lista de contactos.", listNamePlaceholder: "Ej: Clientes VIP, Prospectos Noviembre...", characters: "caracteres", searchByNameOrNumber: "Buscar por nombre o número...", listAlreadySelected: "Lista ya seleccionada", selectWhatsapp: "Seleccione una conexión WhatsApp en la campaña antes de importar." },
    contactsPage: { importFromPhone: "Importar contactos del teléfono", selectConnection: "Seleccione la conexión WhatsApp:", noConnectionFound: "Ninguna conexión WhatsApp conectada encontrada.", selectAConnection: "Seleccione una conexión", noNumber: "sin número", cancel: "Cancelar", import: "Importar", profilePhoto: "Foto de Perfil", imageNotAvailable: "Imagen no disponible", blockContact: "¿Bloquear Contacto {{name}}?", unblockContact: "¿Desbloquear Contacto {{name}}?", contactBlocked: "Contacto bloqueado", contactUnblocked: "Contacto desbloqueado", deleteAll: "Eliminar Todos ({{count}})", deleteSelected: "Eliminar Seleccionados ({{count}})", delete: "Eliminar", selectAtLeastOne: "Seleccione al menos un contacto para eliminar", allDeleted: "Todos los {{count}} contactos fueron eliminados", selectedDeleted: "{{count}} contactos eliminados con éxito", importStarting: "Iniciando importación...", importSuccess: "¡Contactos importados con éxito!", notSynced: "Contactos aún no sincronizados.", importError: "Error al importar contactos" },
    kanbanCard: {
      assignValue: "Asignar Valor",
      value: "Valor: {{value}}",
      remove: "Eliminar",
      viewTicket: "Ver Ticket",
      editValue: "Editar",
      assignValueTitle: "Asignar Valor de Oportunidad",
      editValueTitle: "Editar Valor de Oportunidad",
      valueLabel: "Valor",
      cancel: "Cancelar",
      save: "Guardar",
      noName: "Sin nombre",
      noMessages: "Sin mensajes",
      pending: "Pendiente",
      addValue: "Agregar valor",
      viewChat: "Ver conversación",
      slaOnTime: "A tiempo",
      slaWarning: "Atención",
      slaOverdue: "Atrasado",
    },
    kanbanColumn: {
      searchPlaceholder: "Buscar por nombre, número...",
      noResults: "Sin resultados",
      noTickets: "Sin tickets",
      slaOnTime: "A tiempo",
      slaWarning: "Atención",
      slaOverdue: "Atrasado",
      totalValue: "Valor total",
    },
    kanbanLanes: {
      novo: "Nuevo",
      emAnalise: "En análisis",
      aguardandoCliente: "Esperando cliente",
      resolvido: "Resuelto",
      lead: "Lead",
      qualificado: "Cualificado",
      proposta: "Propuesta",
      fechado: "Cerrado",
      perdido: "Perdido",
      emAberto: "Abierto",
      negociacao: "Negociación",
      acordo: "Acuerdo",
      pago: "Pagado",
      inadimplente: "Moroso",
      boasVindas: "Bienvenida",
      treinamento: "Capacitación",
      ativacao: "Activación",
      clienteAtivo: "Cliente activo",
    },
    kanbanChat: {
      statusOpen: "Abierto",
      statusPending: "Pendiente",
      statusClosed: "Cerrado",
      contact: "Contacto",
      noQueue: "Sin cola",
      noMessages: "Sin mensajes aún",
      inputPlaceholder: "Escribe un mensaje...",
    },
    tooltips: { edit: "Editar", delete: "Eliminar", report: "Reporte", syncTemplates: "Sincronizar templates", copyWebhook: "Copiar webhook" },
    telegram: {
      botTokenTitle: "🤖 Token del Bot de Telegram",
      botTokenHelp: "Crea un bot en @BotFather de Telegram y pega el token aquí. El webhook se configurará automáticamente al guardar.",
      botTokenLabel: "Bot Token",
      webhookUrl: "Webhook URL",
      connectBot: "Conectar Bot",
      chip: "TELEGRAM",
    },
    locationPreview: {
      openInMaps: "Abrir en Google Maps",
    },
    flowBuilderConditionCompare: { saving: "Guardando...", saveChanges: "Guardar cambios", add: "Agregar" },
    flowBuilderStart: { title: "Inicio del flujo", description: "¡Este bloque marca el inicio de tu flujo!" },
    flowBuilderConditionCompareNode: { title: "Si / Sino", contains: "contiene", notContains: "no contiene", containsAny: "contiene alguno", startsWith: "inicia con", endsWith: "termina con", isEmpty: "vacío", isNotEmpty: "no vacío", regex: "regex", field: "campo", value: "valor", and: "Y", or: "O", true: "Verdadero", false: "Falso" },
    flowBuilderHttpRequest: { title: "Solicitud HTTP", preconfiguredWebhooks: "Webhooks Preconfigurados", selectPreset: "Seleccionar preset", choosePreset: "Elija una configuración lista...", system: "SISTEMA", remove: "Eliminar", usingPreset: "Usando preset:", urlFromPreset: "URL (del preset)", urlPlaceholder: "https://api.ejemplo.com/webhook", editPresetUrl: "Puede editar la URL base del preset si es necesario", method: "Método", testRequest: "Probar Solicitud", apiResponse: "Respuesta de la API:", viewFullResponse: "Ver respuesta completa", hideAdvanced: "Ocultar avanzado", showAdvanced: "Mostrar avanzado", advancedWarning: "Las configuraciones avanzadas pueden sobrescribir las del preset", timeoutMs: "Timeout (ms)", queryParams: "Parámetros de Query", key: "Clave", addParam: "Agregar Parámetro", headersJson: "Encabezados (JSON)", requestBody: "Cuerpo de la solicitud (JSON)", editRequestBody: "Editar cuerpo de la solicitud", close: "Cerrar", hideMapVars: "Ocultar Variables de Respuesta", showMapVars: "Mapear Variables de Respuesta", mapResponseData: "Mapear datos de respuesta a variables", path: "Ruta", pathPlaceholder: "ej: data.user.id", variableName: "Nombre de variable", variablePlaceholder: "ej: userId", addVariable: "Agregar variable", tips: "Consejos útiles:", tipAutoSave: "La respuesta completa de la API se guarda automáticamente en la variable global", tipVarUsage: "Puede usar ${nombreDeVariable} en la URL y cuerpo de la solicitud para incluir valores de variables.", requestError: "Error en la solicitud", configSaved: "¡Configuración guardada!", fullApiResponse: "Respuesta completa de la API", presetError: "Error al aplicar configuración del preset", value: "Valor" },
    flowBuilderInteractiveNode: { title: "Msg Interactiva API", buttons: "Botones", maxButtons: "máx. 3", messageBody: "Cuerpo del mensaje...", select: "Seleccionar", button: "Botón", item: "Elemento" },
    
    flowBuilderVariable: { title: "Variable Global", variableName: "Nombre de la variable", value: "Valor", helperText: "Puede usar valores estáticos o referencias como ${otraVariable}", saved: "¡Guardado!", saveVariable: "Guardar variable", variableSavedSuccess: "¡Variable guardada con éxito!" },
    flowBuilderAiAgent: { title: "Agente de IA", selectAgent: "Seleccione un agente" },
    flowBuilderAttendant: { title: "Agente" },
    flowBuilderAudioNode: { title: "Audio", recordedLive: "Grabado en vivo", audioSent: "Audio enviado" },
    flowBuilderVideoNode: { title: "Video" },
    flowBuilderMessageNode: { title: "Mensaje" },
    flowBuilderConditionNode: { title: "Condición" },
    flowBuilderImageNode: { title: "Imagen" },
    flowBuilderInputNode: { title: "Input", question: "Pregunta:", questionNotDefined: "Pregunta no definida", variableToStore: "Variable para almacenar respuesta:", variableNotDefined: "Variable no definida", usingVariables: "Usando variables:", alwaysAsk: "Siempre preguntar (incluso si la variable ya existe)" },
    flowBuilderMenuNode: { title: "Menú Numérico" },
    flowBuilderIntervalNode: { title: "Intervalo" },
    flowBuilderRandomizerNode: { title: "Aleatorizador" },
    flowBuilderSingleBlockNode: { title: "Contenido" },
    flowBuilderSwitchFlowNode: { title: "Cambiar Flujo" },
    flowBuilderTypebotNode: {
      title: "TypeBot",
      description: "Transfiere la conversación a un flujo de Typebot. Ideal para formularios, calificación de leads y respuestas guiadas. El cliente interactúa con el bot y el flujo continúa cuando Typebot finaliza o por la palabra clave configurada.",
    },
    flowBuilderQuestionNode: { title: "Pregunta" },
    flowBuilderTagNode: { title: "Etiqueta" },
    flowBuilderTicketNode: { title: "Cola" },
    flowBuilderAiAgentModal: { addTitle: "Agregar Agente de IA", editTitle: "Editar Agente de IA", add: "Agregar", save: "Guardar", cancel: "Cancelar", selectAgent: "Seleccione un Agente de IA", agentLabel: "Agente de IA", selectPlaceholder: "Seleccione...", subtitle: "Seleccione un agente activo para usar en este flujo", noAgentsFound: "No se encontraron agentes activos. Cree un agente en la página \"Agentes de IA\".", defaultAgentName: "Agente de IA" },
    flowBuilderValidation: { tooShort: "¡Muy corto!", tooLong: "¡Muy largo!", enterName: "¡Ingrese un nombre!", enterMessage: "¡Ingrese un mensaje!", required: "Obligatorio" },
    audioTranscription: { transcription: "Transcripción:", transcribing: "Transcribiendo...", transcribe: "Transcribir", failed: "La conversión a texto falló" },
    birthdayModal: { congratulations: "🎉 ¡Felicidades!", specialDay: "¡Hoy es un día especial!", loading: "Cargando cumpleañeros...", youLabel: "(¡Tú!)", systemUser: "Usuario del Sistema", contact: "Contacto", sending: "Enviando...", messageSent: "Mensaje ya enviado", sendCongrats: "Enviar Felicitaciones", remindLater: "Recordar más tarde", understood: "¡Entendido, gracias!", year: "año", years: "años", notAvailable: "N/D", toasts: { sent: "¡Mensaje de felicitaciones enviado a {{name}}! 🎉", alreadySent: "El mensaje de cumpleaños ya fue enviado hoy para este contacto", loadError: "Error al cargar cumpleañeros", sendError: "Error al enviar mensaje de cumpleaños" } },
    birthdaySettings: { title: "🎂 Configuraciones de Cumpleaños", loading: "Cargando configuraciones...", userSection: "Cumpleaños de Usuarios", contactSection: "Cumpleaños de Contactos", generalSection: "Configuraciones Generales", enableUserNotifications: "Habilitar notificaciones de cumpleaños de usuarios", enableUserNotificationsHelp: "Cuando está habilitado, se mostrará un modal de felicitaciones", createAnnouncementUsers: "Crear anuncio automático para cumpleaños de usuarios", createAnnouncementUsersHelp: "Crea un anuncio automático mostrado a todos los usuarios", userBirthdayMessage: "Mensaje de cumpleaños para usuarios", userMessageHelper: "Use {nome} para incluir el nombre del usuario", enableContactMessages: "Habilitar envío automático de mensajes de cumpleaños para contactos", enableContactMessagesHelp: "Envía automáticamente mensajes de cumpleaños por WhatsApp", contactBirthdayMessage: "Mensaje de cumpleaños para contactos", contactMessageHelper: "Use {nome} para el nombre y {idade} para la edad", testMessage: "Probar Mensaje", sendTime: "Hora de envío de mensajes", sendTimeHelper: "Hora en que se enviarán los mensajes automáticos", whatsappConnection: "Conexión WhatsApp para Envío", selectConnection: "Seleccione una conexión", whatsappConnectionHelp: "Conexión WhatsApp para enviar mensajes de cumpleaños", createInternalAnnouncement: "Crear anuncio interno para cumpleaños de usuarios", createInternalAnnouncementHelp: "Crea un anuncio interno cuando un usuario cumple años", availableVariables: "Variables disponibles en mensajes:", varName: "Nombre de la persona", varAge: "Edad de la persona (solo contactos)", preview: "Vista previa:", saving: "Guardando...", saveSettings: "Guardar Configuraciones", toasts: { saved: "¡Configuraciones de cumpleaños guardadas! 🎉", loadError: "Error al cargar configuraciones de cumpleaños", saveError: "Error al guardar configuraciones", testSent: "¡Mensaje de prueba enviado! 📱", testError: "Error al enviar mensaje de prueba" } },
    announcementValidation: { required: "Obligatorio" },
    campaignModal: { tabCampaign: "Campaña", tabContactLists: "📋 Listas de Contactos", tabSettings: "⚙️ Configuraciones", selectTemplateRequired: "Seleccione un template aprobado para campañas de API Oficial.", noTemplateFound: "No se encontraron templates aprobados. Cree un template antes de enviar.", templateRequired: "Obligatorio para API Oficial. Mensajes sin template fallan fuera de la ventana de 24h.", apiOfficialLabel: "API Oficial", recurrenceTitle: "Configuración de Recurrencia", enableRecurrence: "Habilitar recurrencia", recurrenceType: "Tipo de Recurrencia", minutely: "Por Minuto", hourly: "Por Hora", daily: "Diario", weekly: "Semanal", biweekly: "Quincenal", monthly: "Mensual", yearly: "Anual", interval: "Intervalo", everyInterval: "Cada {{count}} {{unit}}", minuteUnit: "minuto(s)", hourUnit: "hora(s)", dayUnit: "día(s)", weekUnit: "semana(s)", biweekUnit: "quincena(s)", monthUnit: "mes(es)", yearUnit: "año(s)", daysOfWeek: "Días de la Semana", dayOfMonth: "Día del Mes", dayOfMonthHelper: "Día específico del mes (1-31)", endDate: "Fecha Final (opcional)", emptyRecurrence: "Deje vacío para recurrencia infinita", maxExecutions: "Máximo de Ejecuciones (opcional)", hideExecutions: "Ocultar", showExecutions: "Visualizar", nextExecutions: "Próximas Ejecuciones", next5Executions: "Próximas 5 Ejecuciones:", nthExecution: "{{n}}ª Ejecución", campaignMessage: "Mensaje de la Campaña", apiOfficialNote: "Para API Oficial, use el template seleccionado al lado.", apiOfficialNoFollowUp: "⚠️ Follow-up disponible solo para canales Baileys. En campañas vía API Oficial, solo se envía el template.", attachMedia: "Adjuntar Medios", messageVariableHelper: "Use variables como {nome}, {numero}, {email}.", varName: "Nombre", varNumber: "Número", varEmail: "Email", varGreeting: "Saludo", varProtocol: "Protocolo", varFirstName: "Primer Nombre", varAgent: "Agente", variationLabel: "Variación", generateVariantsTitle: "Generar 5 variantes del mensaje", generateVariantsDesc: "La IA reescribe el Mensaje 1 de 5 formas diferentes para reducir el patrón repetitivo de texto (protección contra bloqueo).", generatingVariants: "Generando variantes con IA...", variantsGenerated: "¡Variantes generadas! Revise las pestañas Variación 2 a 5.", variantsNeedBase: "Escriba el Mensaje 1 antes de generar variantes.", contactListTitle: "📋 Lista de Contactos de la Campaña", contactListDesc: "Seleccione una lista creada en la pestaña \"📋 Listas de Contactos\".", contactList: "Lista de Contactos", noListSelected: "Ninguna lista seleccionada", contacts: "contactos", filterByTag: "Filtrar por Tag (opcional)", noTagFilter: "Sin filtro de tag", switchList: "Cambiar lista → Ir a Listas de Contactos", createOrSelectList: "+ Crear o seleccionar lista", dispatchIntervals: "Intervalos de Disparo", dispatchIntervalsDesc: "Configure los intervalos de tiempo entre los disparos para evitar bloqueos.", antiBan: "Anti-Ban", antiBanDesc: "Humaniza el disparo para reducir riesgo de bloqueo", jitterLabel: "Variación aleatoria (jitter)", jitterFixed: "fijo", jitterMax: "máximo", jitterBase: "Base {{base}}s → entre {{min}}s y {{max}}s", jitterSelectBase: "⚠️ Seleccione un intervalo base arriba", extraPauseEvery: "Pausa extra cada N msgs", disabled: "Deshabilitado", everyNMessages: "Cada {{n}} mensajes", extraPauseDuration: "Duración de la pausa extra", seconds: "segundos", minute1: "1 minuto", minutes2: "2 minutos", minutes5: "5 minutos", settingsSaved: "¡Configuraciones guardadas!", daysOfWeekOptions: { sunday: "Domingo", monday: "Lunes", tuesday: "Martes", wednesday: "Miércoles", thursday: "Jueves", friday: "Viernes", saturday: "Sábado" }, autoListName: "Campaña - {{name}} - {{date}}", noName: "Sin nombre" },
    campaignModalPhrase: { campaignName: "Nombre de la campaña", nameRequired: "Nombre es obligatorio", selectFlow: "Seleccione un flujo", flowRequired: "Flujo es obligatorio", connections: "Conexiones WhatsApp", connectionsMultiple: "(Múltiples)", atLeastOneConnection: "Debe seleccionar al menos una conexión", connectionsSelected: "{{count}} conexión(es) seleccionada(s):", connectionsInfo: "La campaña se ejecutará cuando cualquier conexión reciba mensajes que coincidan con las frases configuradas.", filterByTag: "Filtrar por Tag del Contacto", optional: "(opcional)", filterByTagDesc: "Si se selecciona, el flujo solo se disparará para contactos que tengan al menos una de estas tags.", tagsLabel: "Tags (opcional)", filterActive: "🏷️ Filtro activo: El flujo solo se disparará para contactos con al menos una de las {{count}} tag(s) seleccionada(s).", triggerKeywords: "Palabras clave que disparan el flujo", logicOr: "🔀 Lógica O: El flujo se disparará si el contacto envía cualquiera de las palabras/frases abajo.", exactLabel: "Exacta: mensaje idéntico.", partialLabel: "Parcial: palabra contenida en cualquier parte del mensaje.", orChip: "O", phraseLabel: "Palabra/frase {{index}}", phrasePlaceholder: "Ej: hola, quiero presupuesto...", fieldRequired: "Campo obligatorio", typeLabel: "Tipo", exact: "Exacta", partial: "Parcial", addPhrase: "+ Agregar otra palabra/frase (O)", active: "Activa", inactive: "Inactiva", saving: "Guardando...", update: "Actualizar", create: "Crear", fillAllFields: "Por favor, complete todos los campos obligatorios", flowNotFound: "Flujo seleccionado no encontrado", toasts: { updated: "¡Campaña actualizada!", created: "¡Campaña creada!", saveError: "Error al guardar campaña", loadFlowsError: "Error al cargar flujos", loadConnectionsError: "Error al cargar conexiones", loadDataError: "Error al cargar datos de la campaña" } },
    contactNotes: { deleteTitle: "Eliminar Registro", deleteConfirm: "¿Realmente desea eliminar este registro?", noteAdded: "¡Observación agregada con éxito!", noteDeleted: "¡Observación eliminada con éxito!", cancel: "Cancelar", save: "Guardar", close: "Cerrar" },
    contactDeleteConfirm: { titleAll: "¿Eliminar TODOS los {{count}} contactos?", titleSelected: "¿Eliminar {{count}} contactos seleccionados?", warningAll: "⚠️ ATENCIÓN: ¡Esta acción eliminará permanentemente TODOS los {{count}} contactos de la empresa!", warningAllBody: "Esta operación no se puede deshacer. Todos los contactos, sus historiales de mensajes, tags y relaciones se perderán definitivamente.", warningSelected: "Esta acción eliminará permanentemente {{count}} contactos seleccionados.", warningSelectedBody: "Los contactos seleccionados y sus datos relacionados serán eliminados definitivamente.", confirmPrompt: "Para confirmar, escriba exactamente:", confirmLabel: "Confirmación", cancel: "Cancelar", deleteAll: "Eliminar Todos", deleteSelected: "Eliminar Seleccionados", expectedAll: "ELIMINAR TODOS", expectedSelected: "ELIMINAR SELECCIONADOS", typeExact: "Escriba exactamente: {{text}}" },
    colorBoxModal: { title: "Elija un color", cancel: "Cancelar", ok: "OK" },
    contactGroupModal: { title: "Crear Grupo de Contactos", groupName: "Nombre del Grupo", groupNamePlaceholder: "Ej: Clientes VIP, Leads Enero...", searchPlaceholder: "Buscar contactos...", selectedCount: "{{count}} contacto(s) seleccionado(s)", clearSelection: "Limpiar selección", name: "Nombre", number: "Número", email: "Email", tags: "Tags", noContacts: "No se encontraron contactos", perPage: "Por página:", displayedRows: "{{from}}-{{to}} de {{count}}", cancel: "Cancelar", creating: "Creando...", createGroup: "Crear Grupo ({{count}} contactos)", groupNameRequired: "Ingrese un nombre para el grupo", selectAtLeastOne: "Seleccione al menos un contacto", groupCreated: "Grupo \"{{name}}\" creado con {{count}} contactos" },
    contactListTable: { name: "Nombre", contacts: "Contactos", actions: "Acciones" },
    contactTagListModal: { contacts: "Contactos", id: "ID", name: "Nombre", number: "Número", actions: "Acciones" },
    contactsFilter: { placeholder: "Contactos" },
    contactImport: { fields: { name: "Nombre", number: "Número", email: "Correo", birthDate: "Fecha de Nacimiento", tags: "Tags", wallet: "Cartera" }, errors: { noNumber: "No se seleccionó el campo de número", noName: "No se seleccionó el campo de nombre", noSelection: "Ningún contacto seleccionado", fieldAlreadySelected: "El campo {{field}} ya fue seleccionado." }, results: { title: "Resultado de la importación", created: "✅ {{count}} contactos creados con éxito", ignored: "⚠️ {{count}} contactos ignorados", successAll: "¡Importación realizada con éxito! {{count}} contactos importados.", successPartial: "Importación completada: {{created}} contactos importados y {{ignored}} ignorados.", failed: "Falló la importación. Ningún contacto fue importado.", importMore: "Importar más contactos" }, validateSwitch: "Validar contactos en WhatsApp", uploading: "Importando... Espere", importButton: "Importar contactos", cancel: "Cancelar", processing: "Procesando archivo...", invalidFile: "¡Archivo inválido!", invalidFileDesc: "El archivo que intentó importar no es válido.", tryAgain: "Intentar de nuevo", dropzoneTitle: "Haga clic o arrastre un archivo Excel", dropzoneFormats: "* Formatos aceptados: xls, xlsx, csv, txt", dropzoneHelp: "Para importar contactos, debe tener al menos las columnas de nombre y número.", back: "Volver" },
    contactImportWpModal: { importingPhone: "Importando contactos del teléfono...", importPhoneButton: "📱 Importar contactos del teléfono (WhatsApp)", phoneImported: "¡Contactos del teléfono importados con éxito!", statusInProgress: "importación en progreso {{current}} de {{total}}", statusComplete: "importación completada con éxito" },
    contactDrawer: { noParticipants: "No se encontraron participantes", chat: "Chatear", superAdmin: "Super Admin", admin: "Admin", participant: "Participante", searching: "Buscando...", noMessages: "No se encontraron mensajes", searchPlaceholder: "Buscar en mensajes...", infoTab: "Información", imagesTab: "Imágenes", videosTab: "Videos", audiosTab: "Audios", documentsTab: "Documentos", linksTab: "Links", participantsTab: "Participantes", noImages: "No se encontraron imágenes", noVideos: "No se encontraron videos", noAudios: "No se encontraron audios", noDocs: "No se encontraron documentos", noLinks: "No se encontraron links", contactUpdated: "¡Contacto actualizado con éxito!", contactBlocked: "Contacto bloqueado", contactUnblocked: "Contacto desbloqueado", blockTooltip: "Bloquear contacto", unblockTooltip: "Desbloquear contacto", lidWarning: "⚠️ Posible error: Número parece ser LID", you: "(Tú)", exportParticipants: "Exportar Participantes", noParticipantsExport: "No hay participantes para exportar", exportSuccess: "¡Archivo \"{{name}}\" exportado con éxito!", noName: "Sin nombre" },
    companiesManager: { generateInvoice: "Generar Factura", yes: "Sí", no: "No", loadError: "No fue posible cargar la lista de registros", operationSuccess: "¡Operación realizada con éxito!", operationError: "No fue posible realizar la operación", deleteError: "No fue posible realizar la operación" },
    birthdaySettingsPage: { title: "🎂 Configuraciones de Cumpleaños" },
    groupManager: { title: "Gestor de Grupos", groups: "Grupos", refresh: "Actualizar", sync: "Sincronizar Grupos", syncing: "Sincronizando...", clearAll: "Limpiar todos los grupos", selectConnection: "Seleccione una conexión", selectConnectionFirst: "Seleccione una conexión para comenzar", clickSyncToLoad: "Haga clic en Sincronizar para cargar los grupos", connection: "Conexión", allConnections: "Todas las conexiones", searchGroup: "Buscar grupo...", noGroupsFound: "No se encontraron grupos", noName: "Sin nombre", connectionLabel: "Conexión {{id}}", selectGroup: "Seleccione un grupo", selectGroupDesc: "Elija un grupo de la lista para gestionar", participants: "participantes", groupActions: "Acciones del Grupo", changeName: "Cambiar nombre", changeNameDesc: "Cambiar el nombre del grupo", changeDescription: "Cambiar descripción", changeDescriptionDesc: "Editar la descripción del grupo", inviteLink: "Enlace de invitación", inviteLinkDesc: "Generar o copiar enlace para compartir", addParticipants: "Agregar participantes", addParticipantsDesc: "Agregar por número de teléfono", sendMessage: "Enviar mensaje", sendMessageDesc: "Enviar mensaje al grupo con mención fantasma", settings: "Configuraciones", onlyAdminsSend: "Solo admins envían", onlyAdminsSendDesc: "Solo los administradores pueden enviar mensajes", restrictEdit: "Restringir edición", restrictEditDesc: "Solo admins editan datos del grupo", participantsCount: "Participantes ({{count}})", creator: "Creador", admin: "Admin", demoteAdmin: "Degradar de admin", promoteAdmin: "Promover a admin", removeFromGroup: "Remover del grupo", dialogChangeName: "Cambiar nombre del grupo", groupName: "Nombre del grupo", cancel: "Cancelar", save: "Guardar", dialogChangeDesc: "Cambiar descripción del grupo", description: "Descripción", dialogInviteLink: "Enlace de invitación", close: "Cerrar", dialogAddParticipants: "Agregar participantes", phoneNumbers: "Número(s) de teléfono", phoneNumbersPlaceholder: "5521999999999 (separe por coma para varios)", phoneNumbersHelper: "Ingrese el número con código de país+área, sin espacios. Ej: 5521999999999", add: "Agregar", dialogSendMessage: "Enviar mensaje al grupo", message: "Mensaje", mentionAll: "Mencionar a todos los participantes (mención fantasma)", send: "Enviar", confirmRemoveParticipant: "¿Está seguro de que desea remover a este participante?", toasts: { loadError: "Error al cargar grupos", selectConnectionFirst: "Seleccione una conexión primero", syncSuccess: "{{count}} grupos sincronizados!", metadataError: "Error al cargar datos del grupo", nameUpdated: "¡Nombre del grupo actualizado!", nameError: "Error al actualizar nombre del grupo", descUpdated: "¡Descripción actualizada!", descError: "Error al actualizar descripción", inviteLinkError: "Error al generar enlace de invitación", linkCopied: "¡Enlace copiado!", participantAdded: "¡Participante(s) agregado(s)!", participantAddError: "Error al agregar participante", messageSent: "¡Mensaje enviado!", messageError: "Error al enviar mensaje", settingUpdated: "¡Configuración actualizada!", settingError: "Error al actualizar configuración", participantRemoved: "¡Participante removido!", removeError: "Error al remover participante", promoted: "¡Participante promovido a admin!", promoteError: "Error al promover participante", demoted: "¡Admin degradado!", demoteError: "Error al degradar participante" } },
    contactImportPage: { title: "Importar contactos de archivo" },
    forwardMessageModal: { title: "Reenviar mensaje", noContactFound: "Ningún contacto encontrado con el nombre {{name}}", sending: "Enviando {{id}}...", forward: "Reenviar" },
    newTicketModalExtra: { selectQueue: "Seleccione una cola", selectConnection: "Seleccione una Conexión", createAndSendTemplate: "Crear y Enviar Plantilla" },
    finalizacaoVendaModal: { title: "Finalización de Atención - Valor de Venta", loading: "Cargando configuraciones...", saleCompleted: "¿Se completó la venta?", yes: "Sí, venta completada", no: "No, venta no completada", saleValue: "Valor de la Venta", noSaleReason: "Motivo de No Venta *", finalizationReason: "Motivo de Finalización *", selectReason: "Seleccione un motivo", cancel: "Cancelar", finalizing: "Finalizando...", finalize: "Finalizar Atención", errorSaleValue: "Por favor, informe el valor de la venta.", errorNoSaleReason: "Por favor, seleccione el motivo de la no venta.", errorFinalizationReason: "Por favor, seleccione el motivo de la finalización." },
    forbiddenPage: { title: "403", message: "¡Oops! ¡Acceso Denegado!", back: "Volver" },
    showTicketLogModal: { close: "Cerrar" },
    promptModalExtra: { text: "Texto", sectorRequired: "Informe el sector" },
    tagModalExtra: { clickToAttach: "Haga clic para adjuntar archivo (Imagen, PDF, Audio, Video)", maxSize: "Tamaño máximo: 10MB por archivo", fileTooLarge: "Archivo {{name}} es demasiado grande. Tamaño máximo: 10MB", unsupportedType: "Tipo de archivo {{type}} no es soportado" },
    fileModalExtra: { nameTooShort: "nombre muy corto" },
    queueModalExtra2: { clickSaveToRegister: "Haga clic en guardar para registrar los cambios", saturday: "Sábado", sunday: "Domingo", minutes: "minutos", selectRotationType: "Seleccione el tipo de rotación" },
    campaignModalExtra: { preview: "Vista previa", seconds: "segundos" },
    messagesInputExtra: {
      internalMessage: "Mensaje interno",
      placeholderPending: "Escriba un mensaje para tickets pendientes",
      placeholderPendingAccept: "Acepte o reabra este ticket para enviar un mensaje.",
      placeholderWindowExpired: "Fuera de la ventana de 24h. Use una plantilla para enviar el mensaje.",
      ticketPendingTitle: "Ticket pendiente.",
      ticketPendingMessage: "Acepte o reabra este ticket para responder.",
      flowProcessingTitle: "Flujo en Ejecución:",
      flowProcessingMessage: "Campo de mensaje temporalmente deshabilitado.",
      windowExpiredTitle: "Ventana de 24h expiró",
      windowExpiredMessage: "Recomendamos enviar una plantilla, pero también puede escribir normalmente.",
      windowExpiredSubtitle: "Último mensaje del cliente: hace {{elapsed}}. Envíe una plantilla aprobada para reactivar este contacto.",
      windowExpiredSubtitleNoTime: "Envíe una plantilla aprobada para reactivar este contacto.",
      placeholderTemplateOnly: "Mensajes libres no disponibles — use una plantilla",
      chooseTemplate: "Elegir Plantilla",
    },
    quickMessageExtra: { required: "Obligatorio", attachMedia: "Adjuntar Medio", editMedia: "Editar medio", removeMedia: "Eliminar medio", newFile: "Nuevo Archivo", newRecordedAudio: "Nuevo audio grabado", newAudio: "Nuevo Audio", replaceMedia: "Elija un nuevo medio para reemplazar:", chooseMedia: "Elija una opción para adjuntar medio:", attachFile: "Adjuntar Archivo", recordAudio: "Grabar Audio", cancelEdit: "Cancelar Edición", type: "Tipo", value: "Valor" },
    contactDrawerExtra: {
      admin: "Administrador",
      chatAriaLabel: "Abrir conversación",
      contactPhoto: "Foto del contacto",
      exportError: "Error al exportar participantes",
      group: "Grupo",
      nameCol: "Nombre",
      noQueue: "Sin cola",
      numberCol: "Número",
      otherUser: "Otro usuario",
      participantsSheet: "Hoja de participantes",
      roleCol: "Rol",
      superAdmin: "Súper administrador",
    },
    contactModalExtra: {
      leadSourceHelper: "Definido por el agente en la conversación.",
      birthDate: "Fecha de nacimiento",
      birthDateHelper: "Formato: DD/MM/AAAA",
      lid: "LID",
      lidHelper: "Identificador LID del contacto",
      noActiveFloup: "Ningún flujo activo",
      noActiveFloupHelper: "No hay ningún flujo activo para este contacto",
      noQueuesForUser: "El usuario no tiene colas asociadas",
      searchMinChars: "Escriba al menos 3 caracteres para buscar",
      searching: "Buscando...",
      selectUserFirst: "Seleccione un usuario primero",
      followUpPanel: "Panel FollowUP",
      aboutFollowUpTitle: "Acerca del Sistema Follow UP",
      aboutFollowUpDesc: "Follow UP permite crear flujos de mensajes y asignarlos a un contacto o ticket para ejecución automática.",
      aboutFollowUpSelect: "Seleccione una plantilla activa para iniciar. Puede interrumpir en cualquier momento.",
      understood: "Entendido",
      noAgent: "Sin agente",
    },
    scheduleModalExtra: {
      contactPlaceholder: "Escriba para buscar el contacto",
      fromQuickReply: "A partir de la respuesta rápida",
      messageStatus: "Estado del mensaje",
      noQuickMessages: "No se encontraron respuestas rápidas",
      quickMessageSearch: "Buscar respuesta rápida...",
      reminder: "Recordatorio",
      reminderDate: "Fecha del recordatorio",
      reminderDescription: "Descripción del recordatorio",
      reminderNote: "Nota del recordatorio",
      sendError: "Error al guardar la programación",
    },
    ticketActionExtra: {
      disableBot: "Deshabilitar bot",
      enableBot: "Habilitar bot",
      linkToWallet: "Vincular a la cartera",
      ratingRequired: "Evaluación obligatoria",
      sendTemplate: "Enviar plantilla",
      sendTemplateBtn: "Enviar",
      sendTemplateExpired: "⚠️ Ventana de 24h expirada — envía una plantilla para reabrir la conversación",
      templateSent: "¡Plantilla enviada con éxito!",
      ticketFinished: "Ticket finalizado",
      tokenError: "Error de token",
    },
    ticketListExtra: {
      contactPhoto: "Foto del contacto",
      createNewTicket: "Crear nuevo ticket",
      spyChatbot: "Espiar chatbot",
      ticketFinished: "Ticket finalizado",
    },
    installPrompt: {
      title: 'Ten a {{appName}} siempre a mano',
      body: 'Instálalo como aplicación de Windows y activa las notificaciones para no perder ninguna conversación, incluso con el navegador minimizado.',
      blocked: 'Las notificaciones están bloqueadas en los permisos del navegador para este sitio. Actívalas manualmente.',
      install: 'Instalar en Windows',
      enableNotifications: 'Activar notificaciones',
      later: 'Ahora no',
      done: 'Todo listo',
    },
    settingsOptions: {
      generalSettings: 'Configuraciones Generales',
      schedulingBot: 'Programación y Bot',
      pushNotifications: 'Notificaciones Push',
      pushProcessing: 'Procesando...',
      pushEnabled: '🔔 Push Activado',
      pushDisabled: '🔕 Push Desactivado',
      pushDescription: 'Active para recibir notificaciones push en este navegador cuando haya nuevos mensajes.',
      pushDeactivated: 'Notificaciones push desactivadas',
      pushActivated: '¡Notificaciones push activadas con éxito!',
      pushActivateError: 'No fue posible activar las notificaciones push. Verifique los permisos del navegador.',
      pushVapidError: 'Notificaciones push no configuradas en el servidor. Configure las claves VAPID en el backend.',
      pushChangeError: 'Error al cambiar notificaciones push',
      pushTestButton: 'Probar push en este dispositivo',
      pushTestSent: '¡Push de prueba enviado! Apague la pantalla y espere.',
      pushTestError: 'No fue posible enviar el push de prueba.',
      pushTestNotSubscribed: 'Active el push en este dispositivo antes de probar.',
      pushTestExpired: 'Suscripción expirada. Por favor desactive y active el push nuevamente.',
      systemCurrency: 'Moneda de la Empresa',
      currency: 'Moneda',
      currencyDescription: 'Define el símbolo de la moneda mostrado en los valores de venta, informes, financiero y checkout de esta empresa.',
      currencyUpdated: '¡Moneda actualizada con éxito!',
      currencyPersistError: 'Error al persistir moneda',
      currencySaveError: 'Error al guardar moneda',
      currencyUpdateError: 'Error al actualizar moneda',
      operationUpdated: 'Operación actualizada con éxito.',
      operationError: 'No se pudo completar la operación.',
      publicFolderRetention: 'Limpieza de carpetas (medios)',
      publicFolderDisabled: 'Desactivada',
      publicFolder1Month: 'Mantener 1 mes',
      publicFolder2Months: 'Mantener 2 meses',
      publicFolder3Months: 'Mantener 3 meses',
      publicFolder6Months: 'Mantener 6 meses',
      publicFolder12Months: 'Mantener 12 meses',
      publicFolderHelp: 'Elimina medios antiguos manteniendo solo los meses más recientes.',
      publicFolderPeriodLabel: 'Período de retención',
      publicFolderPeriodHelp: 'Define cuánto tiempo se mantienen los medios antes de la limpieza.',
      publicFolderCurrentSize: 'Tamaño actual',
      publicFolderSizeAfter: 'Tamaño después de la limpieza',
      publicFolderFreed: 'Liberado',
      publicFolderFiles: 'archivo(s)',
      publicFolderLoading: 'Calculando...',
      publicFolderRefresh: 'Actualizar tamaño',
      publicFolderNoCleanYet: 'Ninguna limpieza ejecutada aún',
      publicFolderWouldFree: 'Se liberaría',
      publicFolderRetentionDisabledHint: 'Seleccione un período de retención para ver la vista previa',
      publicFolderCleanNow: 'Limpiar ahora',
      cleaning: 'Limpiando...',
      publicFolderCleanConfirm: '¿Realmente desea limpiar los medios con más de {{months}} mes(es)? Esta acción no se puede deshacer.',
      publicFolderCleaned: '{{count}} archivo(s) eliminado(s).',
      supportNumber: '📞 Número de Soporte',
      supportNumberPlaceholder: 'Ej: 5511999998888',
      supportNumberHelper: 'Número con código del país (usado en el botón Llamar Soporte)',
      supportNumberUpdated: '¡Número de soporte actualizado!',
      pixEfiConfig: 'Configuración Pix Efí (GerenciaNet)',
      pixKey: 'Clave PIX',
      tokenAsaas: 'Token Asaas',
      text: 'Texto',
      enabled: '✓ HABILITADO',
      disabledLabel: '✕ DESHABILITADO',
      copyContactPrefix: 'Prefijo para copiar contactos',
      aiSection: '🤖 Inteligencia Artificial',
      autoAiSummary: 'Auto-resumen IA al finalizar atención',
      aiSuggestReply: 'Sugerir Respuesta con IA en el Chat',
    },
    whitelabelSettings: {
      operationUpdated: 'Operación actualizada con éxito.',
      appName: 'Nombre de la Aplicación',
      appNameHelper: 'Nombre mostrado en el navegador y correos',
      mobileAppName: 'Nombre Mobile (PWA)',
      mobileAppNameHelper: 'Nombre mostrado al instalar en el celular',
      languages: {
        ptBR: 'Português',
        en: 'English',
        es: 'Español',
      },
    },
    campaignsPhrase: {
      deleted: 'Campaña eliminada con éxito',
      newCampaign: 'Nueva Campaña',
      active: 'Activo',
      inactive: 'Desactivado',
      editCampaign: 'Editar campaña',
      deleteCampaign: 'Eliminar campaña',
      noCampaigns: 'No se encontraron campañas',
      clickNewCampaign: 'Haga clic en "Nueva Campaña" para crear su primera campaña de flujo',
      name: 'Nombre',
      connectionsCol: 'Conexiones',
      statusCol: 'Estado',
      nameNotDefined: 'Nombre no definido',
      phrasesConfigured: 'frase(s) configurada(s)',
    },
    contactsPage: {
      importFromPhone: 'Importar contactos del teléfono',
      selectConnection: 'Seleccione la conexión WhatsApp de donde desea importar los contactos:',
      noConnectionFound: 'No se encontró ninguna conexión WhatsApp conectada.',
      selectAConnection: 'Seleccione una conexión',
      noNumber: 'sin número',
      cancel: 'Cancelar',
      import: 'Importar',
      profilePhoto: 'Foto de perfil',
      imageNotAvailable: 'Imagen no disponible',
      blockContact: '¿Bloquear el contacto {{name}}?',
      unblockContact: '¿Desbloquear el contacto {{name}}?',
      contactBlocked: 'Contacto bloqueado',
      contactUnblocked: 'Contacto desbloqueado',
      deleteAll: 'Eliminar todos ({{count}})',
      delete: 'Eliminar',
      selectAtLeastOne: 'Seleccione al menos un contacto para eliminar',
      allDeleted: 'Se eliminaron los {{count}} contactos',
      selectedDeleted: '{{count}} contactos eliminados con éxito',
      importStarting: 'Iniciando importación...',
      importSuccess: '¡Contactos importados con éxito!',
      importError: 'Error al importar contactos',
      notSynced: 'Contactos aún no sincronizados. Conecte el celular y espere.',
      deleteAllContacts: 'Eliminar todos los contactos',
      deleteSelectedContacts: 'Eliminar contactos seleccionados',
      cancelSelection: 'Cancelar selección',
      deleteSelected: 'Eliminar seleccionados',
      status: 'Estado',
      userNotFound: 'Usuario no encontrado',
      notAssigned: 'No asignado',
      openConversation: 'Abrir conversación',
    },
    financeiroPage: {
      paid: 'Pagado',
      overdue: 'Vencido',
      open: 'Abierto',
      refunded: 'Reembolsada',
      yes: 'Sí',
      no: 'No',
    },
    adminFinanceiro: {
      title: 'Gestión Financiera',
      totalRevenue: 'Ingresos Totales',
      openInvoices: 'Facturas Abiertas',
      overdueInvoices: 'Facturas Vencidas',
      totalInvoices: 'Total de Facturas',
      paidInvoices: 'facturas pagadas',
      allCompanies: 'Todas las empresas',
      statusDistribution: 'Distribución por Estado',
      revenueByMonth: 'Ingresos por Mes',
      defaultByMonth: 'Morosidad por Mes',
      revenue: 'Ingresos',
      defaulting: 'Morosidad',
      search: 'Buscar factura...',
      filterStatus: 'Filtrar Estado',
      all: 'Todos',
      paid: 'Pagado',
      open: 'Abierto',
      overdue: 'Vencido',
      company: 'Empresa',
      detail: 'Detalles',
      users: 'Usuarios',
      connections: 'Conexiones',
      value: 'Valor',
      dueDate: 'Vencimiento',
      daysLeft: 'Días',
      status: 'Estado',
      daysRemaining: 'días restantes',
      daysOverdue: 'días vencidos',
      action: 'Acción',
      refund: 'Reembolsar',
      refunded: 'Reembolsada',
      refundTitle: 'Reembolsar factura',
      refundMessage: '¿Seguro que desea reembolsar esta factura?',
      refundSuccess: 'Factura reembolsada con éxito.',
    },
    companyFinanceiro: {
      title: 'Mi Plan y Financiero',
      myPlan: 'Mi Plan',
      company: 'Empresa',
      users: 'Usuarios',
      connections: 'Conexiones',
      queues: 'Colas',
      value: 'Valor',
      daysLeft: 'días restantes',
      daysOverdue: 'días vencidos',
      expiresOn: 'Vence el',
      expiredTitle: '¡Suscripción Vencida!',
      expiredMessage: 'Su suscripción ha vencido. Regularice para continuar usando el sistema.',
      availablePlans: 'Planes Disponibles',
      currentPlan: 'Plan Actual',
      changePlan: 'Cambiar Plan',
      earlyPayment: 'Pago Anticipado',
      month: 'mes',
      invoiceHistory: 'Historial de Facturas',
      detail: 'Detalles',
      dueDate: 'Vencimiento',
      status: 'Estado',
      action: 'Acción',
      pay: 'Pagar',
      refund: 'Reembolsar',
      refundTitle: 'Reembolsar factura',
      refundMessage: '¿Seguro que desea reembolsar esta factura?',
      refundSuccess: 'Factura reembolsada con éxito.',
      features: {
        campaigns: 'Campañas',
        schedules: 'Programaciones',
        internalChat: 'Chat Interno',
        integrations: 'Integraciones',
        flows: 'Flujos',
        contacts: 'Contactos',
        realTime: 'Tiempo Real',
        kanban: 'Kanban',
        openai: 'OpenAI',
        telegram: 'Telegram',
        zapi: 'Z-API',
        dashboard: 'Panel',
      },
    },
    checkout: {
      almostDone: '¡Ya casi!',
      steps: { data: 'Datos', customize: 'Personalizar', review: 'Revisar' },
      back: 'VOLVER',
      pay: 'PAGAR',
      next: 'SIGUIENTE',
      select: 'SELECCIONAR',
      users: 'Usuarios',
      connection: 'Conexión',
      queues: 'Colas',
      perMonth: '/mes',
      subscriptionSuccess: '¡Suscripción realizada con éxito! Esperando el pago.',
      total: 'TOTAL',
      copied: 'Copiado',
      copyQrPix: 'Copiar código QR PIX',
      pixInstructions: 'Para finalizar, realice el pago escaneando o pegando el código Pix arriba o elija Pagar con Tarjeta de Crédito abajo.',
      payWithCard: 'Pagar con Tarjeta de Crédito',
      payWithMercadoPago: 'Pagar con MercadoPago',
      payWithAsaas: 'Pagar con Asaas',
      licenseRenewed: 'Su licencia ha sido renovada hasta',
      subscriptionSummary: 'Resumen de la suscripción',
      planDetails: 'Detalles del plan',
      billing: 'Facturación',
      monthly: 'Mensual',
      paymentInfo: 'Información de pago',
      email: 'Email',
      name: 'Nombre',
      cpfCnpj: 'ID Fiscal',
      fullName: 'Nombre completo*',
      fullNameRequired: 'El nombre completo es obligatorio',
      address: 'Dirección*',
      addressRequired: 'La dirección es obligatoria',
      city: 'Ciudad*',
      cityRequired: 'La ciudad es obligatoria',
      state: 'Estado*',
      stateRequired: 'El estado es obligatorio',
      cpfCnpjLabel: 'ID Fiscal*',
      cpfCnpjRequired: 'El ID fiscal es obligatorio',
      country: 'País*',
      countryRequired: 'El país es obligatorio',
    },
    chatPage: {
      loadUsersError: 'Error al cargar usuarios',
      chatExists: '¡Chat con este usuario ya existe!',
      chatCreated: '¡Chat creado con éxito!',
      chatCreateError: 'Error al crear chat',
      group: 'Grupo',
      user: 'Usuario',
      internalChat: 'Chat interno nº ',
      chat: 'Chat',
      noMessages: 'Ningún mensaje',
      editGroup: 'Editar Grupo',
      createGroup: 'Crear Grupo',
      changeGroupPhoto: 'Cambiar Foto del Grupo',
      addGroupPhoto: 'Agregar Foto del Grupo',
      titleLabel: 'Título',
      titlePlaceholder: 'Título',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Descripción del grupo',
      editTimeLimit: 'Solo es posible editar mensajes enviados hace menos de 10 minutos.',
      messageDeleted: 'Este mensaje fue eliminado',
      chatEditError: 'Error al crear/editar chat',
    },
    flowBuilderPage: {
      activeStatus: 'Activo',
      inactiveStatus: 'Inactivo',
      flowDeleted: 'Flujo eliminado con éxito',
      flowDuplicated: 'Flujo duplicado con éxito',
      flowActivated: 'Flujo activado con éxito',
      flowDeactivated: 'Flujo desactivado con éxito',
      searchFlows: 'Buscar flujos...',
      createFlow: 'Crear flujo',
      executionsLabel: 'ejecuciones',
      executionTooltip: 'Cantidad de veces que este flujo fue ejecutado',
      statTotal: 'Total de Flujos',
      statActive: 'Flujos Activos',
      statPaused: 'Pausados',
      statDrafts: 'Borradores',
    },
    instagramReplyCommentNode: {
      count: '{{count}} respuesta(s)',
      help: '💬 Responde <b>públicamente</b> al comentario (todos lo ven). Si hay varias variaciones, elige una al azar — así no parece un bot.',
    },
    n8nTriggerNode: {
      configureUrl: 'Configura la URL del webhook',
      help: 'Dispara webhook n8n con los eventos seleccionados.',
    },
    flowBuilderConfigPage: {
      basics: 'Básicos',
      addNodes: 'Agregar Nodos',
      start: 'Inicio',
      startDesc: 'Punto inicial del flujo',
      content: 'Contenido',
      contentDesc: 'Enviar texto, imagen, audio o video',
      textNode: 'Texto',
      textDesc: 'Mensaje de texto simple',
      interaction: 'Interacción',
      menu: 'Menú',
      menuDesc: 'Menú numérico de opciones',
      interactiveApi: 'Msg Interactivo API',
      interactiveApiDesc: 'Botones, listas, CTA, Flow, catálogo y carrusel (Baileys + API Oficial)',
      input: 'Input',
      inputDesc: 'Recoger entrada del usuario',
      interval: 'Intervalo',
      intervalDesc: 'Pausar ejecución por tiempo',
      logic: 'Lógica',
      randomizer: 'Aleatorizador',
      randomizerDesc: 'Elección aleatoria de caminos',
      distribution: 'Distribución',
      distributionDesc: 'Distribuye el ticket entre colas o agentes (round robin o menos ocupado)',
      kanban: 'Kanban',
      kanbanDesc: 'Mueve la conversación a una etapa del tablero Kanban',
      ifElse: 'Si/Sino (If/Else)',
      ifElseDesc: 'Bifurcar flujo basado en condición',
      system: 'Sistema',
      queues: 'Colas',
      queuesDesc: 'Gestionar colas de atención',
      tags: 'Etiquetas',
      tagsDesc: 'Agregar etiquetas al contacto',
      removeTag: 'Eliminar Etiqueta',
      removeTagDesc: 'Eliminar etiquetas del contacto',
      switchFlow: 'Cambiar Flujo',
      switchFlowDesc: 'Dirigir a otro flujo',
      attendant: 'Agente',
      attendantDesc: 'Transferir a un agente',
      variable: 'Variable',
      variableDesc: 'Definir variables globales',
      aiAgent: 'Agente de IA',
      aiAgentDesc: 'Usar agente de IA configurado',
      httpRequest: 'HTTP Request',
      httpRequestDesc: 'Solicitud HTTP externa',
      flowEditor: 'Editor de Flujos',
        typebotDesc: 'Dispara una integración Typebot configurada en Integraciones',
        n8nDesc: 'Dispara una integración n8n configurada en Integraciones',
        asaasBoleto: 'Segunda vía de Boleto (Asaas)',
        asaasBoletoDesc: 'Consulta boletos pendientes del cliente en Asaas vía CPF/CNPJ',
        n8nTriggerName: 'n8n Trigger',
        n8nTriggerDesc: 'Dispara un webhook n8n configurable (ticket, conexión, mensaje, contacto) con Basic Auth y logs en tiempo real.',
        googleCalendarName: 'Google Calendar',
        googleCalendarDesc: 'Crea un evento en el Google Calendar de la empresa usando datos recogidos en el chat (fecha, hora, profesional, cliente).',
        instagramCategory: 'Instagram',
        igTrigger: 'Disparador: Comentario IG',
        igTriggerDesc: '¡Empieza aquí! Inicia el flujo cuando alguien comenta en tu post o reel.',
        igReply: 'Responder comentario',
        igReplyDesc: 'Responde públicamente el comentario (todos ven la respuesta).',
        igLike: 'Dar like al comentario',
        igLikeDesc: 'Da like automático al comentario — muestra que lo viste.',
        igIsFollower: '¿Es seguidor?',
        igIsFollowerDesc: 'Verifica si la persona te sigue. Crea 2 caminos: sigue / no sigue.',
        igSendDm: 'Enviar DM',
        igSendDmDesc: 'Envía mensaje privado (directo) a quien comentó.',
        igSendDmEmpty: '(sin mensaje)',
        igSendDmHelp: 'Envía un <b>mensaje privado</b> (directo) a la persona que comentó. Usa <code>${nombre}</code> para llamarla por su nombre.',
        igRewardPdf: 'Enviar recompensa (PDF)',
        igRewardPdfDesc: 'Envía un archivo (PDF, imagen, video) en privado. Ideal para lead magnets.',
        waitInput: 'Esperar Respuesta',
        waitInputDesc: 'Pausa el flujo hasta que el cliente responda',
        exit: 'Salir / Finalizar',
        exitDesc: 'Finaliza la atención (cierra el ticket)',
        exitNodeClosesTicket: 'Cierra la atención',
        waitInputSaveIn: 'Guardar en',
        waitInputNodePausesFlow: 'Pausa el flujo hasta la respuesta del cliente',
        exitDefaultFarewell: '¡Atención finalizada. Gracias por contactarnos!',
        exitModalTitle: 'Salir / Finalizar Atención',
        exitModalBody: 'Al llegar a este nodo la atención se finaliza (ticket cerrado). Ideal para conectar en una opción "Salir" de un menú.',
        exitModalFarewellLabel: 'Mensaje de despedida (opcional)',
        exitModalKeywordsLabel: 'Palabras que finalizan la conversación (opcional)',
        exitModalKeywordsPlaceholder: 'salir, finalizar, cerrar',
        exitModalKeywordsHelp: 'Separe con comas. Si el cliente envía exactamente una de estas palabras en cualquier punto del flujo, la conversación se cierra de inmediato. No distingue mayúsculas ni acentos.',
        exitModalLaneLabel: 'Mover a la etapa del Kanban al cerrar',
        exitModalLanePlaceholder: 'Ninguna (dejar donde está)',
        exitModalLaneHelp: 'Opcional. Al cerrar, la tarjeta va a esta columna del Kanban (ej.: Perdido). Deje vacío para no tocar el Kanban.',
        cancel: 'Cancelar',
        save: 'Guardar',
        waitInputDefaultReminder: 'Hola {{name}}, ¿sigues ahí? ¿Podemos continuar tu atención?',
        waitInputModalTitle: 'Esperar Respuesta del Cliente',
        waitInputModalBody: 'El flujo se pausa en este nodo hasta que el cliente envíe un nuevo mensaje. La respuesta queda disponible como variable para los nodos siguientes.',
        waitInputVariableLabel: 'Nombre de la variable',
        waitInputVariableHelp: 'La respuesta se guardará como {{nombreDeVariable}}',
        waitInputSendReminder: 'Enviar recordatorio si el cliente no responde',
        waitInputReminderDelay: 'Esperar antes del recordatorio (minutos)',
        waitInputReminderMessage: 'Mensaje de recordatorio',
        waitInputAvailableVars: 'Variables disponibles: {{name}}, {{firstName}}, {{queue}}, {{protocol}}, {{userName}}, {{ms}}, {{date}}, {{hour}}, {{ticket_id}}, {{connection}}',
        waitInputTimeoutActionLabel: 'Después del recordatorio, si el cliente no responde',
        waitInputTimeoutContinueFlow: 'Retomar el flujo donde se dejó',
        waitInputTimeoutCloseTicket: 'Finalizar la atención',
        waitInputTimeoutKeepWaiting: 'Continuar esperando indefinidamente',
        waitInputTimeoutDelay: 'Tiempo de espera después del recordatorio (minutos)',
        waitInputTimeoutDelayHelp: 'Si es 0, la acción ocurre inmediatamente después de enviar el recordatorio',
        tbSave: 'Guardar',
        tbSaving: 'Guardando...',
        tbSaved: 'Guardado',
        tbSavedAgoSec: 'Guardado hace {{n}}s',
        tbSavedAgoMin: 'Guardado hace {{n}}m',
        tbPause: 'Pausar',
        tbActivate: 'Activar',
        tbTest: 'Probar',
        tbN8nLogs: 'Logs n8n',
        tbZoomIn: 'Acercar',
        tbZoomOut: 'Alejar',
        tbFullscreen: 'Pantalla completa',
    },
    instagramTriggerNode: {
      title: 'Disparador: Comentario IG',
      post: 'Publicación:',
      anyPost: 'cualquier publicación',
      keywords: 'Palabras:',
      anyComment: 'cualquier comentario',
      help: '<b>Inicio del flujo.</b> Conecta este bloque a los siguientes para responder, dar like o enviar DM automático cuando alguien comente.',
    },
    instagramLikeCommentNode: {
      title: 'Dar like al comentario',
      help: '❤️ Da un <b>like automático</b> al comentario de la persona — funciona como un "acuse de recibo" de que lo viste.<br /><i>Obs: Instagram todavía está liberando esta función, puede quedar como pendiente.</i>',
    },
    instagramIsFollowerNode: {
      title: '¿Es seguidor?',
      follows: 'Sigue',
      notFollows: 'No sigue',
      help: '👤 Verifica si quien comentó <b>sigue tu cuenta</b>. Tiene 2 salidas:<br />🟢 <b>Verde (sigue)</b> → recibe la recompensa.<br />🔴 <b>Rojo (no sigue)</b> → recibe un DM tipo "sigue la cuenta primero".',
    },
    instagramRewardPdfNode: {
      title: 'Enviar recompensa',
      noFile: '(ningún archivo seleccionado)',
      help: '🎁 Envía un <b>archivo (PDF, imagen, video)</b> directo al privado de la persona. Ideal para lead magnet: e-book, cupón, checklist…',
    },
    n8nLogsDrawer: {
      title: 'Logs n8n en tiempo real',
      newCount: '+{{n}} nuevos',
      refresh: 'Actualizar',
      clear: 'Limpiar vista',
      status: 'Estado',
      event: 'Evento',
      all: 'Todos',
      success: 'Éxito',
      error: 'Error',
      pending: 'Pendiente',
      evTicket: 'Ticket',
      evConnection: 'Conexión',
      evMessage: 'Mensaje',
      evContact: 'Contacto',
      empty: 'Aún no hay registros. Ejecuta el flujo y los disparos de n8n aparecerán aquí en tiempo real.',
      url: 'URL',
      errorLabel: 'Error',
      payload: 'Payload enviado',
      response: 'Respuesta de n8n',
      footer: 'Mostrando hasta 200 registros. Usa los filtros para refinar.',
    },
    flowBuilderN8nTriggerModal: {
      titleAdd: 'Agregar n8n Trigger',
      titleEdit: 'Editar n8n Trigger',
      info: 'Cuando el flujo pase por este nodo, se enviará un webhook a n8n con los datos seleccionados. Puedes elegir qué campos enviar y agregar campos personalizados usando variables del flujo.',
      webhookUrl: 'URL del Webhook n8n',
      authTitle: 'Autenticación (Basic Auth)',
      authUser: 'Usuario',
      authPass: 'Contraseña',
      presetsTitle: 'Presets listos',
      presetsHelp: 'Aplica una configuración predeterminada con un clic y ajusta después.',
      eventsTitle: 'Eventos / Datos a enviar',
      mappingTitle: 'Mapeo de campos por evento',
      mappingHelp: 'Marca solo los campos que deben enviarse a n8n. Usa los campos personalizados para agregar valores fijos o variables del flujo (ej.: {{var}}).',
      customFields: 'Campos personalizados (admite variables del flujo: {{var}})',
      triggerTitle: 'Disparo',
      mode: 'Modo',
      modeAsync: 'Fire-and-forget',
      modeSync: 'Esperar respuesta',
      timeout: 'Timeout (ms)',
      saveResponse: 'Guardar respuesta en variable',
      saveResponseHelp: 'Úsalo después en los próximos nodos como {{n8nResponse}}',
      cancel: 'Cancelar',
      add: 'Agregar',
      save: 'Guardar',
    },
    metaUnifiedWebhook: {
      back: 'Volver a Plantillas',
      step1Title: 'Pega estos valores en el panel de Meta',
      step1Sub: 'App de Meta → WhatsApp → Configuración → Webhook',
      copyUrl: 'Copiar URL',
      copyToken: 'Copiar token',
      copied: '{{label}} copiado!',
      webhookFieldsLabel: 'En Webhook fields, marca:',
      step2Title: 'Suscribe cada WABA en tu App',
      step2Sub: 'Llama /subscribed_apps con el token guardado en la conexión',
      noConnections: 'No se encontró ninguna conexión oficial.',
      noConnectionsHint: 'Registra primero una conexión WhatsApp Oficial.',
      subscribed: 'Suscrita',
      subscribing: 'Suscribiendo...',
      subscribe: 'Suscribir WABA',
      subscribedToast: '¡WABA suscrita en la App de Meta!',
      howItWorks: 'Cómo funciona',
      howItWorksText: 'Esta página genera una <strong>única URL y Verify Token</strong> que reciben eventos de todos tus números oficiales. Cada mensaje se enruta a la conexión correcta por <code>phone_number_id</code>.',
      stepByStep: 'Paso a paso',
      step1: 'Accede a <strong>developers.facebook.com</strong> → tu App → <strong>WhatsApp → Configuración</strong>.',
      step2: 'En <strong>Webhook</strong>, haz clic en <em>Editar</em> y pega la Callback URL y el Verify Token de arriba.',
      step3: 'Haz clic en <strong>Verificar y guardar</strong>.',
      step4: 'En <strong>Webhook fields</strong>, marca <code>messages</code>.',
      step5: 'Vuelve aquí y haz clic en <strong>Suscribir WABA</strong> en cada número.',
      errorTitle: '¿Error al validar URL o token?',
      tip1: 'Confirma que copiaste la <strong>URL completa</strong> sin espacios y el Verify Token idéntico.',
      tip2: 'La URL debe ser <strong>HTTPS pública</strong> y responder en pocos segundos.',
      tip3: 'Si usas Cloudflare/WAF, libera la ruta <code>/v1/webhook/unified/*</code>.',
      tip4: 'Desactiva <em>"Adjuntar un certificado de cliente"</em>, excepto si usas mTLS.',
      tip5: 'Haz clic en el botón de recargar arriba si cambiaste la conexión.',
    },
    campaignExtras: {
      errorPanelOne: '⚠ Corrige el campo de abajo para continuar',
      errorPanelMany: '⚠ Corrige los campos de abajo para continuar',
      rotationConnections: 'Conexiones (en orden de bloque)',
      rotationOrderHelp: 'El orden de selección define qué conexión atiende cada bloque.',
      rotationRequired: 'Selecciona al menos una conexión para la rotación.',
      contactsPerBlock: 'Contactos por bloque',
      skipAlreadySent: 'No reenviar a contactos que ya recibieron en campañas anteriores (misma lista)',
      rotationCount: 'Conexiones en la rotación',
      sequentialBlocks: 'Secuencial entre bloques',
    },
      asaasBoletoNode: {
        title: "Segunda vía boleto (Asaas)",
        description: "Pregunta el CPF/CNPJ, valida, consulta Asaas y envía los boletos automáticamente.",
        configure: "Configurar nodo",
        dialogTitle: "Configurar segunda vía Asaas",
        tabs: { messages: "Mensajes", boletos: "Boletos", advanced: "Avanzado" },
        buttons: { close: "Cerrar", save: "Guardar" },
        statuses: { pending: "Pendiente", overdue: "Vencido", received: "Pagado", confirmed: "Confirmado" },
        summary: {
          template: "Estado: {{statuses}} • Intentos: {{attempts}} • Modo: {{mode}} • {{sort}}",
          modeSingle: "Único", modeSeparate: "Separados", noSort: "Sin orden"
        },
        fields: {
          askMessage: "Mensaje de solicitud",
          askMessageHelper: "Texto enviado al cliente para pedir el CPF/CNPJ",
          invalidMessage: "Mensaje de CPF/CNPJ inválido",
          notFoundMessage: "Mensaje si no encuentra boletos",
          errorMessage: "Mensaje de error en la consulta",
          giveUpMessage: "Mensaje tras agotar intentos",
          finalMessage: "Mensaje final (después de los boletos)",
          finalMessageHelper: "Déjelo vacío para no enviar",
          statusesLabel: "Estados a buscar en Asaas",
          headerMessage: "Encabezado antes de los boletos",
          boletoTemplate: "Formato de cada boleto (plantilla)",
          boletoTemplateHelper: "Variables: {{indice}} {{descricao}} {{valor}} {{vencimento}} {{status}} {{linkBoleto}} {{linhaDigitavel}} {{nossoNumero}} {{pixCopiaCola}}",
          sendMode: "Modo de envío",
          sendModeSingle: "Mensaje único (todos los boletos juntos)",
          sendModeSeparate: "Un mensaje por boleto",
          sortBy: "Ordenar por", sortOrder: "Dirección",
          sortDueDate: "Vencimiento", sortValue: "Valor", sortNone: "Sin orden (orden de Asaas)",
          sortOrderHelper: "Ascendente: el más próximo primero",
          sortAsc: "Ascendente (más antiguo/menor primero)",
          sortDesc: "Descendente (más reciente/mayor primero)",
          sendPixQrCode: "Incluir variable {{pixCopiaCola}} en la plantilla (heredado)",
          pixDivider: "PIX por boleto",
          pixDelivery: "Cómo enviar el PIX",
          pixDeliveryHelper: "Enviado en mensaje separado tras cada boleto",
          pixNone: "No enviar PIX separado",
          pixCopyPaste: "Solo copia y pega (texto)",
          pixQrImage: "Solo imagen del QR Code",
          pixBoth: "Ambos (texto + imagen)",
          pixMessageTemplate: "Mensaje del PIX copia y pega",
          pixMessageTemplateHelper: "Use {{pixCopiaCola}} para el código",
          pixQrCaption: "Leyenda de la imagen del QR Code",
          asaasToken: "Token Asaas (API Key)",
          asaasTokenPlaceholder: "Pegue aquí el access_token de su cuenta Asaas",
          asaasTokenHelper: "Obligatorio. Cada empresa usa su propio token, configurado por nodo.",
          maxAttempts: "Intentos máximos de validación",
          maxAttemptsHelper: "Al agotarse, pasa al siguiente nodo",
          timeoutDivider: "Tiempo de espera de respuesta",
          inputTimeoutSeconds: "Tiempo de espera de respuesta del cliente (segundos)",
          inputTimeoutSecondsHelper: "0 = desactivado. Si se cumple, reenvía la solicitud y cuenta como intento",
          timeoutMessage: "Mensaje al reenviar por timeout",
          countVariable: "Variable de salida (cantidad encontrada)",
          countVariablePlaceholder: "ej: qtdBoletos",
          countVariableHelper: "Opcional. Úselo luego en un nodo Condicional"
        }
      },
    flowBuilderGoogleCalendarModal: {
      addTitle: 'Añadir Agendamiento Google',
      editTitle: 'Editar Agendamiento Google',
      infoAlert: 'Recoge las variables de fecha y hora antes de este nodo (usa el nodo Pregunta). Las variables aceptan el formato 15/06/2026, 15:30, "hoy", "mañana".',
      eventTitle: 'Título del evento',
      eventTitleHelper: 'Usa {{variable}} para insertar datos recopilados',
      description: 'Descripción',
      flowVariables: 'Variables del flujo',
      dateVar: 'Variable de la fecha',
      dateVarHelper: 'Ej.: fecha',
      timeVar: 'Variable de la hora',
      timeVarHelper: 'Ej.: hora',
      professionalVar: 'Variable del profesional (opcional)',
      customerEmailVar: 'Variable del correo del cliente (opcional)',
      event: 'Evento',
      duration: 'Duración (minutos)',
      timezone: 'Zona horaria',
      calendarId: 'Calendar ID (vacío = predeterminado de la empresa)',
      saveResponseVar: 'Nombre de la variable de salida',
      saveResponseVarHelper: 'Genera {nombre}Id y {nombre}Link para los próximos nodos',
      confirmationMessage: 'Mensaje de confirmación al cliente (opcional)',
      confirmationMessageHelper: 'Usa {{googleEventLink}} para el enlace del evento',
      cancel: 'Cancelar',
      save: 'Guardar',
      nodeTitle: 'Google Calendar',
      nodeDateLabel: 'fecha',
      nodeTimeLabel: 'hora',
      nodeDescription: 'Crea un evento en Google Calendar de la empresa.',
    },
    templateMetaModal: {
      title: 'Templates de WhatsApp',
      searchPlaceholder: 'Buscar Templates',
      templateContent: 'Contenido del Template:',
      category: 'Categoría:',
      language: 'Idioma:',
      selectedDetails: 'Detalles del Template Seleccionado',
      name: 'Nombre:',
      content: 'Contenido:',
      fillValue: 'Complete el valor para',
      requiredField: 'Campo obligatorio',
      sendTemplate: 'Enviar Template',
      back: 'Volver',
    },
    messagesAPIPage: {
      sendTextMedia: 'Enviar Texto / Medios',
      yourMessageHere: 'Su mensaje aquí',
      sendImageUrl: 'Enviar Imagen por URL',
      imageCaption: 'Leyenda de la imagen',
      sendNoTicket: 'Envío Rápido (Sin Ticket)',
      messageNoTicket: 'Mensaje sin ticket',
      batchSend: 'Envío por Lote',
      interactiveMessages: 'Mensajes Interactivos',
      chooseOption: 'Elija una opción:',
      optionalFooter: 'Pie de página opcional',
      sales: 'Ventas',
      support: 'Soporte',
      financial: 'Financiero',
      sidebar: {
        playground: 'PLAYGROUND',
        history: 'HISTORIAL',
        intro: 'INTRODUCCIÓN',
        messages: 'API DE MENSAJES',
        contacts: 'CONTACTOS',
        tickets: 'TICKETS / CONVERSACIONES',
        testEndpoint: 'Probar Endpoint',
        searchEndpoint: 'Buscar endpoint...',
        requestCount: 'solicitud(es)',
        clearHistory: 'Limpiar historial',
        noRequests: 'Ninguna solicitud aún',
        remove: 'Eliminar',
        supportsGroups: 'Soporta grupos',
        docSubtitle: 'Documentación completa — {{count}} endpoints',
      },
      introItems: {
        auth: 'Autenticación',
        rateLimit: 'Límite de Velocidad',
        errorCodes: 'Códigos de Error',
      },
      endpoints: {
        checkNumber: 'Verificar Número',
        listConnections: 'Listar Conexiones',
        listContacts: 'Listar Contactos',
        showContact: 'Buscar Contacto',
        createContact: 'Crear Contacto',
        updateContact: 'Actualizar Contacto',
        deleteContact: 'Eliminar Contacto',
        listTickets: 'Listar Tickets',
        showTicket: 'Buscar Ticket',
        createTicket: 'Crear Ticket',
        updateTicket: 'Actualizar Ticket',
        deleteTicket: 'Eliminar Ticket',
        closeAllTickets: 'Cerrar Todos los Tickets',
        messagesRange: 'Mensajes por Período',
      },
      playground: {
        title: 'API Playground',
        desc: 'Pruebe los endpoints de su API directamente aquí. Ingrese la URL base del servidor y su token de autenticación.',
        apiUrl: 'URL de la API',
        token: 'Token',
        copyCurl: 'Copiar cURL',
        selectEndpoint: 'Seleccionar endpoint predefinido',
        group: 'Grupo',
        send: 'Enviar',
        uploadMedia: 'Subir Media',
        formatJson: 'Formatear JSON',
        mediaHint: 'Imagen, video, audio o documento. ¡También funciona para grupos!',
        error: 'Error',
        response: 'Respuesta',
        yourToken: '<su_token>',
      },
      badges: {
        new: 'NUEVO',
        required: 'obligatorio',
        optional: 'opcional',
      },
      docs: {
        authTitle: 'Autenticación',
        authDesc: 'Todos los endpoints requieren autenticación mediante token Bearer. El token debe registrarse en la conexión de WhatsApp a través del menú <b>Conexiones → Editar → Token</b>.',
        rateLimitTitle: 'Límite de Velocidad',
        rateLimitDesc: 'Para evitar bloqueos de WhatsApp, se recomienda un intervalo mínimo de <b>2 segundos</b> entre envíos. En el envío por lote, utilice el parámetro <code>delay</code> para controlar el intervalo.',
        errorCodesTitle: 'Códigos de Error',
        messagesSection: 'API de Mensajes',
        contactsSection: 'Contactos',
        ticketsSection: 'Tickets / Conversaciones',
        parameter: 'Parámetro',
        type: 'Tipo',
        description: 'Descripción',
        code: 'Código',
        meaning: 'Significado',
        success: 'Éxito',
        invalidParams: 'Parámetros inválidos o faltantes',
        invalidToken: 'Token inválido o no proporcionado',
        notFound: 'Recurso no encontrado',
        serverError: 'Error interno del servidor',
        sendTextTitle: 'Enviar Texto / Medios',
        sendTextDesc: 'Envía mensaje de texto o medios (imagen, video, audio, documento) a contactos individuales o <b>grupos</b>. Para enviar a un grupo, configure <code>"isGroup": true</code> y el JID del grupo en el campo <code>number</code>.',
        paramNumber: 'Número del contacto o JID del grupo',
        paramBody: 'Texto del mensaje o leyenda del medio',
        paramIsGroup: 'Si <code>true</code>, envía al grupo usando <code>@g.us</code>',
        paramMedias: 'Archivo de medios (multipart/form-data)',
        paramUserId: 'ID del agente a asignar',
        paramQueueId: 'ID de la cola a dirigir',
        paramSendSignature: 'Incluir nombre del agente en el mensaje',
        paramCloseTicket: 'Cerrar ticket después del envío',
        paramNoRegister: 'Enviar sin registrar ticket',
        sendImageTitle: 'Enviar Imagen por URL',
        sendImageDesc: 'Envía imagen desde URL pública a contacto o <b>grupo</b>.',
        paramUrl: 'URL pública de la imagen',
        paramCaption: 'Leyenda',
        paramIsGroupSend: 'Si <code>true</code>, envía al grupo',
        sendNoTicketTitle: 'Envío Rápido (Sin Ticket)',
        sendNoTicketDesc: 'Envía mensaje de texto sin crear ticket. Funciona para contactos y <b>grupos</b>.',
        bulkTitle: 'Envío por Lote (Bulk)',
        bulkDesc: 'Envía hasta 100 mensajes por lote. Cada mensaje puede tener <code>isGroup: true</code> individualmente.',
        buttonsTitle: 'Mensajes Interactivos',
        buttonsDesc: 'Envía mensajes interactivos con botones, listas, URLs y PIX. Funciona para contactos y <b>grupos</b>.',
        checkNumberTitle: 'Verificar Número',
        checkNumberDesc: 'Verifica si un número tiene WhatsApp activo.',
        listContactsTitle: 'Listar Contactos',
        listContactsDesc: 'Retorna todos los contactos de la empresa. Soporta paginación y búsqueda.',
        paramSearchParam: 'Buscar por nombre, número o email',
        paramPageNumber: 'Número de página (predeterminado: 1)',
        showContactTitle: 'Buscar Contacto por ID',
        showContactDesc: 'Retorna los datos de un contacto específico por ID.',
        createContactTitle: 'Crear Contacto',
        createContactDesc: 'Crea un nuevo contacto en la base de datos.',
        paramName: 'Nombre del contacto',
        paramNumberWhatsApp: 'Número de WhatsApp con código de país+área',
        paramEmail: 'Email del contacto',
        paramExtraInfo: 'Campos personalizados',
        updateContactTitle: 'Actualizar Contacto',
        updateContactDesc: 'Actualiza los datos de un contacto existente.',
        deleteContactTitle: 'Eliminar Contacto',
        deleteContactDesc: 'Elimina permanentemente un contacto. <b>Atención:</b> Esta acción no se puede deshacer.',
        listTicketsTitle: 'Listar Tickets',
        listTicketsDesc: 'Retorna tickets con filtros por estado, cola y agente. Soporta paginación.',
        paramStatus: '<code>open</code>, <code>pending</code>, <code>closed</code>',
        paramQueueIds: 'IDs de colas separados por coma',
        paramSearchTicket: 'Buscar por mensaje, contacto o ticket',
        paramShowAll: '<code>"true"</code> para listar todos los tickets',
        showTicketTitle: 'Buscar Ticket por ID',
        showTicketDesc: 'Retorna los detalles completos de un ticket, incluyendo contacto, cola, agente y mensajes.',
        createTicketTitle: 'Crear Ticket',
        createTicketDesc: 'Crea un nuevo ticket vinculado a un contacto. Útil para iniciar conversaciones programáticamente.',
        paramContactId: 'ID del contacto vinculado',
        paramStatusDefault: '<code>open</code>, <code>pending</code> (predeterminado: open)',
        paramQueueIdTicket: 'ID de la cola',
        paramUserIdTicket: 'ID del agente responsable',
        updateTicketTitle: 'Actualizar Ticket',
        updateTicketDesc: 'Actualiza estado, cola o agente de un ticket. Útil para transferir o cerrar tickets vía API.',
        paramNewQueueId: 'ID de la nueva cola',
        paramNewUserId: 'ID del nuevo agente',
        deleteTicketTitle: 'Eliminar Ticket',
        deleteTicketDesc: 'Elimina permanentemente un ticket y sus mensajes. <b>Atención:</b> Esta acción es irreversible.',
        closeAllTitle: 'Cerrar Todos los Tickets',
        closeAllDesc: 'Cierra todos los tickets abiertos de una vez. Ideal para limpieza por lote.',
        messagesRangeTitle: 'Mensajes por Período',
        messagesRangeDesc: 'Retorna mensajes dentro de un rango de fechas.',
        paramCompanyId: 'ID de la empresa',
        paramStartDate: 'Fecha de inicio (YYYY-MM-DD)',
        paramEndDate: 'Fecha de fin (YYYY-MM-DD)',
        paramNumberOrJid: 'Número o JID del grupo',
      },
    },
    templateManagerPage: {
      title: 'Gestión de Plantillas',
      heroSubtitle: 'Plantillas, salud del número y webhook de Meta en un solo lugar',
      connection: 'Conexión',
      search: 'Buscar...',
      syncTooltip: 'Sincronizar con Meta',
      sync: 'Sync',
      createTemplate: 'Crear Plantilla',
      submitApproval: 'Enviar para Aprobación',
      noOfficialConnection: 'No se encontró conexión de API Oficial. Agregue una conexión oficial para gestionar plantillas.',
      noTemplatesFound: 'No se encontraron plantillas. Haga clic en "Sync" para sincronizar o "Crear Plantilla" para crear una nueva.',
      tableName: 'Nombre',
      tableCategory: 'Categoría',
      tableLanguage: 'Idioma',
      tableStatus: 'Estado',
      tableActions: 'Acciones',
      viewDetails: 'Ver detalles',
      editTemplate: 'Editar (recrear plantilla)',
      deleteTemplate: 'Eliminar plantilla',
      marketing: 'Marketing',
      utility: 'Utilidad',
      authentication: 'Autenticación',
    },
    userPerformance: {
      title: 'Rendimiento de Agentes',
      subtitle: 'Análisis detallado del rendimiento individual de cada agente',
      fetchError: 'Error al cargar datos de rendimiento',
      loading: 'Cargando...',
      noData: 'No se encontraron datos para el período seleccionado',
      summary: {
        totalTickets: 'Total de Tickets',
        activeUsers: 'Agentes Activos',
        avgSupportTime: 'Tiempo Medio de Atención',
        avgWaitTime: 'Tiempo Medio de Espera',
        avgRating: 'Evaluación Media',
      },
      charts: {
        ticketsByUser: 'Tickets por Agente',
        statusDistribution: 'Distribución por Estado',
      },
      table: {
        title: 'Detalle por Agente',
        user: 'Agente',
        totalTickets: 'Total',
        open: 'Abiertos',
        pending: 'Pendientes',
        closed: 'Cerrados',
        avgTime: 'Tiempo Medio',
        avgWait: 'Espera Media',
        minTime: 'Menor Tiempo',
        maxTime: 'Mayor Tiempo',
        rating: 'Evaluación',
        distribution: 'Distribución',
      },
    },
    messagePreview: {
      title: "Vista previa",
      subtitle: "Vea cómo se mostrará su mensaje",
      contact: "Contacto",
      online: "en línea",
      emptyState: "No hay mensajes para previsualizar",
      typePlaceholder: "Escriba un mensaje...",
      availableVars: "Variables disponibles:",
      greetingExample: "Buenos días",
      attachedMedia: "Medio adjunto",
    },
    reportsExtra: {
      statusDistribution: "Distribución por Estado",
      ticketsByQueue: "Tickets por Cola",
      ticketsByUser: "Tickets por Usuario",
      noQueue: "Sin cola",
      noUser: "Sin usuario",
      noDataForChart: "Sin datos para mostrar",
    },
    flowDefaultPage: {
      title: "Flujo predeterminado",
      welcomeFlow: "Flujo de bienvenida",
      welcomeFlowDesc: "Este flujo se dispara solo para nuevos contactos, personas que no están en su lista de contactos y que enviaron un mensaje",
      defaultResponseFlow: "Flujo de respuesta predeterminado",
      defaultResponseFlowDesc: "La Respuesta Predeterminada se envía con cualquier carácter diferente de una palabra clave. ¡ATENCIÓN! Se disparará si el ticket ya está cerrado.",
      defaultResponseFlowDescLong: "La Respuesta Predeterminada se envía con cualquier carácter diferente de una palabra clave. ¡ATENCIÓN! Se disparará si el ticket ya está cerrado y pasadas 6 horas de su cierre.",
      linkedFlow: "Flujo vinculado",
      linkedFlowDesc: "Flujo ejecutado en esta conexión para nuevos contactos y para mensajes fuera de palabras clave. Funciona de forma independiente de cualquier integración externa.",
      disabled: "Deshabilitado",
      chooseFlow: "Elija un flujo",
      disconnect: "Desconectar",
      save: "Guardar",
      deleteConfirm: "¿Está seguro de que desea eliminar este flujo? Todas las integraciones relacionadas se perderán.",
    },
    flowBuilderAIGenerate: {
      button: "Generar con IA",
      title: "Generar Flujo con IA",
      help: "Describe lo que debe hacer el flujo. La IA creará todos los nodos y conexiones automáticamente, listos para vincular a una conexión.",
      category: "Categoría",
      namePlaceholder: "Nombre del flujo (opcional)",
      description: "Descripción del flujo",
      examplesLabel: "Ejemplos rápidos (haz clic para usar)",
      keyNotice: "La IA usa la clave configurada en Configuraciones > IA de la empresa. El flujo generado nace pausado, listo para editar y vincular a conexiones.",
      generate: "Generar Flujo",
      generating: "Generando...",
      cancel: "Cancelar",
      success: "¡Flujo generado con éxito!",
      descriptionTooShort: "Describe el flujo con un poco más de detalle.",
      categories: {
        customerService: "Atención al Cliente",
        sales: "Ventas / Preventa",
        support: "Soporte Técnico",
        leadQualification: "Calificación de Leads",
        scheduling: "Agendamiento",
        nps: "Encuesta de Satisfacción (NPS)",
        welcome: "Bienvenida / Menú Inicial",
        billing: "Cobranza / Financiero",
        other: "Otro"
      },
      examples: {
        example1: "Menú inicial con opciones: Hablar con Ventas, Soporte Técnico, Financiero. Cada opción transfiere a la cola correspondiente.",
        example2: "Calificación de lead: pregunta nombre, empresa y presupuesto, luego transfiere a Ventas.",
        example3: "Encuesta NPS posatención: pide una nota de 0 a 10 y agradece.",
        example4: "Agendamiento: pregunta nombre, fecha preferida y horario, luego transfiere a la cola."
      }
    },
    flowBuilderPageExtra: {
      title: "Flujos de Conversación",
      newFlow: "Nuevo Flujo",
      importZip: "Importar (.zip)",
      noFlowFound: "Ningún flujo encontrado",
      noFlowCreated: "Ningún flujo creado aún",
      tryOtherSearch: "Intente usar otros términos de búsqueda",
      createFirstFlowDesc: "Cree su primer flujo de conversación para automatizar atenciones",
      createFirstFlow: "Crear Primer Flujo",
    },
    floupPage: {
      title: "Follow UP - Plantillas de Flujo",
      filterActive: "Activo",
      filterError: "Con errores",
      filterPaused: "Pausado",
      filterAll: "Todos",
      subtitle: "Gestione sus plantillas de Follow Up",
      newTemplate: "Nueva Plantilla",
      editTemplate: "Editar Plantilla",
      basicInfo: "Información Básica",
      basicInfoDesc: "Configure el nombre y tipo de su Follow Up. El tipo define la plantilla inicial de los mensajes.",
      templateName: "Nombre de la Plantilla",
      templateType: "Tipo de Plantilla",
      description: "Descripción",
      client: "Cliente",
      lead: "Lead",
      customized: "Personalizado",
      triggerCondition: "Condición de Activación",
      triggerConditionDesc: "Defina cuándo este Follow UP debe activarse. Una vez activado, todos los pasos se ejecutarán secuencialmente hasta que se cumplan las condiciones de parada.",
      condition: "Condición",
      systemQueue: "Cola del sistema",
      systemTag: "Etiqueta del sistema",
      firstClientInteraction: "Primera interacción del cliente",
      firstAttendantInteraction: "Primera interacción del agente",
      queue: "Cola",
      selectQueue: "Seleccionar cola",
      tag: "Etiqueta",
      selectTag: "Seleccionar etiqueta",
      conditionDescription: "Descripción de la condición",
      conditionPlaceholder: "Ej: Cliente envió primer mensaje",
      flowSteps: "Pasos del Flujo",
      stepsDesc: "Configure las etapas del flujo de Follow Up. Use las flechas para reordenar.",
      addStep: "Agregar Paso",
      removeStep: "Eliminar Paso",
      step: "Paso",
      emptyMessage: "Mensaje vacío",
      message: "Mensaje",
      variablesHint: "Variables: {{nombre}}, {{protocolo}}, {{cola}}",
      interval: "Intervalo",
      unit: "Unidad",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Días",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Adjunto/Medios",
      pasteUrl: "Pegue la URL...",
      choose: "Elegir",
      uploadError: "Error en la carga.",
      conversationPreview: "Vista Previa de la Conversación",
      addStepsForPreview: "Agregue pasos para ver la vista previa",
      afterLabel: "Después",
      fileLabel: "Archivo",
      flowStopControls: "Controles de Parada del Flujo",
      stopControlsDesc: "Configure cuándo el Follow Up debe detenerse automáticamente.",
      stopAnyMessage: "1. Si el Contacto responde cualquier mensaje",
      stopKeyword: "2. Si el Contacto responde una Palabra clave",
      keyword: "Palabra clave",
      keywordPlaceholder: "Ej: PARAR, CANCELAR, SALIR",
      stopTicketClosed: "3. Si el Ticket es Cerrado",
      noFlowsYet: "Ningún Follow UP creado aún",
      active: "Activo",
      inactive: "Inactivo",
      stepsCount: "etapas",
      queueLabel: "Cola",
      tagLabel: "Etiqueta",
      interactionLabel: "Interacción",
      edit: "Editar",
      duplicate: "Duplicar",
      delete: "Eliminar",
      cancel: "Cancelar",
      previous: "Anterior",
      next: "Siguiente",
      saveTemplate: "Guardar Plantilla",
      confirmDeleteTitle: "Confirmar Eliminación",
      confirmDeleteMessage: "¿Está seguro que desea eliminar el Follow UP",
      confirmDeleteWarning: "Esta acción no se puede deshacer y todos los medios asociados serán eliminados permanentemente.",
    },
    floupSelector: {
      stopSuccess: "Follow UP interrumpido para el contacto con éxito",
      stopError: "Error al interrumpir el Follow UP",
      active: "Activo",
      newTemplate: "Nueva Plantilla",
      editTemplate: "Editar Plantilla",
      basicInfo: "Información Básica",
      templateName: "Nombre de la Plantilla",
      templateType: "Tipo de Plantilla",
      description: "Descripción",
      triggerCondition: "Condición de Activación",
      triggerConditionDesc: "Defina cuándo este Follow UP debe activarse. Una vez activado, todos los pasos se ejecutarán secuencialmente, hasta que se cumplan las condiciones de parada.",
      condition: "Condición",
      systemQueue: "Cola del sistema",
      systemTag: "Tag del sistema",
      firstClientInteraction: "Primera interacción del cliente",
      firstAttendantInteraction: "Primera interacción del agente",
      queue: "Cola",
      selectQueue: "Seleccionar cola",
      tag: "Tag",
      selectTag: "Seleccionar tag",
      conditionDescription: "Descripción de la condición",
      conditionPlaceholder: "Ej: El cliente envió el primer mensaje",
      flowStopControls: "Controles de Parada del Flujo",
      stopAnyMessage: "1. Si el Contacto responde cualquier mensaje",
      stopKeyword: "2. Si el Contacto responde una Palabra clave",
      keyword: "Palabra clave",
      keywordPlaceholder: "Ej: PARAR, CANCELAR, SALIR",
      stopTicketClosed: "3. Si el Ticket es Cerrado",
      flowSteps: "Pasos del Flujo",
      addStep: "Agregar Paso",
      cancel: "Cancelar",
      saveTemplate: "Guardar Plantilla",
      confirmDeleteTitle: "Confirmar Eliminación",
      confirmDeleteMessage: "¿Está seguro de que desea eliminar el Follow UP",
      confirmDeleteWarning: "Esta acción no se puede deshacer y todos los medios asociados se eliminarán permanentemente.",
      delete: "Eliminar",
      duplicate: "Duplicar",
      edit: "Editar",
      steps: "pasos",
      active: "Activo",
      inactive: "Inactivo",
      customized: "Personalizado",
      client: "Cliente",
      lead: "Lead",
      basicInfoDesc: "Configure el nombre y tipo de su Follow Up. El tipo define la plantilla inicial de los mensajes.",
      stepsDesc: "Configure los pasos del flujo de Follow Up. Use las flechas para reordenar.",
      stopControlsDesc: "Configure cuándo el Follow Up debe detenerse automáticamente.",
      subtitle: "Administre sus plantillas de Follow Up",
      noFlowsYet: "Ningún Follow UP creado aún",
      step: "Paso",
      emptyMessage: "Mensaje vacío",
      message: "Mensaje",
      variablesHint: "Variables: {" + "{nombre}}, {" + "{protocolo}}, {" + "{cola}}",
      interval: "Intervalo",
      unit: "Unidad",
      minutesLabel: "Minutos",
      hoursLabel: "Horas",
      daysLabel: "Días",
      weeksLabel: "Semanas",
      monthsLabel: "Meses",
      attachment: "Adjunto/Media",
      pasteUrl: "Pegue la URL...",
      choose: "Elegir",
      uploadError: "Error en la carga.",
      removeStep: "Eliminar Paso",
      conversationPreview: "Vista Previa de la Conversación",
      addStepsForPreview: "Agregue pasos para ver la vista previa",
      afterLabel: "Después de",
      fileLabel: "Archivo",
      previous: "Anterior",
      next: "Siguiente",
      queueLabel: "Cola",
      tagLabel: "Tag",
      interactionLabel: "Interacción",
      stepsCount: "pasos",
    },
    templateManagerPageExtra: {
      createNewTemplate: "Crear Nueva Plantilla",
      templateNameLabel: "Nombre de la Plantilla",
    },
    templateManagerForm: {
      rejected: "fue RECHAZADO por Meta",
      syncComplete: "Sincronización completada",
      statusChanged: "con cambio de estado",
      syncNoChanges: "Plantillas sincronizadas - sin cambios de estado",
      tokenExpired: "⚠️ ¡Token de API Oficial expirado o inválido! Actualice el token de acceso de Meta en la configuración de la conexión.",
      nameBodyRequired: "Nombre y cuerpo del mensaje son obligatorios",
      nameValidation: "El nombre de la plantilla solo debe contener letras minúsculas, números y guiones bajos (_)",
      sentForApproval: "¡Plantilla enviada para aprobación de Meta!",
      deleteSuccess: "¡Plantilla eliminada con éxito!",
      confirmDeleteMessage: "Esta acción eliminará la plantilla en Meta y localmente. ¿Desea continuar?",
      templateDetails: "Detalles de la Plantilla",
      name: "Nombre",
      language: "Idioma",
      status: "Estado",
      category: "Categoría",
      components: "Componentes",
      close: "Cerrar",
      nameHelper: "Solo letras minúsculas, números y _",
      headerOptional: "Encabezado (opcional)",
      headerHelper: "Texto mostrado en la parte superior de la plantilla",
      messageBody: "Cuerpo del Mensaje",
      messageBodyHelper: "Use ｛｛1｝｝, ｛｛2｝｝, etc. para variables. Ej: Hola ｛｛1｝｝, su pedido ｛｛2｝｝ está listo!",
      footerOptional: "Pie de página (opcional)",
      footerHelper: "Texto pequeño al final de la plantilla",
      buttonsOptional: "Botones (opcional - máx 3)",
      quickReply: "Respuesta Rápida",
      phone: "Teléfono",
      text: "Texto",
      preview: "Vista previa",
      button: "Botón",
      cancel: "Cancelar",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "Resolver y Disparar Integración",
        reportFilename: "Reporte_Ticket_",
        elementNotFoundForExport: "Elemento no encontrado para exportación",
      },
    },
    announcementsPopover: {
      title: "Informativos",
      dontShowAgain: "No mostrar de nuevo",
      dismiss: "No mostrar",
      dismissAll: "Descartar todos",
      close: "Cerrar",
      backToList: "Volver a la lista",
      dismissedToast: "Este informativo ya no se mostrará. Reaparecerá solo cuando haya novedades.",
      priority: {
        high: "Alta",
        medium: "Media",
        low: "Baja",
      },
      priorityLabel: "Prioridad",
    },
    ticketsManagerExtra: {
      viewAll: "Todos",
      ascending: "Ascendente",
      descending: "Descendente",
      searchOnMessages: "Marque para buscar también en el contenido de los mensajes (más lento)",
    },
    announcementsPage: {
      noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Redirigiendo.",
      priorityHigh: "Alta",
      priorityMedium: "Media",
      priorityLow: "Baja",
    },
    pairingCodeModalExtra: {
      phoneRequired: "Ingrese el número de teléfono.",
      phoneTooShort: "Número muy corto. Incluya código de país + código de área.",
      phoneTooLong: "Número muy largo.",
      phoneBrazil: "Para números brasileños, use 55 + código de área + número.",
      connectedSuccess: "✅ ¡WhatsApp conectado exitosamente!",
      pairingFailed: "⚠️ El emparejamiento falló. Inténtalo de nuevo.",
      instructionText: "Ingrese el número de WhatsApp con",
      instructionHighlight: "código de país + código de área",
      exampleNumber: "5511999998888",
      digitsHelper: "dígitos — código de país + código de área + número",
      whatsappInstructions: "En tu WhatsApp, ve a:",
      whatsappSteps: "Configuración → Dispositivos vinculados → Vincular un dispositivo",
      tapLink: "Toca en",
      linkWithPhone: "Vincular con número de teléfono",
      enterCodeExact: "e ingresa el código exactamente como se muestra (sin espacios):",
      stepCodeGenerated: "Código generado",
      stepWaitingPairing: "Esperando emparejamiento",
      stepSyncing: "Sincronizando",
      stepConnected: "Conectado",
    },
    newTicketOficialModal: {
      title: "Nueva Conversación - API Oficial",
      selectQueue: "Seleccione una cola",
      selectOfficialConnection: "Seleccione una Conexión Oficial",
      selectQueuePlaceholder: "Seleccione una cola",
      selectConnectionPlaceholder: "Seleccione una Conexión Oficial",
      officialApiLabel: "API Oficial",
      createAndSendTemplate: "Crear y Enviar Plantilla",
      templateSentSuccess: "¡Template enviado con éxito!",
      selectQueueError: "Seleccione una cola",
      selectConnectionError: "Seleccione una conexión oficial",
    },
    officialApiCountdown: {
      noWindow: "Sin ventana",
      noWindowTooltip: "No se ha recibido ningún mensaje del cliente. La ventana de 24h de la API Oficial solo se abre después de que el cliente responda. Envíe una plantilla para iniciar.",
      expired: "Ventana expirada",
      expiredTooltip: "La ventana de 24h de la API Oficial ha expirado. Para enviar nuevos mensajes libres, el cliente debe responder o usted debe enviar una plantilla aprobada.",
      activeTooltip: "Ventana de 24h de la API Oficial. Expira el {{date}}.",
      minutesLeft: "{{m}}m restantes",
      hoursLeft: "{{h}}h {{m}}m restantes",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "Enviar Mensaje Interactivo",
      modelsCount: "Modelos ({{count}})",
      saveCurrentConfig: "Guarda la configuración actual como un modelo reutilizable para el tipo",
      saveButton: "Guardar",
      templateLoaded: "Template \"{{name}}\" cargado",
      buttonsInfo: "ℹ️ Envíe hasta 3 botones clicables. El cliente puede tocar un botón para responder rápidamente.",
      messageText: "Texto del mensaje *",
      footer: "Pie de página (opcional)",
      buttonsMax: "Botones (máx. 3)",
      add: "Agregar",
      optionPlaceholder: "Opción {{n}}",
      listInfo: "ℹ️ Envíe una lista con hasta 10 opciones. El cliente abre un menú para seleccionar.",
      buttonText: "Texto del botón",
      sectionTitle: "Título de la sección",
      titleLabel: "Título",
      descriptionLabel: "Descripción",
      addOption: "Agregar opción",
      offerInfo: "🏷️ Envíe una oferta con título, precio y descripción.",
      offerTitle: "Título de la oferta",
      offerBody: "Descripción / Cuerpo del mensaje *",
      offerPrice: "Precio (ej: $99.90)",
      offerDetails: "Detalles adicionales",
      pixInfo: "💰 Envíe datos PIX formateados al cliente.",
      pixKey: "Clave PIX *",
      pixKeyPlaceholder: "CPF, CNPJ, email, teléfono o clave aleatoria",
      pixBeneficiary: "Nombre del beneficiario",
      pixCity: "Ciudad",
      pixAmount: "Monto ($)",
      pixCopyPasteLabel: "Código PIX copia y pega (botón copiar)",
      pixCopyPasteHelper: "Complete para enviar un botón nativo 'Copiar código PIX' (recomendado).",
      pixButtonTextLabel: "Texto del botón copiar",
      pixQrCodeLabel: "Enviar código QR (imagen) junto con el botón",
      pixDocInfo: "📄 Documento (PDF) como adjunto + botón \"Copiar clave Pix\" en el mismo globo.",
      pixTotalLabel: "Total mostrado (opcional)",
      pixTotalHelper: "Aparece como 'Total' en el cuerpo del mensaje.",
      pixDocUrlLabel: "URL del PDF (boleta/factura)",
      pixDocUrlHelper: "Enlace público del PDF que se adjuntará a la tarjeta PIX.",
      pixDocNameLabel: "Nombre del archivo (opcional)",
      urlInfo: "🔗 Envíe un enlace clicable con texto personalizado.",
      linkText: "Texto del enlace",
      linkPlaceholder: "Haga clic aquí",
      urlLabel: "URL *",
      callInfo: "📞 Envíe un mensaje con número para llamada.",
      callButtonText: "Texto del botón",
      callPlaceholder: "Llamar ahora",
      callPhoneLabel: "Número de teléfono *",
      callContactSelect: "Elegir de la agenda de contactos",
      callContactPlaceholder: "Buscar contacto...",
      callContactNoOptions: "Ningún contacto encontrado",
      callContactLoading: "Buscando...",
      callPhoneHelper: "Seleccione un contacto arriba o escriba manualmente",
      locationInfo: "📍 Envíe una ubicación al cliente.",
      locationMessageText: "Texto del mensaje",
      locationName: "Nombre del lugar",
      locationAddress: "Dirección",
      latitudeLabel: "Latitud *",
      longitudeLabel: "Longitud *",
      carouselInfo: "🎠 Envíe múltiples tarjetas como carrusel.",
      cardLabel: "Tarjeta {{n}}",
      cardTitle: "Título",
      cardDescription: "Descripción",
      cardButtonText: "Texto del botón",
      addCard: "Agregar tarjeta",
      catalogInfo: "🛍️ Envíe productos del catálogo como tarjetas.",
      productLabel: "Producto {{n}}",
      productName: "Nombre del producto",
      productDescription: "Descripción / Precio",
      addProduct: "Agregar producto",
      pollInfo: "📊 Cree una encuesta para que el cliente vote.",
      pollOfficialNote: "(Se enviará como texto formateado en la API Oficial)",
      pollQuestion: "Pregunta de la encuesta *",
      pollOptionsLabel: "Opciones (mín. 2, máx. 12)",
      billingInfo: "🧾 Envíe un cobro con detalles de pago y botón \"Revisar y pagar\".",
      billingNumber: "Nº del cobro",
      billingDescription: "Descripción del cobro *",
      billingQuantity: "Cantidad",
      billingTotalAmount: "Monto total ($) *",
      billingCustomMessage: "Mensaje personalizado",
      billingAttachPdf: "📄 Adjuntar PDF / Factura (opcional)",
      billingSelectPdf: "Seleccionar PDF",
      billingPaymentButton: "Botón de pago",
      billingButtonText: "Texto del botón",
      billingPaymentUrl: "URL de pago (opcional)",
      billingPaymentUrlHelper: "Si se completa, el botón será un enlace clicable (CTA URL)",
      billingNumberPreview: "Nº DEL COBRO",
      billingQuantityPreview: "Cantidad",
      billingTotal: "Total",
      billingDefaultBody: "Cuerpo del mensaje...",
      billingDefaultDescription: "Descripción del cobro...",
      billingDefaultButton: "Revisar y pagar",
    },
    whatsAppModalExtra: {
      saturday: "Sábado",
      sunday: "Domingo",
      saveSchedulesHint: "Haga clic en guardar para registrar los cambios",
    },
    tagsKanbanContainer: {
      label: "Etapa Kanban",
      selectStep: "Seleccione una etapa",
      selectKanbanStep: "Seleccione una Etapa Kanban",
      none: "Ninguna",
      loadingSteps: "Cargando etapas...",
    },
    pendingTicketOverlay: {
      blockedTitle: "Conversación Bloqueada",
      blockedSubtitle: "Este ticket está esperando aceptación. Acepte la conversación para ver y responder los mensajes del cliente.",
      statusWaiting: "Estado: En espera",
      contact: "Contacto",
      ticketId: "Ticket #{{id}}",
      accepting: "Aceptando...",
      acceptConversation: "Aceptar Conversación",
      warningText: "🚫 No puede ver los mensajes antes de aceptar el ticket",
    },
    documentModalExtra: {
      viewDocument: "Ver Documento",
      open: "Abrir",
      download: "Descargar",
      emailOutlook: "Correo Outlook",
      keynotePresentation: "Presentación Keynote",
      numbersSpreadsheet: "Hoja Numbers",
      pagesDocument: "Documento Pages",
      executable: "Ejecutable",
      retFile: "Archivo RET",
      document: "Documento",
    },
    statusFilterExtra: {
      groups: "Grupos",
    },
    callReport: {
      title: "Informe de Llamadas",
      subtitle: "Historial completo de llamadas realizadas y recibidas",
      exportCsv: "Exportar CSV",
      totalCalls: "Total de Llamadas",
      made: "Realizadas",
      answered: "Contestadas",
      received: "Recibidas",
      errorsRejected: "Errores / Rechazadas",
      callsByHour: "Llamadas por Hora",
      callsByDay: "Llamadas por Día",
      callStatus: "Estado de Llamadas",
      average: "Promedio",
      dateStart: "Fecha Inicio",
      dateEnd: "Fecha Fin",
      provider: "Conexión",
      attendant: "Agente",
      status: "Estado",
      all: "Todos",
      dateTime: "Fecha/Hora",
      phone: "Teléfono",
      contact: "Contacto",
      connection: "Conexión",
      duration: "Duración",
      recording: "Grabación",
      downloadRecording: "Descargar grabación",
      noRecords: "No se encontraron registros",
      showing: "Mostrando",
      of: "de",
      completed: "Completada",
      rejected: "Rechazada",
      notAnswered: "No Contestada",
      pending: "Pendiente",
      system: "Sistema",
      sun: "Dom",
      mon: "Lun",
      tue: "Mar",
      wed: "Mié",
      thu: "Jue",
      fri: "Vie",
      sat: "Sáb",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n Esperar",
      query: "n8n Consulta",
      sendMessage: "n8n Mensaje",
      configureUrl: "Configurar URL del Webhook",
      configureQuery: "Configurar Consulta",
      configureWebhook: "Configurar Webhook",
      waitingReturn: "Esperando retorno de n8n",
      receiveAndSend: "Recibir y enviar mensaje",
      sendsTicketData: "Envía datos del ticket",
      sendsContactData: "Envía datos del contacto",
      queryN8n: "Consulta n8n",
      resultIn: "Resultado en",
      sendsResponseToClient: "Envía respuesta al cliente",
      waitsN8nResponse: "Espera respuesta de n8n",
      field: "Campo",
      variable: "Var",
      saveIn: "Guardar en",
      error: "error",
      webhookDesc: "Dispara un webhook de n8n con datos del ticket/contacto. El flujo continúa de inmediato — útil para registrar eventos, integrar CRMs o iniciar automatizaciones.",
      waitDesc: "Envía datos a n8n y pausa el flujo hasta recibir el callback. Ideal para tareas largas (aprobaciones, procesos); la respuesta se guarda en una variable.",
      queryDesc: "Consulta síncrona a n8n para obtener datos (CRM, ERP, hojas). El resultado se guarda en variable y puede usarse en los siguientes nodos o enviarse al cliente.",
      sendMessageDesc: "Envía datos a n8n, espera el texto procesado y lo envía automáticamente al cliente. Útil para respuestas generadas por IA o plantillas en n8n.",
    },
    n8nModal: {
      editWebhook: "Editar n8n Webhook",
      editWait: "Editar n8n Esperar Retorno",
      editQuery: "Editar n8n Consulta",
      editSendMessage: "Editar n8n Enviar Mensaje",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - Esperar Retorno",
      addQuery: "n8n - Consulta",
      addSendMessage: "n8n - Enviar Mensaje",
      nodeType: "Tipo de Nodo n8n",
      webhookOption: "Webhook - Enviar datos",
      waitOption: "Esperar Retorno - Pausar hasta callback",
      queryOption: "Consulta - Buscar y retornar datos",
      sendMessageOption: "Enviar Mensaje - Recibir texto de n8n y enviar",
      webhookInfo: "Envía datos a un webhook de n8n. El flujo continúa inmediatamente después del envío.",
      waitInfo: "Envía datos a n8n y PAUSA el flujo hasta recibir un callback vía POST /n8n-callback con los datos procesados.",
      queryInfo: "Hace una consulta sincrónica a n8n (ej: buscar datos de CRM/ERP) y guarda la respuesta en una variable para uso en el flujo.",
      sendMessageInfo: "Envía datos del ticket/contacto a n8n, espera el texto procesado en la respuesta y lo envía automáticamente como mensaje al cliente.",
      webhookUrlLabel: "URL del Webhook n8n",
      webhookUrlPlaceholder: "https://tu-n8n.com/webhook/...",
      authTokenLabel: "Token de Autenticación (opcional)",
      authTokenPlaceholder: "Token para autenticar en n8n",
      dataToSend: "Datos a enviar",
      ticketData: "Datos del Ticket (ID, cola, estado, etc.)",
      contactData: "Datos del Contacto (nombre, teléfono, email)",
      lastMessage: "Último mensaje recibido",
      customPayload: "Payload personalizado (JSON opcional)",
      waitConfig: "Configuración de Espera",
      timeoutMinutes: "Timeout (minutos)",
      timeoutHelper: "Tiempo máximo de espera. Después de eso, sigue por el handle 'timeout'.",
      saveResponseVar: "Variable para guardar respuesta",
      saveResponseHelper: "La respuesta de n8n se guardará en esta variable. Use {{n8n_resultado}} en los próximos nodos.",
      waitingMessage: "Mensaje mientras espera (opcional)",
      queryConfig: "Configuración de la Consulta",
      queryNameLabel: "Nombre de la Consulta",
      queryPayloadLabel: "Payload de la consulta (JSON)",
      queryPayloadHelper: "Use {{variable}} para insertar variables del flujo",
      queryResultVar: "Variable para guardar resultado",
      queryResultHelper: "El resultado de la consulta se guardará en esta variable",
      sendResultAsMessage: "Enviar resultado como mensaje al cliente",
      messageTemplate: "Template del mensaje",
      messageTemplateHelper: "Use {{variable}} para interpolar el resultado",
      sendConfig: "Configuración de Envío",
      responseFieldLabel: "Campo de la respuesta con el mensaje",
      responseFieldHelper: "El campo del JSON de respuesta de n8n que contiene el texto.",
      timeoutSeconds: "Timeout (segundos)",
      timeoutSecondsHelper: "Tiempo máximo de espera por la respuesta de n8n",
      saveResponseVarOptional: "Variable para guardar respuesta (opcional)",
      saveResponseVarHelper: "Guarda el texto retornado en una variable para uso posterior",
      fallbackMessage: "Mensaje de fallback (si n8n falla)",
      fallbackHelper: "Enviado al cliente si n8n no responde o ocurre un error",
      flowWarning: "Los datos del ticket y contacto se envían a n8n → n8n procesa y retorna el texto → el texto se envía automáticamente al cliente vía WhatsApp.",
      webhookRequired: "URL del Webhook es obligatoria",
      cancel: "Cancelar",
      save: "Guardar",
      add: "Agregar",
    },
    n8nMonitor: {
      title: "Monitoreo n8n",
      total: "Total",
      success: "Éxito",
      errors: "Errores",
      pending: "Pendientes",
      avgDuration: "Tiempo Promedio",
      successRate: "Tasa de Éxito",
      startDate: "Fecha Inicio",
      endDate: "Fecha Fin",
      status: "Estado",
      nodeType: "Tipo de Nodo",
      all: "Todos",
      webhook: "Webhook",
      waitReturn: "Esperar Retorno",
      query: "Consulta",
      sendMessage: "Enviar Mensaje",
      id: "ID",
      dateTime: "Fecha/Hora",
      type: "Tipo",
      ticket: "Ticket",
      contact: "Contacto",
      duration: "Duración",
      details: "Detalles",
      noLogs: "No se encontraron logs",
      executionDetail: "Detalles de la Ejecución",
      nodeTypeLabel: "Tipo del Nodo",
      webhookUrl: "URL del Webhook",
      errorMessage: "Mensaje de Error",
      payloadSent: "Payload Enviado",
      responseReceived: "Respuesta Recibida",
      noData: "Sin datos",
      close: "Cerrar",
      loadError: "Error al cargar logs n8n",
      detailError: "Error al cargar detalles",
      of: "de",
    },
    flowBuilderN8N: {
      integrations: "Integraciones",
      webhookName: "n8n Webhook",
      webhookDesc: "Enviar datos al webhook n8n",
      waitName: "n8n Esperar",
      waitDesc: "Pausar hasta retorno de n8n",
      queryName: "n8n Consulta",
      queryDesc: "Buscar datos vía n8n",
      sendMessageName: "n8n Mensaje",
      sendMessageDesc: "Recibir texto de n8n y enviar",
    },
    n8nMenuLabel: "Monitor n8n",
    hardcoded: {
      flowSavedSuccess: "Flujo guardado con éxito",
      flowSaveError: "Error al guardar el flujo",
      flowDeletedSuccess: "Flujo eliminado con éxito",
      flowDefaultsUpdated: "Flujos predeterminados actualizados",
      mediaError: "Error al procesar el medio",
      noDataFound: "No se encontraron datos",
      selectFollowUp: "Seleccione un Follow Up",
      chooseTemplate: "Elegir plantilla...",
      noPermission: "Esta empresa no tiene permiso para acceder a esta página. Redirigiendo.",
      noPermissionShort: "Esta empresa no tiene permiso para acceder a esta página!",
      loadError: "Error al cargar datos de envío",
      generatingExcel: "Generando informe Excel, espere...",
      loadingData: "Cargando datos... {{count}} registros encontrados",
      noDataToExport: "No se encontraron datos para exportar",
      excelReportHeader: "Informe de Campaña",
      excelCampaignLabel: "Campaña: {{name}}",
      excelGeneratedAt: "Fecha de generación: {{date}}",
      excelColId: "ID",
      excelColRecipient: "Destinatario",
      excelColMessage: "Mensaje",
      excelColSentAt: "Enviado en",
      excelColDeliveredAt: "Entregado en",
      excelColStatus: "Estado",
      excelDelivered: "Entregado",
      excelPending: "Pendiente",
      excelSheetName: "Informe de Campaña",
      excelSuccess: "Informe Excel generado con éxito! {{count}} registros exportados.",
      excelError: "Error al generar informe Excel",
      settingsSaved: "Configuraciones guardadas",
      campaignDeleted: "Campaña eliminada con éxito",
      enterToken: "Informe el token de autenticación",
      requestSuccess: "✅ Solicitud enviada con éxito",
      requestLoaded: "Solicitud cargada — haga clic en Enviar para repetir",
      historyCleared: "Historial limpiado",
      copied: "¡Copiado!",
      invalidJson: "JSON inválido",
      chatCreated: "¡Chat creado con éxito!",
      chatsGenerated: "¡Chats generados con éxito!",
      confirmBackfill: "¿Está seguro de que desea generar chats para todos los usuarios existentes? Esto puede tardar y crear muchos chats.",
      walletNotFound: "Cartera no encontrada",
      maxButtonsReached: "Máximo de 3 botones permitidos",
      queueAcceptance: {
        kept: "Fila conservada",
        inherited: "Fila heredada de la conexión"
      },
      schedulesUpdated: "Horarios actualizados con éxito.",
      pushDeactivateError: "Error al desactivar notificaciones push",
      metaUpdated: "¡{{field}} actualizado!",
      clickSaveToRegister: "Haga clic en guardar para registrar los cambios",
      contactsImported: "¡Contactos de WhatsApp importados con éxito!",
      couldNotLoadRecords: "No se pudo cargar la lista de registros",
      selectPeriod: "Por favor, seleccione el período",
      fillAllFields: "Complete todos los campos con valores numéricos válidos.",
      slaLimitsOrder: "Los límites deben ser crecientes: Verde < Amarillo < Rojo.",
      slaUpdated: "¡Configuraciones de SLA actualizadas con éxito!",
      slaError: "Error al guardar configuraciones de SLA.",
      slaTitle: "Configuraciones de SLA del Kanban",
      slaTimeLimitsAndColors: "Límites de Tiempo y Colores",
      slaDescription: "Defina los límites de tiempo (en minutos) y los colores de cada nivel de alerta del SLA en el Kanban.",
      slaOnTimeLabel: "🟢 A tiempo — hasta (min)",
      slaWarningLabel: "🟡 Atención — hasta (min)",
      slaLateLabel: "🔴 Atrasado — más de (min)",
      slaOnTimeHelper: "Tiempo máximo para el estado verde",
      slaWarningHelper: "Tiempo máximo para el estado amarillo",
      slaLateHelper: "Por encima de este valor muestra pulsación",
      slaOnTimePreview: "A tiempo — hasta {{m}}min",
      slaWarningPreview: "Atención — hasta {{m}}min",
      slaLatePreview: "Atrasado — más de {{m}}min",
      slaSaveBtn: "Guardar Configuraciones de SLA",
      slaSaving: "Guardando...",
      slaClose: "Cerrar",
      slaSelectColor: "Seleccionar color",
      cancelRequested: "Cancelación solicitada. Espere a que finalice el chat actual...",
      parameterizeFilter: "Configure los parámetros del filtro",
      intervalValue: "Valor del Intervalo",
      sendHowManyTimes: "Enviar cuántas veces",
      sendNormallyNonBusiness: "Enviar normalmente en días no laborables",
      sendBusinessDayBefore: "Enviar un día hábil antes",
      sendBusinessDayAfter: "Enviar un día hábil después",
      showUser: "Mostrar Usuario",
      users: "Usuarios",
      createTicket: "Crear Ticket",
      filterByTags: "Filtrar por Tags",
      unknown: "Desconocido",
      accessTicket: "Acceder al Ticket",
      downloadFile: "Descargar archivo",
      clickToDownload: "📎 Clic para descargar",
      select: "Seleccionar",
      options: "Opciones",
      reviewAndPay: "Revisar y pagar",
      followUpInfo: "Información sobre Follow UP",
      salesReport: "Informe de Ventas",
      startDate: "Fecha Inicial",
      endDate: "Fecha Final",
      agent: "Agente",
      all: "Todos",
      generating: "Generando...",
      generateReport: "Generar Informe",
      totalSales: "Total de Ventas",
      totalSalesValue: "Valor Total de Ventas",
      nonSales: "No Ventas",
      avgTicketsPerAgent: "Promedio de Tickets por Agente",
      nonSaleReasons: "Motivos de No Venta",
      closedTickets: "Tickets Finalizados",
      saleValue: "Valor de la Venta",
      nonSaleReason: "Motivo de No Venta",
      closingReason: "Motivo de Finalización",
      closingReasonFilter: "Motivo de Finalización",
      nonSaleReasonFilter: "Motivo de No Venta",
      agentPerformance: "Rendimiento por Agente",
      totalTickets: "Total de Tickets",
      avgTickets: "Promedio de Tickets",
      date: "Fecha",
      allowCrossQueueTicket: "Permitir abrir ticket en cualquier sector/conexión",
      refresh: "Actualizar",
      openNewTab: "Abrir en nueva pestaña",
      whatsappConnection: "Conexión WhatsApp",
      tagUsed: "Tag Utilizada",
      notSpecified: "No especificado",
      downloadSampleSheet: "Descargar Planilla Ejemplo",
      saveFlow: "Guardar Flujo",
      intervals: "Intervalos",
      connected: "Conectado",
      connecting: "Conectando...",
      unknownNumber: "Número desconocido",
      incomingCall: "Llamada entrante",
      readyForCalls: "Listo para llamadas",
      connectingToServer: "Conectando al servidor...",
      minimize: "Minimizar",
      backspace: "Borrar",
      unmute: "Desmutar",
      mute: "Mutar",
      endCall: "Finalizar",
      answerCall: "Contestar",
      rejectCall: "Rechazar",
      makeCall: "Llamar",
      typeNumberToCall: "Escriba un número para llamar",
      calling: "Llamando...",
      inCall: "En llamada",
      numberTooShort: "Número muy corto",
      numberTooLong: "Número muy largo",
      callError: "Error al realizar la llamada",
      recordAudio: "Grabar Audio",
      recording: "Grabando...",
      audioRecorded: "Audio grabado",
      confirmOrDelete: "Haga clic en ✓ para confirmar o 🗑️ para eliminar",
      dashboardSubtitle: "Siga el progreso de sus flujos de follow up",
      totalContacts: "Total Contactos",
      active: "Activos",
      paused: "Pausados",
      withErrors: "Con Errores",
      steps: "Etapas",
      completionRate: "Tasa de Conclusión",
      responseRate: "Tasa de Respuesta",
      contactDistribution: "Distribución de contactos por etapa",
      searchContact: "Buscar contacto...",
      allChannels: "Todos los canales",
      allFilter: "Todos",
      withErrorsFilter: "Con Errores",
      pausedFilter: "Pausados",
      noContact: "Ningún contacto",
      noStepFound: "Ninguna etapa encontrada",
      noHistoryFound: "No se encontró historial",
      lastSendError: "Error en el último envío",
      step: "Etapa",
      resume: "Reanudar",
      pause: "Pausar",
      history: "Historial",
      timelineFollowUp: "Línea de Tiempo de Follow Up",
      created: "Creado",
      sent: "Enviado",
      next: "Próximo",
      inactive: "Inactivo",
      awaitingExecution: "Esperando ejecución",
      awaitingExecutionShort: "Esperando",
      deliveryStatus: "Estado de Entrega",
      delivered: "Entregados",
      waiting: "Esperando",
      failures: "Fallos",
      messagesSent: "Mensajes Enviados",
      uniqueRecipients: "Destinatarios Únicos",
      messagesDelivered: "Mensajes Entregados",
      messageDetails: "Detalles de Mensajes",
      exportExcel: "Exportar Excel",
      rowsPerPage: "Filas por página:",
      chipDelivered: "Entregado",
      chipPending: "Pendiente",
      chipFailed: "Fallo",
      chipUnknown: "Desconocido",
      loading: "Cargando...",
      noMessagesFound: "Ningún mensaje encontrado",
      notScheduled: "No programado",
      notCompleted: "No completado",
      approved: "Aprobado",
      pending: "Pendiente",
      rejected: "Rechazado",
      noContactInList: "Aún no hay contactos en esta lista.",
      importViaExcelOrWhatsapp: "Importe vía Excel o WhatsApp usando los botones de arriba.",
      loadingTags: "Cargando etiquetas...",
      noTagAvailable: "Ninguna etiqueta disponible.",
      selectAllShown: "Seleccionar todos ({{count}} mostrados)",
      noContactFound: "Ningún contacto encontrado.",
      trySearchOther: "Intente buscar por otro nombre o número.",
      clickNewListToStart: "Haga clic en \"Nueva Lista\" para comenzar.",
      filterByTag: "Filtrar por etiqueta:",
      clearTags: "Limpiar ({{count}})",
      addingToList: "Agregando a la lista:",
      addToList: "Agregar {{count}} a la lista",
      listCreatedImport: "¡Lista \"{{name}}\" creada! Ahora importe los contactos (opcional).",
      dragExcelHere: "Arrastre el Excel aquí o haga clic para seleccionar",
      acceptedFormats: "Formatos aceptados: .xls, .xlsx",
      downloadTemplate: "📥 Descargar hoja modelo (.xlsx)",
      skipImport: "Omitir importación",
      nameListHint: "Dé un nombre para identificar esta lista de contactos.",
      characters: "caracteres",
      listNameMinLength: "El nombre debe tener al menos 2 caracteres.",
      listCreatedSuccess: "¡Lista \"{{name}}\" creada con éxito!",
      contactsAddedToList: "¡{{count}} contacto(s) agregado(s) a la lista \"{{name}}\"!",
      listSelectedForCampaign: "¡Lista \"{{name}}\" seleccionada para la campaña!",
      backToCampaign: "Volver a la Campaña →",
      excelModel: "Modelo Excel",
      importExcel: "Importar Excel",
      loadMore: "Cargar más",
      contactLists: "Listas de Contactos",
      contactListsSubtitle: "Cree listas, importe contactos y seleccione la lista a usar en esta campaña.",
      simpleList: "Lista Simple",
      newListExcel: "Nueva Lista + Excel",
      selectedListLabel: "Lista seleccionada: {{name}}",
      selectedListDesc: "{{count}} contactos — esta lista se usará en la campaña",
      remove: "Eliminar",
      deleteListConfirm: "¿Eliminar la lista \"{{name}}\"?",
      addCaption: "Agregue una descripción (opcional)",
      previewNotAvailable: "Vista previa no disponible",
      departments: "Departamentos",
      name: "Nombre",
      noTagFound: "Ninguna etiqueta encontrada. Escriba para crear una nueva.",
      selectWhatsappConnection: "Seleccione la conexión WhatsApp de donde desea importar los contactos:",
      noWhatsappConnectionFound: "No se encontró ninguna conexión WhatsApp conectada.",
      cancel: "Cancelar",
      import: "Importar",
      imageNotAvailable: "Imagen no disponible",
    },
    todoList: {
      title: "Lista de Tareas",
      counter: "{{pending}} pendiente(s) de {{total}} tarea(s)",
      newTask: "Nueva tarea",
      editTask: "Editar tarea",
      add: "Agregar",
      save: "Guardar",
      cancel: "Cancelar",
      priority: "Prioridad",
      category: "Categoría",
      status: "Estado",
      dueDate: "Vencimiento",
      assignTo: "Asignar a",
      nobody: "Nadie",
      notes: "Observaciones",
      notesLabel: "Notas",
      search: "Buscar...",
      allTabs: "Todas",
      pendingTabs: "Pendientes",
      doneTabs: "Completadas",
      allPriorities: "Todas",
      allUsers: "Todos",
      sortBy: "Ordenar",
      sortCreatedAt: "Fecha de creación",
      sortPriority: "Prioridad",
      sortDueDate: "Vencimiento",
      sortManual: "Manual (arrastrar)",
      user: "Usuario",
      priorities: { high: "Alta", medium: "Media", low: "Baja" },
      statuses: { pending: "Pendiente", in_progress: "En Progreso", done: "Completada" },
      categories: { general: "General", work: "Trabajo", personal: "Personal", urgent: "Urgente", study: "Estudio" },
      emptyNoTasks: "No hay tareas creadas aún",
      emptyFiltered: "No se encontraron tareas",
      emptyAddFirst: "¡Agrega tu primera tarea arriba!",
      emptyAdjustFilters: "Intenta ajustar los filtros",
      dueSoonAlert: "tarea(s) vence(n) pronto:",
      overdue: "¡Atrasada!",
      subtasks: "Subtareas",
      newSubtask: "Nueva subtarea...",
      createdBy: "Creada por",
      assignedTo: "Asignada a",
      deleteTitle: "Confirmar eliminación",
      deleteMessage: "¿Desea realmente eliminar esta tarea?",
      deleteConfirm: "Eliminar",
      toasts: {
        loadError: "Error al cargar tareas",
        saveError: "Error al guardar tarea",
        statusError: "Error al actualizar estado",
        deleteError: "Error al eliminar tarea",
        subtaskError: "Error al actualizar subtareas",
      },
    },
    accountSwitch: {
      title: "Sus Cuentas",
      subtitle: "Seleccione una cuenta para cambiar automáticamente",
      addAccount: "Agregar cuenta",
      savePassword: "Guardar Contraseña",
      saveCurrentPassword: "Guardar Contraseña de la Cuenta Actual",
      email: "Correo",
      password: "Contraseña",
      cancel: "Cancelar",
      save: "Guardar",
      admin: "Admin",
      agent: "Agente",
      saved: "Guardada",
      noPassword: "Sin contraseña",
      active: "ACTIVA",
      passwordHelper: "La contraseña se guarda localmente para cambio rápido",
      saveWarning: "Guarde su contraseña para habilitar el cambio rápido",
      toasts: {
        accountAdded: "¡Cuenta validada y agregada!",
        invalidCredentials: "Credenciales inválidas. Verifique correo y contraseña.",
        passwordSaved: "¡Contraseña guardada con éxito!",
        cannotRemoveActive: "No es posible eliminar la cuenta activa.",
        accountRemoved: "Cuenta eliminada.",
        noCredentials: "Credenciales no guardadas. Guarde la contraseña primero.",
        connectedAs: "Conectado como {{name}}",
      },
    },
        backupRestore: {
          backupTitle: "Respaldo de Base de Datos",
          backupDescription: "Descargue una copia completa de la base de datos. Elija el formato deseado:",
          backupSQL: "Respaldo SQL (.sql)",
          backupJSON: "Respaldo JSON (.json)",
          generating: "Generando...",
          tip: "El respaldo SQL es ideal para restauración completa. El respaldo JSON es útil para análisis y migración de datos.",
          restoreTitle: "Restaurar Base de Datos",
          dangerZone: "Zona de peligro",
          dangerDescription: "La restauración sobrescribirá todos los datos actuales de la base de datos. Asegúrese de tener un respaldo actualizado antes de continuar.",
          restoring: "Restaurando...",
          uploadRestore: "Enviar archivo .sql para restaurar",
          confirmRestore: "⚠️ ATENCIÓN: La restauración sobrescribirá los datos actuales de la base de datos. ¿Está seguro de que desea continuar? Recomendamos hacer un respaldo primero.",
          important: "Importante",
          importantText: "Después de restaurar el respaldo, reinicie el servidor para que las conexiones con Redis/Bull sean recreadas correctamente.",
          toasts: {
            sqlSuccess: "¡Respaldo SQL descargado con éxito!",
            sqlError: "Error al generar respaldo SQL.",
            jsonSuccess: "¡Respaldo JSON descargado con éxito!",
            jsonError: "Error al generar respaldo JSON.",
            sqlOnly: "Solo se aceptan archivos .sql para restauración.",
            restoreSuccess: "¡Base de datos restaurada con éxito! Recargue la página.",
            restoreError: "Error al restaurar la base de datos.",
          },
        },
        smtpSettings: {
          title: "Configuraciones SMTP",
          description: "Configure el servidor de correo electrónico para envío de códigos de recuperación de contraseña y notificaciones.",
          server: "Servidor SMTP",
          port: "Puerto",
          secure: "Conexión segura (SSL/TLS en puerto 465)",
          secureHelp: "Active para usar SSL/TLS directo (puerto 465). Desactivado usa STARTTLS (puerto 587).",
          senderEmail: "Correo del Remitente",
          senderName: "Nombre del Remitente",
          senderNameHelp: "Ej.: CRM Moovein. El correo remitente será el campo anterior.",
          authentication: "Autenticación",
          authMethod: "Método de Autenticación",
          password: "Contraseña (Predeterminado)",
          passwordLabel: "Contraseña",
          gmailHelp: "Para Gmail, use una \"Contraseña de aplicación\" generada en myaccount.google.com/apppasswords",
          save: "Guardar",
          testConfig: "Probar Configuración",
          testEmail: "Correo para prueba",
          sendTest: "Enviar Prueba",
          toasts: {
            saveSuccess: "¡Configuraciones SMTP guardadas con éxito!",
            saveError: "Error al guardar configuraciones SMTP.",
            emailRequired: "Informe un correo para prueba.",
            testSuccess: "¡Correo de prueba enviado con éxito!",
            testError: "Error al enviar correo de prueba. Verifique las configuraciones.",
          },


        },
    templateManagerExtraV2: {
      deleteTemplateConfirm: "¿Eliminar plantilla \"{{name}}\"?",
      headerTypeTitle: "Encabezado:",
      headerTypeNone: "Ninguno",
      headerTypeText: "Texto",
      headerTypeImage: "Imagen",
      headerTypeVideo: "Vídeo",
      headerTypeDocument: "Documento",
      mediaUrlImageLabel: "URL pública de la imagen (muestra para aprobación)",
      mediaUrlVideoLabel: "URL pública del vídeo (muestra para aprobación)",
      mediaUrlDocumentLabel: "URL pública del documento (muestra para aprobación)",
      mediaUrlHelper: "Meta requiere una muestra. Pega una URL HTTPS pública o haz clic en 'Subir archivo' para alojarla ahora. Al enviar, puedes cambiar el medio por uno adjunto a la campaña/conversación.",
      uploading: "Subiendo...",
      uploadFile: "Subir archivo",
      uploadSuccess: "Archivo subido y URL completada.",
      uploadNoUrl: "Subida completa, pero no se devolvió la URL.",
      fileNameLabel: "Nombre del archivo (opcional)",
      preview: "Vista previa",
      imageLoadError: "No se pudo cargar la imagen desde esta URL.",
      documentFallback: "documento",
      openDocument: "Abrir documento",
      bodyRequiredTitle: "Cuerpo del mensaje *",
      insertVariable: "+ Insertar variable",
      varExamplesTitle: "Valores de ejemplo (obligatorio para aprobación)",
      varExamplesDesc: "Meta usa estos valores solo para validar la plantilla. No aparecen en el envío real.",
      varExampleLabel: "Ejemplo para {{var}}",
      link: "Enlace",
      previewImage: "Imagen",
      previewVideo: "Vídeo",
      previewDocumentAttached: "Documento adjunto",
      previewDocument: "Documento",
      seeAllOptions: "Ver todas las opciones",
      previewVarsNote: "Los valores de ejemplo se usan solo para esta vista previa.",
    },
    campaignModalExtraV2: {
      sectionHeader: "Encabezado",
      sectionBody: "Cuerpo",
      sectionFooter: "Pie de página",
      sectionButtons: "Botones",
      buttonFallback: "Botón",
      templateMediaAuto: "📎 Medio automático de la plantilla ({{format}}): {{name}}",
      templateMediaSample: "📎 Medio automático de la plantilla ({{format}}): muestra aprobada por Meta",
      templateMediaMissing: "⚠️ La plantilla requiere encabezado {{format}}. Adjunta un archivo abajo o guarda el medio en la plantilla.",
      templateMediaAttached: "adjunto",
      templateVarsTitle: "Variables de la plantilla",
      templateVarsDesc: "Completa los valores que reemplazarán los marcadores {{...}} al enviar.",
      varValuePlaceholder: "Valor para {{key}}",
      varAppearsIn: "Aparece en: {{sections}}",
      varSection: "Sección: {{section}}",
      messagePreviewTitle: "Vista previa del mensaje",
      messagePreviewDesc: "Vista previa con las variables sustituidas. Los marcadores sin completar aparecen como {{...}}.",
      scheduleTimezoneHelper: "Zona horaria: {{tz}} ({{offset}})",
    },
    closeTicketModal: {
      title: "Cerrar ticket",
      subtitle: "¿Estás seguro de que deseas cerrar el ticket?",
      subject: "Asunto del ticket",
      selectPlaceholder: "Seleccione",
      summary: "Resumen de la atención",
      summaryPlaceholder: "Describe el resumen de la atención",
      cancel: "Cancelar",
      confirm: "Cerrar ticket",
      addSubject: "Registrar nuevo asunto",
      newSubjectPlaceholder: "Nombre del nuevo asunto",
      save: "Guardar",
      subjectAdded: "Asunto registrado con éxito",
      requestRating: "Solicitar evaluación",
      ratingOn: "El cliente recibirá la encuesta de evaluación",
      ratingOff: "El ticket se cerrará sin evaluación",
      confirmWithoutRating: "Cerrar sin evaluación",
      sendFarewell: "Enviar mensaje de despedida",
      farewellOn: "El cliente recibirá el mensaje de despedida",
      farewellOff: "El ticket se cerrará sin mensaje de despedida",
    },
    ticketInlineLog: {
      create: "Conversación creada por {{user}}",
      open: "Conversación abierta por {{user}}",
      access: "{{user}} entró en la conversación",
      transfered: "Conversación transferida por {{user}}",
      receivedTransfer: "Conversación recibida por {{user}} en la cola {{queue}}",
      pending: "Conversación movida a pendiente (esperando agente)",
      closed: "Conversación resuelta por {{user}}",
      reopen: "Conversación reabierta por {{user}}",
      queue: "Conversación enviada a la cola {{queue}}",
      redirect: "Conversación redirigida a la cola {{queue}}",
      chatBot: "Atención por el chatbot",
      clientClosed: "Conversación cerrada por el cliente",
    },
    ticketReport: {
      menuItem: "Informe de atención",
      title: "Informe de atención",
      filename: "informe-atencion",
      contact: "Contacto",
      ticketId: "Ticket",
      subject: "Asunto del ticket",
      summary: "Resumen de la atención",
      timing: "Tiempo de atención",
      totalDuration: "Duración total",
      startedAt: "Inicio",
      closedAt: "Cierre",
      connection: "Conexión",
      agents: "Agentes",
      queues: "Colas recorridas",
      timeline: "Historial de la atención",
      notInformed: "No informado",
      exportPDF: "Exportar PDF",
      close: "Cerrar",
      duration: {
        days: "d",
        hours: "h",
        minutes: "min",
        seconds: "s",
      },
    },
    ticketsAdvanced: {
      ticket: "Ticket",
      services: "Atenciones",
    },
    closingReport: {
      title: "Informe de cierre",
      filename: "informe-cierre",
      startDate: "Fecha inicial",
      endDate: "Fecha final",
      subject: "Asunto del cierre",
      allSubjects: "Todos los asuntos",
      filter: "Filtrar",
      exportExcel: "Exportar Excel",
      exportPDF: "Exportar PDF",
      total: "Total",
      clearFilters: "Limpiar filtros",
      summary: {
        total: "Total de tickets",
        closed: "Cerrados",
        pending: "Pendientes",
        open: "Abiertos",
        avgDuration: "Tiempo promedio",
      },
      noData: "No se encontraron tickets para los filtros seleccionados",
      columns: {
        protocol: "Protocolo",
        contact: "Contacto",
        agent: "Agente",
        queue: "Cola",
        status: "Estado",
        subject: "Asunto",
        summary: "Resumen",
        openDate: "Fecha de apertura",
        closeDate: "Fecha de cierre",
        duration: "Duración",
      },
      statusLabels: {
        FECHADO: "Cerrado",
        ABERTO: "Abierto",
        PENDENTE: "Pendiente",
        GRUPO: "Grupo",
        OPEN: "Abierto",
        CLOSED: "Cerrado",
        PENDING: "Pendiente",
      },
    },

  },

};

export { messages };

// Appended by Lovable: WhatsApp Health
if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.whatsappHealth = {
    title: "Salud de Números (API Oficial)",
    updatedAt: "Actualizado a las",
    refresh: "Actualizar",
    empty: "Ningún número WhatsApp Oficial configurado.",
    unknown: "Desconocido",
    verifiedName: "Nombre verificado",
    messagingLimit: "Límite de mensajes (24h)",
    platform: "Plataforma",
    codeVerification: "Verificación del código",
    nameStatus: "Estado del nombre",
    accountReview: "Revisión de la cuenta",
    businessVerification: "Verificación del negocio",
    wabaName: "Nombre de WABA",
    phoneNumberId: "Phone Number ID",
    throughput: "Throughput"
  };
}

// Appended by Lovable: i18n for new screens
if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.webhookUnified = {
      "title": "Webhook Unificado Meta",
      "subtitle": "Un único webhook para todos sus números oficiales",
      "description": "Meta permite solo una URL de webhook por App. Esta herramienta recibe los eventos de todos los números y los enruta internamente por phone_number_id.",
      "openMeta": "Abrir Meta",
      "loadError": "No fue posible cargar la información del webhook. Verifique que la API Oficial esté configurada y que haya al menos una conexión oficial registrada.",
      "oneUrl": "una URL"
  };
  messages["es"].translations.templateManager = {
      "title": "Gestión de Plantillas",
      "health": "Salud",
      "webhookMeta": "Webhook Meta",
      "name": "Nombre",
      "category": "Categoría",
      "marketing": "Marketing",
      "utility": "Utilidad",
      "authentication": "Autenticación"
  };
  Object.assign(messages["es"].translations.whatsappHealth = messages["es"].translations.whatsappHealth || {}, {
      "searchPlaceholder": "Buscar número, WABA, nombre...",
      "downloadPdf": "Descargar PDF",
      "history": "Historial",
      "templates": "Plantillas",
      "templatesTooltip": "Gestionar plantillas de mensajes de Meta",
      "reloadTooltip": "Recargar",
      "historyTooltip": "Reportes diarios generados automáticamente a las 09:00",
      "statConnected": "Números conectados",
      "statHigh": "Calidad alta",
      "statMedium": "Calidad media",
      "statAttention": "Atención / errores",
      "summaryTitle": "Mensajes vía API Oficial",
      "summarySub": "Tiempo real · últimas 24h",
      "sent": "Enviados",
      "delivered": "Entregados",
      "availableMeta": "Disponibles por Meta",
      "of": "de",
      "usage24h": "Uso de la ventana 24h",
      "limit24h": "Límite (24h)",
      "shipments24h": "ENVÍOS · 24H",
      "sentLow": "enviados",
      "deliveredLow": "entregados",
      "available": "Disponible",
      "emptyAll": "Ningún número oficial encontrado.",
      "emptyFiltered": "Sin resultados para la búsqueda.",
      "unlimited": "Ilimitado"
  });
  messages["es"].translations.campaignWizard = {
      "stepsLabel": "ETAPAS",
      "configuration": "Configuración",
      "campaignTab": "Campaña",
      "campaignTabSub": "Mensajes, programación y ticket",
      "contactsTab": "Listas de Contactos",
      "contactsTabSub": "Seleccionar destinatarios",
      "settingsTab": "Configuraciones",
      "settingsTabSub": "Intervalos y anti-ban",
      "preview": "VISTA PREVIA",
      "back": "← Volver",
      "continue": "Continuar →",
      "close": "Cerrar",
      "save": "Guardar",
      "step1": "Identificación",
      "step2": "Distribución",
      "step3": "Programación",
      "step4": "Ticket",
      "step5": "Mensaje",
      "step6": "Contactos",
      "identificationTitle": "IDENTIFICACIÓN DE LA CAMPAÑA",
      "distributionTitle": "DISTRIBUCIÓN DE LOS DISPAROS",
      "scheduleTitle": "PROGRAMACIÓN",
      "ticketTitle": "TICKET",
      "messageTitle": "MENSAJE Y VISTA PREVIA",
      "contactsTitle": "LISTA DE CONTACTOS",
      "splitByConnection": "Dividir disparos en bloques por conexión",
      "connectionsOrder": "Conexiones (en orden de bloque)",
      "connectionsHelp": "El orden de selección define qué conexión atiende cada bloque.",
      "contactsPerBlock": "Contactos por bloque",
      "sequentialBlocks": "Secuencial entre bloques",
      "recurrenceTitle": "Configuración de Recurrencia",
      "enableRecurrence": "Habilitar recurrencia",
      "intervalsTitle": "Intervalos de Disparo",
      "intervalsSubtitle": "Configure los intervalos de tiempo entre los disparos para evitar bloqueos.",
      "randomInterval": "Intervalo de disparo aleatorio",
      "biggerIntervalAfter": "Intervalo mayor después de",
      "biggestInterval": "Intervalo de envío más grande",
      "antiBan": "Anti-Ban",
      "antiBanSub": "Humaniza el disparo para reducir riesgo de bloqueo",
      "variation": "Variación aleatoria (jitter)",
      "extraPauseEvery": "Pausa extra cada N msgs",
      "extraPauseDuration": "Duración de la pausa extra",
      "guardFill": "Complete los campos de {step} para desbloquear las próximas etapas.",
      "previewLabel": "Vista previa",
      "messageOficialNote": "Para API Oficial, utilice la plantilla seleccionada al lado. El campo de mensaje y adjunto de medios no están disponibles.",
      "followUpNote": "Follow-up disponible solo para canales Baileys. En campañas vía API Oficial, solo se envía la plantilla.",
      "campaignMessage": "Mensaje de la Campaña",
      "msgPreviewSection": "MENSAJE Y VISTA PREVIA",
      "subtitle": "Configura tus disparos en masa con inteligencia",
      "previewClient": "Cliente",
      "previewOnline": "en línea",
      "previewToday": "Hoy",
      "previewMsg1Placeholder": "Escribe el mensaje 1 para visualizarlo aquí…",
      "previewTemplatePlaceholder": "Selecciona una plantilla para visualizarla aquí…"
  };
}

if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.login = messages["es"].translations.login || {};
  messages["es"].translations.login.form = Object.assign(messages["es"].translations.login.form || {}, {
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password"
  });
  messages["es"].translations.login.noAccount = "No account?";
  messages["es"].translations.login.secureNote = "Your data is protected with end-to-end encryption.";
  messages["es"].translations.templateManagerPage = messages["es"].translations.templateManagerPage || {};
  messages["es"].translations.templateManagerPage.summary = { total: "Total", approved: "Approved", pending: "Pending", rejected: "Rejected" };
}

// Appended by Lovable
if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  const T = messages["es"].translations;
  T.flowBuilderInstagramTriggerModal = {
    title: "Disparador: Comentario en Instagram",
    account: "Cuenta Instagram",
    selectPost: "Selecciona el post/reel (vacío = cualquiera)",
    searchPlaceholder: "Buscar por leyenda...",
    emptyHint: "Deja vacío para disparar en cualquier post",
    noAccounts: "Ninguna cuenta Instagram conectada",
    loading: "Cargando...",
    noResults: "No se encontraron publicaciones",
    pasteIdManually: "Pegar ID manualmente",
    chooseFromList: "Elegir de la lista",
    mediaId: "ID del medio (post/reel)",
    mediaIdPlaceholder: "Ej.: 17900000000000000",
    keyword: "Palabra clave",
    add: "Añadir",
    matchAny: "Disparar si contiene CUALQUIER palabra",
    matchAll: "Disparar solo si contiene TODAS las palabras",
    hint: "Sin palabras clave = dispara en cualquier comentario.",
    cancel: "Cancelar", save: "Guardar", noCaption: "sin leyenda"
  };
  T.flowBuilderInstagramReplyModal = {
    title: "Responder comentario públicamente",
    hint: "Se elegirá aleatoriamente una de las variaciones para evitar repetición.",
    variation: "Variación", addVariation: "Añadir variación", cancel: "Cancelar", save: "Guardar"
  };
  T.flowBuilderInstagramRewardModal = {
    title: "Enviar recompensa (archivo/PDF)",
    selectFile: "Seleccionar archivo", uploading: "Enviando...", file: "Archivo:",
    caption: "Leyenda (opcional)",
    hint: "El archivo se adjuntará a un DM para el autor del comentario.",
    cancel: "Cancelar", save: "Guardar"
  };
  T.flowBuilderInstagramDmModal = {
    title: "Enviar DM (mensaje privado)", message: "Mensaje",
    hint: "Usa ${nombre} para variables. El DM se envía al autor del comentario.",
    cancel: "Cancelar", save: "Guardar"
  };
  T.facebookPostPreview = { fbPost: "Publicación de Facebook", yourComment: "Tu comentario:", viewPost: "Ver Publicación" };
  T.flowBuilderTestModal = {
    title: "Probar flujo (simulación)",
    hintIntro: "Esta es una simulación visual — nada se envía realmente. Úsala para verificar si el orden de los nodos es correcto.",
    igDetected: "(Flujo de Instagram detectado.)",
    genericDetected: "(Flujo genérico detectado.)",
    commentLabel: "Comentario simulado", messageLabel: "Mensaje simulado",
    defaultComment: "¡Quiero el PDF!", defaultMessage: "Hola",
    commentSimulated: "Simulando comentario recibido: \"{{text}}\"",
    messageSimulated: "Simulando mensaje recibido: \"{{text}}\"",
    simulatedUser: "Usuario simulado:", follows: "Sigue la cuenta", notFollows: "No sigue",
    clickToToggle: "haz clic para alternar",
    clickStart: "Haz clic en Iniciar simulación para ver el paso a paso.",
    simulating: "Simulando...", start: "Iniciar simulación", clear: "Limpiar", close: "Cerrar",
    loopDetected: "Bucle detectado — simulación interrumpida.",
    end: "Fin del flujo. ✅ ({{n}} paso(s) ejecutado(s))",
    maxSteps: "Límite de pasos alcanzado (100) — simulación interrumpida.",
    noNodes: "No se encontró ningún nodo en el flujo.",
    nextNotFound: "Próximo nodo (id={{id}}) no encontrado en el flujo.",
    step: {
      startTitle: "Inicio del flujo", startDetail: "El flujo ha comenzado.",
      igTriggerTitle: "Disparador de Instagram", igTriggerDetail: "Esperando comentario en la publicación",
      keyword: "Palabra clave", anyKeyword: "cualquiera",
      igReplyTitle: "Responder comentario", igReplyDetail: "Respondería públicamente",
      igLikeTitle: "Dar me gusta", igLikeDetail: "El bot daría me gusta al comentario.",
      igFollowerTitle: "Verificar seguidor",
      igFollowerYes: "✓ El usuario SIGUE la cuenta — salida verde.",
      igFollowerNo: "✗ El usuario NO sigue — salida roja.",
      igDmTitle: "Enviar DM", igDmDetail: "DM enviado",
      igRewardTitle: "Entregar recompensa", igRewardDetail: "Enviaría el archivo",
      noText: "sin texto", emptyMsg: "(mensaje vacío)",
      messageTitle: "Mensaje",
      imageTitle: "Imagen", imageEmpty: "(imagen)",
      audioTitle: "Audio", audioEmpty: "(audio)",
      videoTitle: "Video", videoEmpty: "(video)",
      singleBlockTitle: "Bloque único", singleBlockDetail: "Contenido agrupado.",
      menuTitle: "Menú", menuDetail: "Menú con {{n}} opción(es).",
      interactiveTitle: "Menú interactivo", interactiveDetail: "Menú interactivo", buttons: "botones",
      inputTitle: "Entrada", inputDetail: "Esperaría entrada del usuario", variable: "variable",
      intervalTitle: "Intervalo", intervalDetail: "Esperaría {{sec}}s.",
      randomTitle: "Aleatorio", randomDetail: "Elegiría un camino aleatorio.",
      conditionTitle: "Condición", conditionDetail: "Compararía",
      ticketTitle: "Ticket", ticketDetail: "Crearía/actualizaría ticket.",
      tagTitle: "Etiqueta", tagDetail: "Añadiría etiqueta",
      removeTagTitle: "Quitar etiqueta", removeTagDetail: "Quitaría etiqueta",
      switchFlowTitle: "Cambiar flujo", switchFlowDetail: "Iría al flujo",
      attendantTitle: "Agente", attendantDetail: "Transferiría a un agente humano.",
      httpTitle: "Solicitud HTTP", noUrl: "(sin URL)",
      variableTitle: "Variable", variableDetail: "Definiría",
      aiTitle: "Agente IA", aiDetail: "Respondería usando el agente de IA configurado.",
      typebotTitle: "Typebot", typebotDetail: "Integración con Typebot.",
      n8nTitle: "n8n", n8nDetail: "Integración con n8n.",
      asaasTitle: "Boleto Asaas", asaasDetail: "Generaría un boleto vía Asaas.",
      genericTitle: "Nodo", genericDetail: "Ejecutaría este paso."
    }
  };
}

if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.login = messages["es"].translations.login || {};
  messages["es"].translations.login.or = "o";
  messages["es"].translations.login.buttons = messages["es"].translations.login.buttons || {};
  messages["es"].translations.login.buttons.google = "Continuar con Google";
  messages["es"].translations.signup = messages["es"].translations.signup || {};
  messages["es"].translations.signup.buttons = messages["es"].translations.signup.buttons || {};
  messages["es"].translations.signup.buttons.google = "Registrarse con Google";
  messages["es"].translations.settings = messages["es"].translations.settings || {};
  messages["es"].translations.settings.settings = messages["es"].translations.settings.settings || {};
  messages["es"].translations.settings.settings.options = messages["es"].translations.settings.settings.options || {};
  messages["es"].translations.settings.settings.options.googleLogin = "Inicio de sesión con Google";
}

// Appended by Lovable: IVR
if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.ivr = {
    menu: "IVR / Colas",
    title: "Flujos de IVR",
    help: "Cree menús DTMF. Las opciones pueden enrutar a colas, agentes o extensiones. El fallback se activa por timeout o entrada inválida.",
    new: "Nuevo flujo",
    newTitle: "Nuevo flujo de IVR",
    editTitle: "Editar flujo de IVR",
    empty: "Sin flujos",
    disabled: "Deshabilitado",
    save: "Guardar",
    cancel: "Cancelar",
    saved: "Flujo guardado",
    confirmDelete: "¿Eliminar este flujo?",
    errors: { nameRequired: "Nombre requerido", summaryTitle: "Corrija los errores antes de guardar:", digitRequired: "Tecla requerida", digitInvalid: "Solo 0-9, * o #", digitDuplicate: "Tecla duplicada", targetRequired: "Destino requerido", extensionRequired: "Indique extensión/número", submenuRequired: "Seleccione IVR destino", submenuSelf: "El submenú no puede apuntar a sí mismo", submenuMissing: "IVR destino no existe", fallbackRequired: "Defina acción de fallback", followMeNeedsUser: "Sígueme solo con destino Agente", submenuCycle: "El encadenamiento de IVR forma un ciclo", submenuTooDeep: "El encadenamiento supera el límite de 5 niveles" },
    list: { options: "Opciones", status: "Estado" },
    fields: {
      name: "Nombre", did: "DID (número entrante)",
      didHelp: "Opcional. Vacío = flujo por defecto",
      isDefault: "Predeterminado", enabled: "Activo",
      greetingText: "Saludo (TTS)", greetingAudioUrl: "URL del audio de saludo",
      timeout: "Timeout (s)", maxRetries: "Reintentos",
    },
    options: {
      title: "Opciones DTMF", add: "Agregar opción",
      digit: "Tecla", label: "Descripción", action: "Acción", target: "Destino",
      empty: "Sin opciones. Agregue teclas (1, 2, 3...).",
    },
    action: { queue: "Cola", user: "Agente", extension: "Extensión externa", submenu: "Submenú (otro IVR)", voicemail: "Buzón de voz", hangup: "Colgar" },
    target: { queue: "Cola", user: "Agente", extension: "Extensión/Número", submenu: "IVR destino" },
    fallback: { title: "Fallback (timeout / inválido)", useFollowMe: "Usar Sígueme del agente cuando no disponible" }, preview: { title: "Vista previa del flujo", help: "Cómo se comportará el IVR por cada tecla DTMF, incluyendo submenús encadenados." },
  };
}

// Appended by Lovable: Settings nav + dialogs i18n
if (typeof messages !== "undefined" && messages["es"] && messages["es"].translations) {
  messages["es"].translations.settings = messages["es"].translations.settings || {};
  messages["es"].translations.settings.nav = Object.assign(messages["es"].translations.settings.nav || {}, {
    optionsDesc: "Configuraciones generales",
    schedulesDesc: "Horarios de atención",
    finalizacaoDesc: "Finalización de atención",
    companiesDesc: "Gestionar empresas",
    plansDesc: "Planes y precios",
    helpsDesc: "Ayuda y soporte",
    googleCalendarDesc: "Integración de agenda",
  });
  messages["es"].translations.transferTicketModalCustom = Object.assign(messages["es"].translations.transferTicketModalCustom || {}, {
    connection: "Conexión",
  });
  messages["es"].translations.templateMetaModal = Object.assign(messages["es"].translations.templateMetaModal || {}, {
    empty: "Ningún template encontrado",
  });
  messages["es"].translations.whatsappHealth = Object.assign(messages["es"].translations.whatsappHealth || {}, {
    reportsDialog: {
      title: "Reportes diarios (generados a las 09:00)",
      empty: "Aún no se ha generado ningún reporte. Se generará automáticamente mañana a las 09:00.",
      download: "Descargar",
      close: "Cerrar",
    },
  });
  messages["es"].translations.connections = Object.assign(messages["es"].translations.connections || {}, {
    noResults: "No se encontró ninguna conexión.",
    facebook: Object.assign(
      (messages["es"].translations.connections || {}).facebook || {},
      { success: "¡Conexión de Facebook creada con éxito!" }
    ),
    toasts: Object.assign(
      (messages["es"].translations.connections || {}).toasts || {},
      {
        deleted: "¡Conexión eliminada con éxito!",
        webhookCopied: "¡Webhook copiado!",
        webhookNotReady: "El webhook aún no fue generado para esta conexión. Guarde la conexión e inténtelo de nuevo.",
      }
    ),
  });
  messages["es"].translations.officialCall = Object.assign(messages["es"].translations.officialCall || {}, {
    permissionTitle: "Pedir permiso para llamar",
    permissionBody: "Meta solo permite llamadas iniciadas por la empresa después de que el contacto lo autorice — y recibir una llamada suya no cuenta como autorización. Podemos enviar la solicitud ahora: recibirá un mensaje con los botones de permitir o rechazar. Al autorizar, la llamada funciona por un período corto.",
    permissionLater: "Ahora no",
    permissionAsk: "Enviar solicitud",
    toasts: Object.assign(
      (messages["es"].translations.officialCall || {}).toasts || {},
      {
        permissionSent: "Solicitud de permiso enviada. En cuanto el contacto lo autorice, podrá llamar.",
        permissionFailed: "No se pudo enviar la solicitud de permiso.",
      }
    ),
  });
}

// === i18n: telas de Agendamento + Google Agenda ===
//
// As chaves destas duas telas ficam aqui, num merge explícito, e não
// inseridas no meio do objeto acima. Motivo concreto: estes arquivos têm
// indentação irregular, e ao inserir por texto os blocos caíram FORA de
// `translations` no arquivo turco — sem erro nenhum, apenas sem tradução.
// O merge abaixo escreve no lugar certo por referência, não por posição.
//
// O spread preserva o que já existir: se alguma chave for traduzida à mão
// mais acima, ela continua valendo.
const _t = messages.es.translations;
Object.assign(_t, {
  scheduleGoogle: {
    ...(_t.scheduleGoogle || {}),
    ...{
  "title": "Integración Google Calendar & Meet",
  "connectedAs": "Conectado:",
  "connectAccount": "Conectar cuenta",
  "notConnectedHint": "Ninguna cuenta de Google conectada. Conecta una para sincronizar este agendamiento y generar el enlace de Meet.",
  "syncCalendar": "Sincronizar en Google Calendar",
  "generateMeet": "Generar enlace de Google Meet",
  "eventTitle": "Título de la reunión / Asunto",
  "eventTitlePlaceholder": "Ej.: Reunión con el cliente",
  "duration": "Duración",
  "minutes": "minutos",
  "hour": "hora",
  "hours": "horas",
  "copyLink": "Copiar enlace",
  "copied": "¡Copiado!",
  "openMeet": "Abrir Meet"
}
  },
  schedulesHeader: {
    ...(_t.schedulesHeader || {}),
    ...{
  "title": "Programación de mensajes",
  "subtitle": "Programa y visualiza envíos automáticos y recordatorios en un calendario interactivo",
  "programmed": "Envíos programados",
  "schedulesWord": "agendamientos",
  "cardTotal": "Total programados",
  "cardTotalHint": "Envíos registrados en el sistema",
  "cardToday": "Programados para hoy",
  "cardTodayHint": "Envíos previstos para el día",
  "cardWeek": "Próximos 7 días",
  "cardWeekHint": "Previsión de la semana",
  "cardPending": "Pendientes de envío",
  "cardPendingHint": "Esperando el horario de envío",
  "googleCalendar": "Google Calendar",
  "newSchedule": "Nuevo agendamiento"
}
  },
  googleCalendar: {
    ...(_t.googleCalendar || {}),
    ...{
  "title": "Integración Google Calendar & Google Meet",
  "step1": "1. Credenciales de la API de Google (OAuth 2.0)",
  "step1Sub": "Configura tu Client ID y Client Secret generados en Google Cloud Console",
  "clientId": "Google Client ID",
  "clientSecret": "Google Client Secret",
  "redirectUri": "URI de redirección autorizada (pégala en Google Cloud)",
  "jsOrigin": "Origen JavaScript autorizado (pégalo en Google Cloud)",
  "saveCredentials": "Guardar credenciales de la API",
  "credentialsSaved": "Credenciales guardadas.",
  "credentialsFail": "No se pudieron guardar las credenciales.",
  "copied": "¡Copiado!",
  "howToTitle": "Paso a paso: cómo generar el Client ID y el Client Secret en Google Cloud (2 minutos)",
  "how1": "Entra en console.cloud.google.com y crea (o elige) un proyecto.",
  "how2": "En APIs y servicios → Biblioteca, activa la Google Calendar API.",
  "how3": "En Pantalla de consentimiento OAuth, configúrala como Externa y publícala.",
  "how4": "En Credenciales → Crear credenciales → ID de cliente de OAuth, elige Aplicación web.",
  "how5": "Pega los dos valores de arriba en los campos de orígenes y URIs de redirección autorizados.",
  "how6": "Copia el Client ID y el Client Secret generados y pégalos arriba.",
  "step2": "2. Conexión de la cuenta de Google",
  "step2Sub": "Conecta la cuenta que gestionará las reuniones y Meet",
  "connectionStatus": "ESTADO DE LA CONEXIÓN",
  "connectedAccount": "CUENTA CONECTADA",
  "connected": "Conectado",
  "connectedAs": "Conectado",
  "disconnect": "Desconectar",
  "disconnectAccount": "Desconectar cuenta",
  "openCalendar": "Abrir Google Calendar",
  "connect": "Conectar Google Calendar",
  "notConnected": "Ninguna cuenta de Google conectada para esta empresa.",
  "confirmDisconnect": "¿Desconectar la cuenta de Google de esta empresa?",
  "defaultCalendar": "Calendario predeterminado",
  "primary": "primary (predeterminado)",
  "main": "principal",
  "defaultDuration": "Duración predeterminada de las reuniones",
  "timezone": "Zona horaria",
  "timezoneHelp": "Ej.: America/Sao_Paulo",
  "save": "Guardar configuración",
  "saving": "Guardando...",
  "subtitle": "Conecta una cuenta de Google para crear eventos y reuniones desde los agendamientos.",
  "prefsTitle": "Preferencias de Google Meet y agendamientos",
  "prefsSubtitle": "Define cómo se crearán los eventos y reuniones",
  "autoMeet": "Generar Google Meet automáticamente",
  "autoMeetHelp": "Crea un enlace de videollamada exclusivo en cada agendamiento",
  "syncEvents": "Sincronizar eventos en Google Calendar",
  "syncEventsHelp": "Inserta los agendamientos en tu calendario de Google",
  "sendInvite": "Enviar invitación por correo al cliente",
  "sendInviteHelp": "Google enviará una invitación automática si el contacto tiene correo registrado",
  "errors": {
    "credentialsMissing": "Google Calendar aún no está habilitado en esta plataforma. Pide al administrador que registre el Client ID y el Client Secret de Google.",
    "redirectMissing": "No se pudo identificar la dirección del servidor para el retorno de Google. Avisa al administrador."
  },
  "toast": {
    "connected": "¡Google Calendar conectado!",
    "connectFail": "Error al conectar: ",
    "unknownError": "error desconocido",
    "authUrlError": "No se pudo iniciar la conexión con Google.",
    "disconnected": "Cuenta desconectada.",
    "disconnectError": "No se pudo desconectar.",
    "saved": "Configuración guardada.",
    "saveError": "No se pudo guardar."
  }
}
  },
});

// i18n: telas novas (63 chaves)
(() => {
  const target = messages.es.translations;
  const extra = {
    "asaasBoletoNode": {
      "title": "Segunda copia de factura (Asaas)",
      "description": "Pide el CPF/CNPJ, lo valida, consulta Asaas y envía las facturas automáticamente.",
      "configure": "Configurar nodo",
      "dialogTitle": "Configurar segunda copia Asaas",
      "tabs": {
        "messages": "Mensajes",
        "boletos": "Facturas",
        "advanced": "Avanzado"
      },
      "buttons": {
        "close": "Cerrar",
        "save": "Guardar"
      },
      "statuses": {
        "pending": "Pendiente",
        "overdue": "Vencido",
        "received": "Pagado",
        "confirmed": "Confirmado"
      },
      "summary": {
        "template": "Estado: {{statuses}} • Intentos: {{attempts}} • Modo: {{mode}} • {{sort}}",
        "modeSingle": "Única",
        "modeSeparate": "Separadas",
        "noSort": "Sin ordenación"
      },
      "fields": {
        "askMessage": "Mensaje de solicitud",
        "askMessageHelper": "Texto enviado al cliente para pedir el CPF/CNPJ",
        "invalidMessage": "Mensaje de CPF/CNPJ inválido",
        "notFoundMessage": "Mensaje si no encuentra facturas",
        "errorMessage": "Mensaje de error en la consulta",
        "giveUpMessage": "Mensaje tras agotar los intentos",
        "finalMessage": "Mensaje final (después de las facturas)",
        "finalMessageHelper": "Déjalo vacío para no enviar nada",
        "statusesLabel": "Estados a buscar en Asaas",
        "headerMessage": "Encabezado antes de las facturas",
        "boletoTemplate": "Formato de cada factura (plantilla)",
        "boletoTemplateHelper": "Variables: {{indice}} {{descricao}} {{valor}} {{vencimento}} {{status}} {{linkBoleto}} {{linhaDigitavel}} {{nossoNumero}} {{pixCopiaCola}}",
        "sendMode": "Modo de envío",
        "sendModeSingle": "Mensaje único (todas las facturas juntas)",
        "sendModeSeparate": "Un mensaje por factura",
        "sortBy": "Ordenar por",
        "sortOrder": "Dirección",
        "sortDueDate": "Vencimiento",
        "sortValue": "Importe",
        "sortNone": "Sin ordenación (orden de Asaas)",
        "sortOrderHelper": "Ascendente: el más próximo primero",
        "sortAsc": "Ascendente (más antiguo/menor primero)",
        "sortDesc": "Descendente (más reciente/mayor primero)",
        "sendPixQrCode": "Incluir la variable {{pixCopiaCola}} en la plantilla (legado)",
        "pixDivider": "PIX por factura",
        "pixDelivery": "Cómo enviar el PIX",
        "pixDeliveryHelper": "Enviado en un mensaje aparte después de cada factura",
        "pixNone": "No enviar PIX aparte",
        "pixCopyPaste": "Solo copiar y pegar (texto)",
        "pixQrImage": "Solo imagen del código QR",
        "pixBoth": "Ambos (texto + imagen)",
        "pixMessageTemplate": "Mensaje del PIX copiar y pegar",
        "pixMessageTemplateHelper": "Usa {{pixCopiaCola}} para el código",
        "pixQrCaption": "Leyenda de la imagen del código QR",
        "asaasToken": "Token Asaas (API Key)",
        "asaasTokenPlaceholder": "Pega aquí el access_token de tu cuenta Asaas",
        "asaasTokenHelper": "Obligatorio. Cada empresa usa su propio token, configurado por nodo.",
        "maxAttempts": "Intentos máximos de validación",
        "maxAttemptsHelper": "Al agotarse, sigue al siguiente nodo",
        "timeoutDivider": "Tiempo de espera de respuesta",
        "inputTimeoutSeconds": "Tiempo para que el cliente responda (segundos)",
        "inputTimeoutSecondsHelper": "0 = desactivado. Si se agota, reenvía la solicitud y cuenta como intento",
        "timeoutMessage": "Mensaje al reenviar por tiempo agotado",
        "countVariable": "Variable de salida (cantidad encontrada)",
        "countVariablePlaceholder": "ej: qtdBoletos",
        "countVariableHelper": "Opcional. Úsala después en un nodo Condicional"
      }
    }
  };
  const deepFill = (t, s) => {
    for (const k of Object.keys(s)) {
      if (s[k] && typeof s[k] === "object" && !Array.isArray(s[k])) {
        if (!t[k] || typeof t[k] !== "object") t[k] = {};
        deepFill(t[k], s[k]);
      } else if (t[k] === undefined) {
        t[k] = s[k];
      }
    }
  };
  deepFill(target, extra);
})();
